import React, { useState, useEffect, useMemo, useRef } from "react";
import {
  Plus,
  PieChart,
  Banknote,
  CreditCard,
  X,
  Check,
  Calendar as CalendarIcon,
  User,
  Phone,
  Search,
  ChevronLeft,
  ChevronRight,
  List,
  Settings,
  Trash2,
  Edit2,
  Hash,
  Users,
  Palette,
  Upload,
  Image as ImageIcon,
  FileText,
  PenTool,
  Sliders,
  Loader2,
  CloudUpload,
  AlertCircle,
  Instagram,
  MessageCircle,
  FileSignature,
  ArrowRight,
  Eye,
  Printer,
  Mail,
  Tag,
  PenLine,
  Move,
  ChevronDown,
  ChevronUp,
  Info,
  Download,
  ArrowUp,
  ArrowDown,
  Lock,
  Unlock,
  BarChart2,
  Copy,
} from "lucide-react";

import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  onSnapshot,
  setDoc,
  writeBatch,
  getDocs,
  arrayUnion,
  arrayRemove,
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCUhNIkTxar78dRtx9ne2O1lGX18cdHwxA",
  authDomain: "eyebroows-art-app.firebaseapp.com",
  projectId: "eyebroows-art-app",
  storageBucket: "eyebroows-art-app.firebasestorage.app",
  messagingSenderId: "800734229728",
  appId: "1:800734229728:web:1fc65a226e2de936128c85",
  measurementId: "G-6JMWK0YTTN",
};

let db;
try {
  const app = initializeApp(firebaseConfig);
  db = getFirestore(app);
} catch (e) {
  console.error("Firebase 初始化失敗:", e);
}

const COLOR_PALETTE = [
  "bg-[#C5A47E] text-black border-[#C5A47E]",
  "bg-red-400 text-black border-red-400",
  "bg-orange-400 text-black border-orange-400",
  "bg-amber-400 text-black border-amber-400",
  "bg-yellow-400 text-black border-yellow-400",
  "bg-lime-400 text-black border-lime-400",
  "bg-green-400 text-black border-green-400",
  "bg-emerald-400 text-black border-emerald-400",
  "bg-teal-400 text-black border-teal-400",
  "bg-cyan-400 text-black border-cyan-400",
  "bg-sky-400 text-black border-sky-400",
  "bg-blue-400 text-black border-blue-400",
  "bg-indigo-400 text-black border-indigo-400",
  "bg-violet-400 text-black border-violet-400",
  "bg-purple-400 text-black border-purple-400",
  "bg-fuchsia-400 text-black border-fuchsia-400",
  "bg-pink-400 text-black border-pink-400",
  "bg-rose-400 text-black border-rose-400",
  "bg-stone-400 text-black border-stone-400",
  "bg-gray-500 text-white border-gray-500",
];

const CONSENT_TERMS = `
【消費者同意書】

1. 此項服務經本人同意進行設計及操作，過程與專業紋繡師溝通並同意後進行，本人無任何異議。

2. 此項目服務為非永久性上色，留色效果及持久度因人而異（受皮膚類別、膚色、角質層厚度、年齡、新陳代謝等影響）
   - 輕妝漸層霧眉、原生機器線條眉、極致線條加霧眉：可於術後一個月至半年內免費補色或修型一次。
   - 星紗霧眼線、隱形眼線、歐式霧唇：可於術後一個月至三個月內免費補色或修型一次。 (註：油性皮膚、毛孔粗大、經常暴曬或運動流汗者，留色時間可能較短且線條較易暈開，此為皮膚生理現象，敬請理解。)

3. 如逾期半年補色或一年內補色或修型第 2 次，將收取正價五折費用（以上補色費用不另保固）。

4. 本人明白療程會有結痂、脫色等修復期，亦知道有機會出現罕見之副作用（包括結痂或永久性皮膚褪色），以及短期副作用（如皮膚發紅，輕微灼傷，暫時性瘀傷或短暫性皮膚褪色）。

5. 關於對稱性： 本人理解人體面部骨骼、肌肉及表情天生並非絕對對稱，定妝旨在達致視覺平衡及修飾，而非追求機械式完全對稱。

6. 本公司為預約制一人工作室，如紋繡師因病或不可抗力因素無法如期服務，將會盡早通知並安排優先改期，不便之處敬請原諒。

7. 本人同意將有關相片作宣傳用途。

8. 如有任何爭議 EyebrowsArt 保留最終決定權。
`;

const SECRET_PIN = "0617";

const getServiceCategory = (name = "") => {
  if (name.includes("激光")) return "激光";
  if (name.includes("補")) return "補色";
  if (name.includes("眉")) return "眉";
  if (name.includes("眼") || name.includes("瞳")) return "眼";
  if (name.includes("唇")) return "唇";
  return "其他";
};
const CATEGORY_LABELS = ["眉", "眼", "唇", "激光", "補色", "其他"];

const getTodayDate = () => {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Hong_Kong",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date());
};

const getServiceAddMonths = (service) => {
  if (!service) return 6;
  if (service.includes("激光")) return 0;
  if (service.includes("一年")) return 12;
  if (service.includes("眉")) return 6;
  if (service.includes("眼")) return 3;
  if (service.includes("唇")) return 3;
  return 6;
};

const getVoucherExpiryDate = (purchaseDate) => {
  if (!purchaseDate) return null;
  const d = new Date(purchaseDate);
  d.setFullYear(d.getFullYear() + 1);
  return d;
};

const getMonthsElapsed = (fromDateStr, toDateStr) => {
  const from = new Date(fromDateStr);
  const to = new Date(toDateStr || getTodayDate());
  let months =
    (to.getFullYear() - from.getFullYear()) * 12 +
    (to.getMonth() - from.getMonth());
  if (to.getDate() < from.getDate()) months -= 1;
  return Math.max(0, months);
};

const fillTemplate = (template, vars) => {
  return template.replace(/\{(\w+)\}/g, (match, key) =>
    vars[key] !== undefined ? vars[key] : match
  );
};

const DEFAULT_TOUCHUP_TEMPLATE = `Hello {client}\n我係Eyebrows Art嘅Yoky🥰\n\n你上次做完療程之後\n免費補色嘅限期就快到\n到期日為：{deadline}\n\n想約時間嘅話，隨時話我知，我幫你留返個位✨\n記得提早預約，我幫你安排時間💕`;

const DEFAULT_VOUCHER_TEMPLATE = `Hello {client}\n我係Eyebrows Art嘅Yoky🥰\n\n提提你之前買咗嘅補色券快到期喇\n到期日為：{expiryDate}\n\n想約時間嘅話，隨時話我知，我幫你留返個位✨\n記得提早預約，過咗期就用唔到㗎喇。`;

const DEFAULT_RECALL_TEMPLATE = `Hello {client}\n見到你上次嚟補色已經係 {lastServiceDate}（{timeElapsed}前），\n啱啱好想同你講返，依家做緊「舊客戶回訪優惠」🥰\n\n眉部單次補色收費：\n6個月內 ── \${tier6}\n12個月內 ── \${tier12}\n18個月內 ── \${tier18}\n\n你而家嘅情況啱用 💛 \${price}\n\n想約時間嘅話，隨時話我知，我幫你留返個位✨`;

const getRecallPriceInfo = (monthsElapsed, eyebrowOriginalPrice = 2800, pricing = {}) => {
  const p6 = pricing.price6m ?? 980;
  const p12 = pricing.price12m ?? 1580;
  const p18 = pricing.price18m ?? 1880;
  const discount = pricing.discountOver18m ?? 200;
  if (monthsElapsed <= 6) return { price: p6, tier: "6個月內" };
  if (monthsElapsed <= 12) return { price: p12, tier: "12個月內" };
  if (monthsElapsed <= 18) return { price: p18, tier: "18個月內" };
  return { price: eyebrowOriginalPrice - discount, tier: "超過18個月" };
};

const formatElapsedTime = (monthsElapsed) => {
  if (monthsElapsed < 12) return `${monthsElapsed}個月`;
  const years = Math.floor(monthsElapsed / 12);
  const remMonths = monthsElapsed % 12;
  return remMonths > 0 ? `${years}年${remMonths}個月` : `${years}年`;
};

const generateTouchUpReminderMessage = ({ client, deadline, template }) => {
  return fillTemplate(template || DEFAULT_TOUCHUP_TEMPLATE, {
    client,
    deadline,
  });
};

const generateVoucherExpiryMessage = ({ client, expiryDate, template }) => {
  return fillTemplate(template || DEFAULT_VOUCHER_TEMPLATE, {
    client,
    expiryDate,
  });
};

const addMonthsToDateStr = (dateStr, monthsToAdd) => {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  d.setMonth(d.getMonth() + monthsToAdd);
  return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日`;
};

const generateRecallMessage = ({
  client,
  lastServiceDate,
  monthsElapsed,
  price,
  pricing = {},
  template,
}) => {
  const timeElapsed = formatElapsedTime(monthsElapsed);
  const p6 = pricing.price6m ?? 980;
  const p12 = pricing.price12m ?? 1580;
  const p18 = pricing.price18m ?? 1880;
  return fillTemplate(template || DEFAULT_RECALL_TEMPLATE, {
    client,
    lastServiceDate,
    timeElapsed,
    price,
    tier6: p6,
    tier12: p12,
    tier18: p18,
    plus6Months: addMonthsToDateStr(lastServiceDate, 6),
    plus12Months: addMonthsToDateStr(lastServiceDate, 12),
    plus18Months: addMonthsToDateStr(lastServiceDate, 18),
  });
};

const generateCareMessage = ({ client, service, date, isTouchUp }) => {
  let careText = "";
  let addMonths = getServiceAddMonths(service);

  if (service.includes("激光")) {
    careText = `【Eyebrows Art - 激光洗眉術後護理注意事項】\n1. 術後部位可能出現輕微紅腫、結痂或水泡，屬正常反應，請勿用手觸碰或強行撕除。\n2. 術後即可正常濕水洗面及化妝。\n3. 術後一星期內，請避免進行高溫活動，例如：桑拿、蒸氣浴或浸溫泉。\n4. 請避免暴曬，外出時建議做好防曬措施。\n5. 如有結痂，請讓其自然脫落，切勿用手搣甩，以免影響效果或造成色素殘留。\n6. 修復期間請避免使用含酸類或去角質護膚品於眉毛位置。\n7. 修復完成後，部分顏色殘留屬正常，通常需要多次療程才能達到理想效果。\n8. 如需進行下次激光洗眉或半永久定妝療程，兩次療程之間必須相隔至少 30 日。`;
  } else if (service.includes("眉")) {
    careText = `【Eyebrows Art - 眉部半永久定妝修復保養注意事項】\n1. 施術後 2 小時及當晚，即可正常濕水洗面。\n2. 翌日起床後，眉毛顏色會顯得稍微加深，此為正常現象，無需擔心。\n3. 約第 3 至第 4 天，眉毛部位可能會出現類似秋冬乾燥般的輕微脫皮或結痂。\n4. 請讓痂皮自然脫落，*切勿用手強行撕剝或抓撓*，以免影響留色。\n5. 整個修復期預計在隨後 3 至 4 天內完成。\n6. *修復完成前*：請避免任何護膚品 (Skincare) 塗抹於眉毛位置。\n7. *修復完成後*：眉毛顏色會自然減淡約兩成，線條及霧感會變得更加柔和自然。`;
  } else if (service.includes("眼")) {
    careText = `【Eyebrows Art - 眼線半永久定妝修復保養注意事項】\n1. 施術後 2 小時及當晚，即可正常濕水洗面（洗面濕水時，請有意識地緊閉雙眼）。\n2. 日常使用眼霜或進行眼部修護時，請務必避開眼線位置。\n3. 施術後一星期內，請盡量避免化眼妝。\n4. 整個修復期大約需時 7 至 10 天。在此期間，請避免進行高溫活動，例如：桑拿、蒸氣浴 (Steam) 或浸溫泉。\n5. 修復完成後，眼線顏色會自然減淡約兩成，整體效果會變得更加柔和自然。`;
  } else if (service.includes("唇")) {
    careText = `【Eyebrows Art - 歐式霧唇後期保養注意事項】\n堅持 3-5 天，還你性感迷人紅唇！👄\n1. 如有微腫，可適當進行冰敷。\n2. 每次飯後請務必漱口（建議使用漱口水或生理鹽水保持清潔）。\n3. 請薄塗護唇膏（建議一天 4 次：早、午、晚及睡前）。\n4. 易發炎體質者，可考慮按劑量服用口服消炎藥 3-4 天。\n5. 可選擇服用維他命 C，提高免疫力以預防皰疹。\n6. 痂皮完全脫落後，切記不可讓唇部太乾，護唇膏可一天多次塗抹。\n7. 一星期內：*不可塗口紅*；*謝絕煙酒，飲食需清淡*（戒食辛辣刺激食物、海鮮、牛羊肉）；*不可游泳、蒸桑拿和浸溫泉*。\n8. 修復期間內，如唇部顏色出現輕微不均勻屬正常過渡現象。`;
  } else {
    careText = `【Eyebrows Art - 術後保養注意事項】\n請保持部位乾爽清潔，依照指示塗抹修復霜。結痂期間切勿用手抓撓。`;
  }

  let deadlineText = "";
  if (!isTouchUp && addMonths > 0) {
    const recordDate = new Date(date || getTodayDate());
    recordDate.setMonth(recordDate.getMonth() + addMonths);
    const deadlineStr = `${recordDate.getFullYear()}年${
      recordDate.getMonth() + 1
    }月${recordDate.getDate()}日`;
    deadlineText = `\n\n另外提提你，閣下之免費補色限期為：\n*${deadlineStr}*\n\n⚠️ 請注意，如預約超過此免費補色限期半年內，需付半價費用！\n敬請提早預約補色時間。`;
  }

  return `Hello ${client}，多謝你今日嚟 Eyebrows Art！💕\n\n呢度提提你術後照顧嘅注意事項：\n\n${careText}${deadlineText}\n\n如果有任何問題隨時搵我🥰`;
};

const PinLock = ({ icon, title, onUnlock }) => {
  const [pin, setPin] = useState("");
  const [isError, setIsError] = useState(false);

  const handlePress = (num) => {
    if (isError) return;
    if (num === "del") {
      setPin((prev) => prev.slice(0, -1));
      return;
    }
    if (pin.length < 4) {
      const newPin = pin + num;
      setPin(newPin);
      if (newPin.length === 4) {
        if (newPin === SECRET_PIN) {
          onUnlock();
        } else {
          setIsError(true);
          setTimeout(() => {
            setIsError(false);
            setPin("");
          }, 600);
        }
      }
    }
  };

  return (
    <div className="flex-1 flex flex-col items-center justify-center pb-20 overflow-hidden touch-none select-none">
      <div className="mb-8 text-center">
        <div className="w-16 h-16 bg-[#C5A47E]/20 rounded-full flex items-center justify-center mx-auto mb-4 text-[#C5A47E]">
          {icon}
        </div>
        <h3 className="text-xl text-white font-light tracking-widest mb-2">
          {title}
        </h3>
        <p
          className={`text-xs transition-colors duration-300 ${
            isError ? "text-red-400" : "text-neutral-500"
          }`}
        >
          {isError ? "密碼錯誤，請重試" : "請輸入 4 位數密碼"}
        </p>
      </div>
      <div
        className={`flex gap-4 mb-10 transition-transform ${
          isError ? "animate-[shake_0.5s_ease-in-out]" : ""
        }`}
        style={isError ? { animation: "shake 0.5s ease-in-out" } : {}}
      >
        <style>{`@keyframes shake { 0%,100%{transform:translateX(0)} 20%{transform:translateX(-8px)} 40%{transform:translateX(8px)} 60%{transform:translateX(-6px)} 80%{transform:translateX(6px)} }`}</style>
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            className={`w-4 h-4 rounded-full border transition-all duration-300 ${
              isError
                ? "bg-red-500 border-red-500"
                : i < pin.length
                ? "bg-[#C5A47E] border-[#C5A47E]"
                : "border-[#C5A47E] bg-transparent"
            }`}
          />
        ))}
      </div>
      <div className="grid grid-cols-3 gap-4 w-64">
        {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((n) => (
          <button
            key={n}
            onClick={() => handlePress(String(n))}
            className="h-16 rounded-full bg-neutral-800 text-white text-xl font-medium active:bg-[#C5A47E] active:text-black transition-colors"
          >
            {n}
          </button>
        ))}
        <div className="h-16" />
        <button
          onClick={() => handlePress("0")}
          className="h-16 rounded-full bg-neutral-800 text-white text-xl font-medium active:bg-[#C5A47E] active:text-black transition-colors"
        >
          0
        </button>
        <button
          onClick={() => handlePress("del")}
          className="h-16 rounded-full flex items-center justify-center text-neutral-400 active:text-white"
        >
          <ChevronLeft size={24} />
        </button>
      </div>
    </div>
  );
};

const useToast = () => {
  const [toasts, setToasts] = React.useState([]);
  const showToast = (message, type = "info", duration = 3000) => {
    const id = Date.now();
    setToasts((prev) => [...prev, { id, message, type }]);
    setTimeout(
      () => setToasts((prev) => prev.filter((t) => t.id !== id)),
      duration
    );
  };
  const ToastContainer = () => (
    <div className="fixed top-6 left-1/2 -translate-x-1/2 z-[200] flex flex-col gap-2 w-[90vw] max-w-sm pointer-events-none">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={
            "px-4 py-3 rounded-xl text-sm font-medium shadow-lg border flex items-start gap-3 pointer-events-auto " +
            (t.type === "success"
              ? "bg-green-900/90 border-green-700 text-green-100"
              : t.type === "error"
              ? "bg-red-900/90 border-red-700 text-red-100"
              : "bg-neutral-800/95 border-neutral-600 text-white")
          }
        >
          <span className="text-lg leading-none mt-0.5">
            {t.type === "success" ? "✅" : t.type === "error" ? "❌" : "ℹ️"}
          </span>
          <span className="flex-1 whitespace-pre-line">{t.message}</span>
        </div>
      ))}
    </div>
  );
  return { showToast, ToastContainer };
};

const useDialog = () => {
  const [dialog, setDialog] = React.useState(null);
  const showDialog = (options) =>
    new Promise((resolve) => setDialog({ ...options, resolve }));
  const handleConfirm = (value = true) => {
    dialog?.resolve(value);
    setDialog(null);
  };
  const handleCancel = () => {
    dialog?.resolve(false);
    setDialog(null);
  };
  const DialogContainer = () => {
    const [inputVal, setInputVal] = React.useState(dialog?.defaultValue || "");
    if (!dialog) return null;
    const isPrompt = dialog.type === "prompt";
    const isDanger = dialog.type === "danger";
    return (
      <div className="fixed inset-0 z-[150] flex items-center justify-center p-6 bg-black/70 backdrop-blur-sm">
        <div className="w-full max-w-sm bg-neutral-800 rounded-2xl border border-neutral-700 shadow-2xl overflow-hidden">
          <div
            className={
              "px-5 pt-5 pb-3" + (isDanger ? " border-b border-red-900/50" : "")
            }
          >
            {dialog.title && (
              <h3
                className={
                  "text-base font-bold mb-1 " +
                  (isDanger ? "text-red-400" : "text-[#C5A47E]")
                }
              >
                {dialog.title}
              </h3>
            )}
            {dialog.message && (
              <p className="text-sm text-neutral-300 whitespace-pre-line leading-relaxed">
                {dialog.message}
              </p>
            )}
          </div>
          {isPrompt && (
            <div className="px-5 pb-3">
              <input
                type="text"
                value={inputVal}
                onChange={(e) => setInputVal(e.target.value)}
                onKeyDown={(e) =>
                  e.key === "Enter" && handleConfirm(inputVal || true)
                }
                placeholder={dialog.placeholder || ""}
                autoFocus
                className="w-full bg-neutral-900 border border-neutral-600 rounded-xl px-4 py-3 text-white outline-none focus:border-[#C5A47E] text-sm mt-2"
              />
            </div>
          )}
          <div className="flex gap-2 px-5 pb-5 pt-2">
            {dialog.showCancel !== false && (
              <button
                onClick={handleCancel}
                className="flex-1 py-3 rounded-xl bg-neutral-700 text-neutral-300 text-sm font-medium"
              >
                {dialog.cancelLabel || "取消"}
              </button>
            )}
            <button
              onClick={() => handleConfirm(isPrompt ? inputVal || true : true)}
              className={
                "flex-[2] py-3 rounded-xl text-sm font-bold " +
                (isDanger ? "bg-red-700 text-white" : "bg-[#C5A47E] text-black")
              }
            >
              {dialog.confirmLabel || "確認"}
            </button>
          </div>
        </div>
      </div>
    );
  };
  return { showDialog, DialogContainer };
};

const getContactInfo = (item) => {
  if (item.hasWhatsapp && item.whatsappPhone) {
    return { label: "WhatsApp", value: item.whatsappPhone };
  }
  if (item.useSocial && item.socialHandle) {
    return { label: "FB/IG", value: item.socialHandle };
  }
  if (item.phone) {
    return { label: "電話", value: item.phone };
  }
  return null;
};

const TransactionCard = ({ t, colors, onClick, onClientClick }) => (
  <div
    onClick={onClick}
    className={`p-4 rounded-xl ${colors.card} border border-neutral-800 flex flex-col gap-1 relative overflow-hidden group cursor-pointer hover:border-[#C5A47E]/50 transition-colors`}
  >
    <div
      className={`absolute left-0 top-0 bottom-0 w-1 ${
        t.method === "PayMe"
          ? "bg-red-500"
          : t.method === "FPS"
          ? "bg-blue-500"
          : "bg-green-500"
      }`}
    />
    <div className="flex justify-between items-start pl-3">
      <div>
        <div className="flex items-center gap-2">
          <span className={`${colors.white} font-medium text-lg`}>
            {t.client}
          </span>
          {t.customerId && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                onClientClick?.(t.customerId);
              }}
              className="text-[10px] bg-neutral-800 text-neutral-400 px-1.5 py-0.5 rounded border border-neutral-700 hover:text-white hover:border-[#C5A47E] hover:bg-neutral-700 transition-all"
            >
              {t.customerId}
            </button>
          )}
          {t.customerType === "new" && (
            <span className="text-[9px] text-black bg-[#E07A8D] px-1 rounded font-bold">
              新客
            </span>
          )}
        </div>
        <div className="flex items-center gap-2 mt-1.5">
          <span
            className={`text-[10px] px-2 py-0.5 rounded font-medium ${
              t.serviceColor || "bg-neutral-700 text-neutral-300"
            }`}
          >
            {t.service}
          </span>
          <span
            className={`text-[10px] ${colors.pink} px-1.5 py-0.5 bg-neutral-900 rounded`}
          >
            {t.type}
          </span>
        </div>
      </div>
      <div className="text-right">
        <span className={`${colors.gold} text-lg font-light block`}>
          +{parseInt(t.amount).toLocaleString()}
        </span>
        <span className={`text-[10px] ${colors.gray}`}>{t.date}</span>
      </div>
    </div>
    <div className="pl-3 mt-1 flex justify-between items-end">
      <span className={`text-[10px] ${colors.gray}`}>{t.phone}</span>
      <div className="flex items-center gap-2">
        <span
          className={`text-[10px] font-medium px-2 py-0.5 rounded ${
            t.method === "PayMe"
              ? "text-red-400 bg-red-900/20"
              : t.method === "FPS"
              ? "text-blue-400 bg-blue-900/20"
              : "text-green-400 bg-green-900/20"
          }`}
        >
          {t.method}
        </span>
        <Edit2 size={12} className="text-neutral-600" />
      </div>
    </div>
  </div>
);

const NavButton = ({ icon, label, active, onClick, colors }) => (
  <button
    onClick={onClick}
    className={`flex flex-col items-center justify-center w-16 space-y-1 transition-colors ${
      active ? colors.gold : "text-neutral-600"
    }`}
  >
    {icon}
    <span className="text-[10px]">{label}</span>
  </button>
);

const ReminderStatusToggle = ({ type, itemId, status, onToggle }) => {
  const booked = status?.booked || false;
  const contacted = status?.contacted || false;
  return (
    <div className="flex gap-1.5 flex-none">
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          onToggle(type, itemId, "contacted");
        }}
        className={`px-2 py-1 rounded-md text-[10px] font-medium border transition-colors ${
          contacted
            ? "bg-sky-500/20 text-sky-300 border-sky-500/50"
            : "bg-neutral-900 text-neutral-500 border-neutral-700 hover:text-neutral-300"
        }`}
        title="標記為已提醒"
      >
        已提醒
      </button>
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          onToggle(type, itemId, "booked");
        }}
        className={`px-2 py-1 rounded-md text-[10px] font-medium border transition-colors ${
          booked
            ? "bg-green-500/20 text-green-300 border-green-500/50"
            : "bg-neutral-900 text-neutral-500 border-neutral-700 hover:text-neutral-300"
        }`}
        title="標記為已預約"
      >
        已預約
      </button>
    </div>
  );
};

const downloadPhoto = (src, filename) => {
  const link = document.createElement("a");
  link.href = src;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const PhotoUploader = ({ label, photos = [], onChange, colors }) => {
  const [previewIdx, setPreviewIdx] = useState(null);

  const compressImage = (file, maxBytes = 150000) =>
    new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement("canvas");
          const MAX = 640;
          let { width, height } = img;
          if (width > height) {
            if (width > MAX) {
              height = Math.round((height * MAX) / width);
              width = MAX;
            }
          } else {
            if (height > MAX) {
              width = Math.round((width * MAX) / height);
              height = MAX;
            }
          }
          canvas.width = width;
          canvas.height = height;
          canvas.getContext("2d").drawImage(img, 0, 0, width, height);

          let quality = 0.7;
          let dataUrl = canvas.toDataURL("image/jpeg", quality);
          while (dataUrl.length > maxBytes && quality > 0.3) {
            quality -= 0.1;
            dataUrl = canvas.toDataURL("image/jpeg", quality);
          }
          resolve(dataUrl);
        };
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
    });

  const handleFiles = async (e) => {
    const files = Array.from(e.target.files);

    if (navigator.canShare && navigator.canShare({ files })) {
      navigator.share({ files }).catch(() => {});
    }

    const compressed = await Promise.all(files.map((f) => compressImage(f)));
    onChange([...photos, ...compressed]);
    e.target.value = "";
  };

  return (
    <div className="space-y-2">
      <p
        className={`text-xs font-medium uppercase tracking-wider ${
          label === "Before" ? "text-neutral-400" : "text-[#C5A47E]"
        }`}
      >
        {label}
      </p>
      <div className="flex gap-2 flex-wrap">
        {photos.map((src, idx) => (
          <div
            key={idx}
            className="relative w-16 h-16 rounded-lg overflow-hidden border border-neutral-600 group flex-none"
          >
            <img
              src={src}
              alt={`${label}-${idx}`}
              onClick={() => setPreviewIdx(idx)}
              className="w-full h-full object-cover cursor-pointer"
            />
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                onChange(photos.filter((_, i) => i !== idx));
              }}
              className="absolute top-0 right-0 w-6 h-6 bg-black/70 opacity-0 group-hover:opacity-100 flex items-center justify-center transition-opacity rounded-bl-lg"
            >
              <X size={12} className="text-white" />
            </button>
          </div>
        ))}
        <label className="w-16 h-16 rounded-lg border border-dashed border-[#C5A47E]/50 flex flex-col items-center justify-center cursor-pointer hover:border-[#C5A47E] hover:bg-[#C5A47E]/5 transition-colors bg-neutral-900 flex-none gap-1">
          <input
            type="file"
            accept="image/*"
            multiple
            className="hidden"
            onChange={handleFiles}
          />
          <Plus size={18} className="text-[#C5A47E]" />
          <span className="text-[8px] text-neutral-500">上傳</span>
        </label>
      </div>

      {previewIdx !== null && (
        <div
          className="fixed inset-0 z-[120] bg-black/90 flex flex-col items-center justify-center p-4"
          onClick={() => setPreviewIdx(null)}
        >
          <img
            src={photos[previewIdx]}
            alt="preview"
            className="max-h-[75vh] max-w-full object-contain rounded-lg"
            onClick={(e) => e.stopPropagation()}
          />
          <div className="flex gap-4 mt-4" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              onClick={() =>
                downloadPhoto(photos[previewIdx], `${label}-${previewIdx + 1}.jpg`)
              }
              className="px-4 py-2 rounded-full bg-[#C5A47E] text-black text-sm font-medium flex items-center gap-1"
            >
              <Download size={14} /> 下載
            </button>
            <button
              onClick={() => setPreviewIdx(null)}
              className="px-4 py-2 rounded-full bg-neutral-700 text-white text-sm"
            >
              關閉
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

const PhotoViewer = ({ record, onClose }) => {
  const [activeIdx, setActiveIdx] = useState(0);
  const [activeType, setActiveType] = useState(
    record.beforePhotos?.length > 0 ? "before" : "after"
  );
  const photos =
    activeType === "before"
      ? record.beforePhotos || []
      : record.afterPhotos || [];

  return (
    <div className="fixed inset-0 z-[100] bg-black flex flex-col animate-fade-in">
      <div className="flex-none flex justify-between items-center px-4 pt-12 pb-3 bg-black/80">
        <button
          onClick={onClose}
          className="p-2 text-neutral-400 hover:text-white"
        >
          <X size={24} />
        </button>
        <div className="flex bg-neutral-900 rounded-full p-1 border border-neutral-700">
          {record.beforePhotos?.length > 0 && (
            <button
              onClick={() => {
                setActiveType("before");
                setActiveIdx(0);
              }}
              className={`px-4 py-1.5 rounded-full text-sm font-medium transition-all ${
                activeType === "before"
                  ? "bg-neutral-600 text-white"
                  : "text-neutral-500"
              }`}
            >
              Before ({record.beforePhotos.length})
            </button>
          )}
          {record.afterPhotos?.length > 0 && (
            <button
              onClick={() => {
                setActiveType("after");
                setActiveIdx(0);
              }}
              className={`px-4 py-1.5 rounded-full text-sm font-medium transition-all ${
                activeType === "after"
                  ? "bg-[#C5A47E] text-black"
                  : "text-neutral-500"
              }`}
            >
              After ({record.afterPhotos.length})
            </button>
          )}
        </div>
        {photos.length > 0 ? (
          <button
            type="button"
            onClick={() =>
              downloadPhoto(
                photos[activeIdx],
                `${record.client || "photo"}-${activeType}-${activeIdx + 1}.jpg`
              )
            }
            className="p-2 text-neutral-400 hover:text-white"
          >
            <Download size={22} />
          </button>
        ) : (
          <div className="w-10" />
        )}
      </div>
      <div className="flex-1 flex items-center justify-center relative overflow-hidden bg-neutral-950 px-4">
        {photos.length > 0 ? (
          <img
            src={photos[activeIdx]}
            alt={`${activeType}-${activeIdx}`}
            className="max-h-full max-w-full object-contain rounded-lg"
          />
        ) : (
          <p className="text-neutral-600">未有相片</p>
        )}
        {photos.length > 1 && (
          <>
            <button
              onClick={() => setActiveIdx((i) => Math.max(0, i - 1))}
              disabled={activeIdx === 0}
              className="absolute left-2 top-1/2 -translate-y-1/2 p-3 bg-black/50 rounded-full text-white disabled:opacity-20"
            >
              <ChevronLeft size={20} />
            </button>
            <button
              onClick={() =>
                setActiveIdx((i) => Math.min(photos.length - 1, i + 1))
              }
              disabled={activeIdx === photos.length - 1}
              className="absolute right-2 top-1/2 -translate-y-1/2 p-3 bg-black/50 rounded-full text-white disabled:opacity-20"
            >
              <ChevronRight size={20} />
            </button>
          </>
        )}
      </div>
      {photos.length > 1 && (
        <div className="flex-none flex gap-2 justify-center py-4 px-4 overflow-x-auto">
          {photos.map((src, idx) => (
            <button
              key={idx}
              onClick={() => setActiveIdx(idx)}
              className={`flex-none w-12 h-12 rounded-lg overflow-hidden border-2 transition-all ${
                idx === activeIdx
                  ? "border-[#C5A47E] scale-110"
                  : "border-transparent opacity-50"
              }`}
            >
              <img
                src={src}
                alt={`thumb-${idx}`}
                className="w-full h-full object-cover"
              />
            </button>
          ))}
        </div>
      )}
      <div className="flex-none pb-8 text-center">
        <p className="text-xs text-neutral-600">
          {record.service} · {record.date}
        </p>
      </div>
    </div>
  );
};

const EyebrowsArtApp = () => {
  const { showToast, ToastContainer } = useToast();
  const { showDialog, DialogContainer } = useDialog();

  useEffect(() => {
    if (!document.getElementById("tailwind-script")) {
      const script = document.createElement("script");
      script.src = "https://cdn.tailwindcss.com";
      script.id = "tailwind-script";
      document.head.appendChild(script);
    }
    if (!document.getElementById("html2canvas-script")) {
      const script = document.createElement("script");
      script.src =
        "https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js";
      script.id = "html2canvas-script";
      document.body.appendChild(script);
    }
  }, []);

  const [activeTab, setActiveTab] = useState("clients");
  const [showModal, setShowModal] = useState(false);
  const [showRecordModal, setShowRecordModal] = useState(false);
  const [showClientModal, setShowClientModal] = useState(false);
  const [showClientEditModal, setShowClientEditModal] = useState(false);
  const [showConsentModal, setShowConsentModal] = useState(false);
  const [photoViewerRecord, setPhotoViewerRecord] = useState(null);

  const [transServiceCat, setTransServiceCat] = useState("");
  const [recordServiceCat, setRecordServiceCat] = useState("");
  const [isEditingServiceOrder, setIsEditingServiceOrder] = useState(false);
  const serviceDragItem = useRef();
  const serviceDragOverItem = useRef();

  const [isFinanceUnlocked, setIsFinanceUnlocked] = useState(false);

  useEffect(() => {
    const FINANCE_TABS = ["home", "calendar", "stats"];
    if (!FINANCE_TABS.includes(activeTab)) {
      setIsFinanceUnlocked(false);
    }
  }, [activeTab]);

  const [isGuestMode, setIsGuestMode] = useState(false);
  const [showGuestLockScreen, setShowGuestLockScreen] = useState(false);
  const [showGuestPinPad, setShowGuestPinPad] = useState(false);
  const [guestPin, setGuestPin] = useState("");

  const handleGuestPinPress = (num) => {
    if (num === "del") {
      setGuestPin((prev) => prev.slice(0, -1));
      return;
    }
    if (guestPin.length < 4) {
      const newPin = guestPin + num;
      setGuestPin(newPin);
      if (newPin.length === 4) {
        if (newPin === SECRET_PIN) {
          setShowGuestLockScreen(false);
          setShowGuestPinPad(false);
          setGuestPin("");
        } else {
          setTimeout(() => {
            showToast("密碼錯誤，請重試", "error");
            setGuestPin("");
          }, 100);
        }
      }
    }
  };

  const [showClientDetails, setShowClientDetails] = useState(false);
  const [consentStep, setConsentStep] = useState(1);
  const [viewConsentData, setViewConsentData] = useState(null);
  const consentFormRef = useRef(null);

  const [searchQuery, setSearchQuery] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [sortOption, setSortOption] = useState("latest");

  const [calendarDate, setCalendarDate] = useState(new Date());
  const [dashboardDate, setDashboardDate] = useState(new Date());
  const [selectedCalendarDate, setSelectedCalendarDate] = useState(null);
  const [calendarMode, setCalendarMode] = useState("records");
  const [selectedClient, setSelectedClient] = useState(null);

  const [logoImage, setLogoImage] = useState(null);
  const [defaultDeposit, setDefaultDeposit] = useState(500);
  const [recallPricing, setRecallPricing] = useState({
    price6m: 980,
    price12m: 1580,
    price18m: 1880,
    discountOver18m: 200,
  });
  const [reminderTemplates, setReminderTemplates] = useState({
    touchUp: "",
    voucher: "",
    recall: "",
  });
  const [colorPresets, setColorPresets] = useState([
    "淺啡",
    "深啡",
    "灰啡",
    "黑灰",
  ]);
  const [toolPresets, setToolPresets] = useState(["WWS", "DWS", "S3", "RL1"]);
  const [isEditingColor, setIsEditingColor] = useState(false);
  const [isEditingTool, setIsEditingTool] = useState(false);

  const dragItem = useRef();
  const dragOverItem = useRef();
  const [selectedDragItem, setSelectedDragItem] = useState(null);

  const defaultServices = [
    {
      id: 1,
      name: "霧眉",
      price: 2800,
      color: "bg-[#C5A47E] text-black border-[#C5A47E]",
    },
    {
      id: 2,
      name: "原生機器線條眉",
      price: 3800,
      color: "bg-[#C5A47E] text-black border-[#C5A47E]",
    },
    {
      id: 3,
      name: "絲霧眉",
      price: 3200,
      color: "bg-[#C5A47E] text-black border-[#C5A47E]",
    },
    {
      id: 4,
      name: "美瞳線",
      price: 1800,
      color: "bg-[#C5A47E] text-black border-[#C5A47E]",
    },
    {
      id: 5,
      name: "水晶唇",
      price: 4500,
      color: "bg-[#C5A47E] text-black border-[#C5A47E]",
    },
    {
      id: 6,
      name: "補色",
      price: 1000,
      color: "bg-[#C5A47E] text-black border-[#C5A47E]",
    },
  ];

  const [services, setServices] = useState(defaultServices);
  const [transactions, setTransactions] = useState([]);
  const [treatmentRecords, setTreatmentRecords] = useState([]);
  const [clientProfiles, setClientProfiles] = useState({});
  const [reminderStatus, setReminderStatus] = useState({});

  useEffect(() => {
    if (!db) return;
    const unsubTrans = onSnapshot(collection(db, "transactions"), (s) =>
      setTransactions(s.docs.map((d) => ({ ...d.data(), id: d.id })))
    );
    const unsubRecords = onSnapshot(collection(db, "treatmentRecords"), (s) =>
      setTreatmentRecords(s.docs.map((d) => ({ ...d.data(), id: d.id })))
    );
    const unsubServices = onSnapshot(collection(db, "services"), (s) => {
      const data = s.docs.map((d) => ({ ...d.data(), id: d.id }));
      if (data.length > 0) {
        setServices(data.sort((a, b) => (a.order ?? 999) - (b.order ?? 999)));
      }
    });
    const unsubSettings = onSnapshot(doc(db, "system", "settings"), (snap) => {
      if (snap.exists()) {
        const data = snap.data();
        if (data.defaultDeposit) setDefaultDeposit(data.defaultDeposit);
        if (data.recallPricing)
          setRecallPricing((prev) => ({ ...prev, ...data.recallPricing }));
        if (data.reminderTemplates)
          setReminderTemplates((prev) => ({
            ...prev,
            ...data.reminderTemplates,
          }));
        if (data.colorPresets) setColorPresets(data.colorPresets);
        if (data.toolPresets) setToolPresets(data.toolPresets);
        if (data.logoImage !== undefined) setLogoImage(data.logoImage || null);
      }
    });
    const unsubProfiles = onSnapshot(collection(db, "clientProfiles"), (s) => {
      const profiles = {};
      s.docs.forEach((d) => {
        profiles[d.id] = d.data();
      });
      setClientProfiles(profiles);
    });
    const unsubReminderStatus = onSnapshot(
      collection(db, "reminderStatus"),
      (s) => {
        const statusMap = {};
        s.docs.forEach((d) => {
          statusMap[d.id] = d.data();
        });
        setReminderStatus(statusMap);
      }
    );
    return () => {
      unsubTrans();
      unsubRecords();
      unsubServices();
      unsubSettings();
      unsubProfiles();
      unsubReminderStatus();
    };
  }, []);

  const toggleReminderStatus = async (type, itemId, field) => {
    if (!itemId || !db) return;
    const key = `${type}-${itemId}`;
    const current = reminderStatus[key] || {};
    const updated = { ...current, [field]: !current[field] };
    setReminderStatus((prev) => ({ ...prev, [key]: updated }));
    await setDoc(doc(db, "reminderStatus", key), updated, { merge: true });
  };

  const [reportYear, setReportYear] = useState(new Date().getFullYear());
  const [reportMonth, setReportMonth] = useState("all");

  const reportData = useMemo(() => {
    const filtered = transactions.filter((t) => {
      if (!t.date) return false;
      const d = new Date(t.date);
      const matchYear = d.getFullYear() === reportYear;
      const matchMonth =
        reportMonth === "all" || d.getMonth() + 1 === parseInt(reportMonth);
      return matchYear && matchMonth;
    });

    let totalRev = 0;
    const svcStats = {};

    filtered.forEach((t) => {
      const amt = parseInt(t.amount || 0);
      totalRev += amt;
      const clientId = t.customerId || t.phone || t.client;
      const svc = t.service || "其他/未指定";
      if (!svcStats[svc]) {
        svcStats[svc] = {
          revenue: 0,
          clients: new Set(),
          color:
            t.serviceColor || "bg-neutral-600 text-white border-neutral-600",
        };
      }
      svcStats[svc].revenue += amt;
      svcStats[svc].clients.add(clientId);
    });

    const idPrefix = String(reportYear).slice(-2);
    const newClientSet = new Set();
    const sourceStats = {};

    Object.values(clientProfiles).forEach((profile) => {
      const cid = String(profile.id || "").trim();
      if (cid.startsWith(idPrefix)) {
        let earliest = "9999-99-99";
        if (profile.consents && Array.isArray(profile.consents)) {
          profile.consents.forEach((c) => {
            if (c.date && c.date < earliest) earliest = c.date;
          });
        }
        treatmentRecords.forEach((r) => {
          const matchId = r.customerId && String(r.customerId).trim() === cid;
          const matchPhone = profile.phone && r.phone === profile.phone;
          const matchName = profile.name && r.client === profile.name;
          if (
            (matchId || matchPhone || matchName) &&
            r.date &&
            r.date < earliest
          )
            earliest = r.date;
        });
        if (earliest === "9999-99-99" && profile.lastUpdated) {
          earliest = profile.lastUpdated.split("T")[0];
        }
        if (earliest !== "9999-99-99") {
          const fd = new Date(earliest);
          const matchYear = fd.getFullYear() === reportYear;
          const matchMonth =
            reportMonth === "all" ||
            fd.getMonth() + 1 === parseInt(reportMonth);
          if (matchYear && matchMonth) {
            newClientSet.add(cid);
            const source = profile.source?.trim() || "未記錄";
            sourceStats[source] = (sourceStats[source] || 0) + 1;
          }
        }
      }
    });

    const sourceBreakdown = Object.entries(sourceStats)
      .map(([name, count]) => ({ name, count }))
      .sort((a, b) => b.count - a.count);

    let totalServicesCount = 0;
    const breakdown = Object.entries(svcStats)
      .map(([name, data]) => {
        totalServicesCount += data.clients.size;
        return {
          name,
          revenue: data.revenue,
          clientCount: data.clients.size,
          color: data.color,
          percentage: 0,
        };
      })
      .sort((a, b) => b.revenue - a.revenue);

    breakdown.forEach((item) => {
      item.percentage = totalRev > 0 ? (item.revenue / totalRev) * 100 : 0;
    });

    return {
      totalRevenue: totalRev,
      newClients: newClientSet.size,
      totalServices: totalServicesCount,
      breakdown,
      sourceBreakdown,
    };
  }, [transactions, treatmentRecords, clientProfiles, reportYear, reportMonth]);

  const clients = useMemo(() => {
    const profileById = new Map();
    const profileByPhone = new Map();

    Object.entries(clientProfiles).forEach(([key, profile]) => {
      if (profile.id) profileById.set(String(profile.id).trim(), key);
      if (profile.phone) profileByPhone.set(String(profile.phone).trim(), key);
    });

    const resolveProfileKey = (customerId, phone, name) => {
      if (customerId) {
        const key = profileById.get(String(customerId).trim());
        if (key) return key;
      }
      if (phone) {
        const key = profileByPhone.get(String(phone).trim());
        if (key) return key;
      }
      return customerId || phone || name || null;
    };

    const lastActivityMap = new Map();

    const updateLastActivity = (key, dateStr) => {
      if (!key || !dateStr) return;
      const current = lastActivityMap.get(key) || "0000-00-00";
      if (dateStr > current) lastActivityMap.set(key, dateStr);
    };

    transactions.forEach((t) => {
      const key = resolveProfileKey(t.customerId, t.phone, t.client);
      updateLastActivity(key, t.date);
    });

    treatmentRecords.forEach((r) => {
      const key = resolveProfileKey(r.customerId, r.phone, r.client);
      updateLastActivity(key, r.date);
    });

    Object.entries(clientProfiles).forEach(([key, profile]) => {
      if (profile.lastUpdated) updateLastActivity(key, profile.lastUpdated);
      if (profile.consents) {
        profile.consents.forEach((c) => {
          updateLastActivity(key, c.timestamp || c.date);
        });
      }
    });

    const clientsMap = new Map();

    Object.entries(clientProfiles).forEach(([key, profile]) => {
      clientsMap.set(key, {
        ...profile,
        lastActivity:
          lastActivityMap.get(key) ||
          profile.lastUpdated?.split("T")[0] ||
          "0000-00-00",
      });
    });

    const addOrphanClient = (customerId, phone, name, extraData, dateStr) => {
      const key = resolveProfileKey(customerId, phone, name);
      if (!key || clientsMap.has(key)) return;
      clientsMap.set(key, {
        id: customerId || "",
        name: name || "",
        phone: phone || "",
        lastActivity: lastActivityMap.get(key) || dateStr || "0000-00-00",
        ...extraData,
      });
    };

    transactions.forEach((t) =>
      addOrphanClient(
        t.customerId,
        t.phone,
        t.client,
        {
          contactMethod: t.contactMethod,
          socialHandle: t.socialHandle,
          whatsappPhone: t.whatsappPhone,
        },
        t.date
      )
    );

    treatmentRecords.forEach((r) =>
      addOrphanClient(r.customerId, r.phone, r.client, {}, r.date)
    );

    return Array.from(clientsMap.values());
  }, [transactions, treatmentRecords, clientProfiles]);

  const findClientById = (id) => clients.find((c) => c.id === id);

  const monthlyReminders = useMemo(() => {
    const y = calendarDate.getFullYear();
    const m = calendarDate.getMonth();

    const touchUpDue = [];
    treatmentRecords.forEach((r) => {
      const isTouchUp = r.service?.includes("補");
      const isLaser = r.service?.includes("激光");
      if (isTouchUp || isLaser || !r.service || !r.date) return;

      const addMonths = getServiceAddMonths(r.service);
      if (addMonths <= 0) return;

      const deadline = new Date(r.date);
      deadline.setMonth(deadline.getMonth() + addMonths);
      if (deadline.getFullYear() !== y || deadline.getMonth() !== m) return;

      const key = r.customerId || r.phone || r.client;
      const hasLaterTouchUp = treatmentRecords.some((other) => {
        if (other.id === r.id) return false;
        const otherKey = other.customerId || other.phone || other.client;
        if (otherKey !== key) return false;
        return (
          other.service?.includes("補") &&
          new Date(other.date) >= new Date(r.date)
        );
      });
      if (hasLaterTouchUp) return;

      const profile = clientProfiles[key] || {};

      touchUpDue.push({
        id: r.id,
        client: r.client,
        phone: r.phone,
        customerId: r.customerId,
        service: r.service,
        serviceDate: r.date,
        deadline: `${deadline.getFullYear()}年${
          deadline.getMonth() + 1
        }月${deadline.getDate()}日`,
        hasWhatsapp: profile.hasWhatsapp || false,
        useSocial: profile.useSocial || false,
        socialHandle: profile.socialHandle || "",
        whatsappPhone: profile.whatsappPhone || r.phone || "",
      });
    });
    touchUpDue.sort((a, b) => new Date(a.serviceDate) - new Date(b.serviceDate));

    const voucherExpiring = [];
    Object.entries(clientProfiles).forEach(([key, profile]) => {
      if (!profile.voucherPurchaseDate || profile.voucherUsed) return;
      const expiry = getVoucherExpiryDate(profile.voucherPurchaseDate);
      if (!expiry) return;
      const reminderDate = new Date(expiry);
      reminderDate.setMonth(reminderDate.getMonth() - 1);
      if (reminderDate.getFullYear() !== y || reminderDate.getMonth() !== m)
        return;

      voucherExpiring.push({
        key,
        client: profile.name,
        phone: profile.phone,
        customerId: profile.id,
        purchaseDate: profile.voucherPurchaseDate,
        expiryDate: `${expiry.getFullYear()}年${
          expiry.getMonth() + 1
        }月${expiry.getDate()}日`,
        hasWhatsapp: profile.hasWhatsapp || false,
        useSocial: profile.useSocial || false,
        socialHandle: profile.socialHandle || "",
        whatsappPhone: profile.whatsappPhone || profile.phone || "",
      });
    });
    voucherExpiring.sort(
      (a, b) => new Date(a.purchaseDate) - new Date(b.purchaseDate)
    );

    const recallYear = y - 1;
    const recallCandidates = treatmentRecords.filter((r) => {
      if (!r.service?.includes("補") || !r.date) return false;
      const d = new Date(r.date);
      return d.getFullYear() === recallYear && d.getMonth() === m;
    });

    const recallByClient = new Map();
    recallCandidates.forEach((r) => {
      const key = r.customerId || r.phone || r.client;
      const existing = recallByClient.get(key);
      if (!existing || new Date(r.date) > new Date(existing.date)) {
        recallByClient.set(key, r);
      }
    });

    const recallClients = [];
    const eyebrowService = services.find(
      (s) => getServiceCategory(s.name) === "眉"
    );
    const eyebrowOriginalPrice = eyebrowService?.price || 2800;
    recallByClient.forEach((r, key) => {
      const hasReturnedSince = treatmentRecords.some((other) => {
        if (other.id === r.id) return false;
        const otherKey = other.customerId || other.phone || other.client;
        if (otherKey !== key) return false;
        return new Date(other.date) > new Date(r.date);
      });
      if (hasReturnedSince) return;

      const profile = clientProfiles[key] || {};
      const monthsElapsed = getMonthsElapsed(r.date);
      const { price: recallPrice, tier: recallTier } = getRecallPriceInfo(
        monthsElapsed,
        eyebrowOriginalPrice,
        recallPricing
      );
      recallClients.push({
        id: r.id,
        client: r.client,
        phone: r.phone,
        customerId: r.customerId,
        service: r.service,
        lastServiceDate: r.date,
        monthsElapsed,
        recallPrice,
        recallTier,
        hasWhatsapp: profile.hasWhatsapp || false,
        useSocial: profile.useSocial || false,
        socialHandle: profile.socialHandle || "",
        whatsappPhone: profile.whatsappPhone || r.phone || "",
      });
    });
    recallClients.sort(
      (a, b) => new Date(a.lastServiceDate) - new Date(b.lastServiceDate)
    );

    return { touchUpDue, voucherExpiring, recallClients };
  }, [treatmentRecords, clientProfiles, calendarDate, services, recallPricing]);

  const initialTransForm = {
    mode: "single",
    client: "",
    customerId: "",
    customerType: "new",
    phone: "",
    contactMethod: "",
    socialHandle: "",
    whatsappPhone: "",
    service: "",
    serviceColor: "",
    date: getTodayDate(),
    type: "訂金",
    method: "PayMe",
    amount: "",
    isMixedSingle: false,
    method2: "Cash",
    amount2: "",
    depositDate: getTodayDate(),
    depositMethod: "PayMe",
    depositAmount: "",
    balanceDate: getTodayDate(),
    balanceMethod: "Cash",
    balanceAmount: "",
    isMixedBalance: false,
    balanceMethod2: "PayMe",
    balanceAmount2: "",
    remarks: "",
  };
  const [transForm, setTransForm] = useState(initialTransForm);
  const [isWhatsappSame, setIsWhatsappSame] = useState(false);

  const initialRecordForm = {
    client: "",
    phone: "",
    customerId: "",
    date: getTodayDate(),
    service: "",
    serviceColor: "",
    price: "",
    colorUsed: "",
    toolsUsed: "",
    remarks: "",
    colorComparison: "Same",
    beforePhotos: [],
    afterPhotos: [],
  };
  const [recordForm, setRecordForm] = useState(initialRecordForm);

  const [clientEditForm, setClientEditForm] = useState({
    name: "",
    phone: "",
    id: "",
    contactMethod: "",
    socialHandle: "",
    whatsappPhone: "",
    skinType: [],
    preference: "",
    dailyCare: [],
    hasTattooBefore: null,
    tattooTime: "",
    tattooBaseColor: "",
    hasLaserBefore: null,
    source: "",
    voucherPurchaseDate: "",
    voucherUsed: false,
    voucherUsedDate: "",
  });
  const [isEditWhatsappSame, setIsEditWhatsappSame] = useState(false);

  const [consentForm, setConsentForm] = useState({
    name: "",
    phone: "",
    dobMonth: "",
    dobDay: "",
    email: "",
    medicalConditions: [],
    agreed: false,
    signature: "",
    selectedServices: [],
    otherServiceRemark: "",
  });

  const [newService, setNewService] = useState({
    name: "",
    price: "",
    color: COLOR_PALETTE[0],
  });
  const [tempEditingService, setTempEditingService] = useState(null);
  const canvasRef = useRef(null);
  const [isDrawing, setIsDrawing] = useState(false);

  const openAddModal = () => {
    setTransForm({
      ...initialTransForm,
      date: getTodayDate(),
      depositDate: getTodayDate(),
      balanceDate: getTodayDate(),
    });
    setIsWhatsappSame(false);
    setTransServiceCat("");
    setShowModal(true);
  };

  const openEditModal = (t) => {
    setTransForm({ ...t, mode: "single" });
    setIsWhatsappSame(t.whatsappPhone === t.phone);
    setTransServiceCat(t.service ? getServiceCategory(t.service) : "");
    setShowModal(true);
  };

  const openClientFile = (client) => {
    setSelectedClient(client);
    setShowClientDetails(false);
    setShowClientModal(true);
  };

  const handleJumpToClient = (id) => {
    const client = findClientById(id);
    if (client) openClientFile(client);
    else showToast("找不到此客戶 ID 的檔案", "error");
  };

  const openAddRecordModal = () => {
    if (!selectedClient) return;
    setRecordForm({
      ...initialRecordForm,
      client: selectedClient.name || "",
      phone: selectedClient.phone || "",
      customerId: selectedClient.id || "",
      date: getTodayDate(),
    });
    setIsEditingColor(false);
    setIsEditingTool(false);
    setSelectedDragItem(null);
    setRecordServiceCat("");
    setShowRecordModal(true);
  };

  const openClientEditModal = () => {
    const isSame = selectedClient.whatsappPhone === selectedClient.phone;
    setClientEditForm({
      name: selectedClient.name || "",
      phone: selectedClient.phone || "",
      id: selectedClient.id || "",
      socialHandle: selectedClient.socialHandle || "",
      whatsappPhone: selectedClient.whatsappPhone || "",
      skinType: selectedClient.skinType || [],
      preference: selectedClient.preference || "",
      dailyCare: selectedClient.dailyCare || [],
      dobMonth: selectedClient.dobMonth || "",
      dobDay: selectedClient.dobDay || "",
      email: selectedClient.email || "",
      notes: selectedClient.notes || "",
      tagV: selectedClient.tagV || false,
      tagS: selectedClient.tagS || false,
      hasWhatsapp: selectedClient.hasWhatsapp || false,
      useSocial: !!selectedClient.socialHandle,
      hasTattooBefore: selectedClient.hasTattooBefore ?? null,
      tattooTime: selectedClient.tattooTime || "",
      tattooBaseColor: selectedClient.tattooBaseColor || "",
      hasLaserBefore: selectedClient.hasLaserBefore ?? null,
      source: selectedClient.source || "",
      isNonHK: selectedClient.isNonHK || false,
      voucherPurchaseDate: selectedClient.voucherPurchaseDate || "",
      voucherUsed: selectedClient.voucherUsed || false,
      voucherUsedDate: selectedClient.voucherUsedDate || "",
    });
    setIsEditWhatsappSame(isSame);
    setIsGuestMode(false);
    setShowClientEditModal(true);
  };

  const openNewClientModal = () => {
    let nextId = "1";
    if (clients.length > 0) {
      const numericIds = clients
        .map((c) => parseInt(c.id))
        .filter((n) => !isNaN(n));
      if (numericIds.length > 0) nextId = String(Math.max(...numericIds) + 1);
    }
    setClientEditForm({
      name: "",
      phone: "",
      id: nextId,
      socialHandle: "",
      whatsappPhone: "",
      skinType: [],
      preference: "",
      dailyCare: [],
      dobMonth: "",
      dobDay: "",
      email: "",
      notes: "",
      tagV: false,
      tagS: false,
      hasWhatsapp: false,
      useSocial: false,
      hasTattooBefore: null,
      tattooTime: "",
      tattooBaseColor: "",
      hasLaserBefore: null,
      source: "",
      isNonHK: false,
      voucherPurchaseDate: "",
      voucherUsed: false,
      voucherUsedDate: "",
    });
    setSelectedClient(null);
    setIsEditWhatsappSame(false);
    setIsGuestMode(false);
    setShowClientEditModal(true);
  };

  const openViewConsent = (consent) => {
    setViewConsentData(consent);
    setShowConsentModal(true);
  };

  const openConsentModal = () => {
    setConsentStep(1);
    setConsentForm({
      name: selectedClient.name || "",
      phone: selectedClient.phone || "",
      dobMonth: selectedClient.dobMonth || "",
      dobDay: selectedClient.dobDay || "",
      email: selectedClient.email || "",
      medicalConditions: selectedClient?.medicalConditions || [],
      agreed: false,
      signature: "",
      selectedServices: [],
      otherServiceRemark: "",
    });
    setShowConsentModal(true);
    setViewConsentData(null);
  };

  const handleTransIdChange = (e) => {
    const newId = e.target.value;
    let updates = { customerId: newId };
    const existingClient = findClientById(newId);
    if (existingClient && newId.trim() !== "") {
      updates = {
        ...updates,
        client: existingClient.name,
        phone: existingClient.phone,
        customerType: "old",
        socialHandle: existingClient.socialHandle || "",
        whatsappPhone: existingClient.whatsappPhone || "",
      };
      if (existingClient.whatsappPhone === existingClient.phone)
        setIsWhatsappSame(true);
    }
    setTransForm((prev) => ({ ...prev, ...updates }));
  };

  const toggleEditSkinType = (type) =>
    setClientEditForm((prev) => ({
      ...prev,
      skinType: prev.skinType?.includes(type)
        ? prev.skinType.filter((t) => t !== type)
        : [...(prev.skinType || []), type],
    }));

  const toggleEditDailyCare = (type) =>
    setClientEditForm((prev) => ({
      ...prev,
      dailyCare: prev.dailyCare?.includes(type)
        ? prev.dailyCare.filter((t) => t !== type)
        : [...(prev.dailyCare || []), type],
    }));

  const toggleMedical = (condition) => {
    setConsentForm((prev) => {
      if (condition === "以上症狀皆沒有")
        return { ...prev, medicalConditions: ["以上症狀皆沒有"] };
      const newConditions = prev.medicalConditions.includes(condition)
        ? prev.medicalConditions.filter((c) => c !== condition)
        : [
            ...prev.medicalConditions.filter((c) => c !== "以上症狀皆沒有"),
            condition,
          ];
      return { ...prev, medicalConditions: newConditions };
    });
  };

  const toggleService = (service) => {
    setConsentForm((prev) => {
      const isSelected = prev.selectedServices.includes(service);
      const newServices = isSelected
        ? prev.selectedServices.filter((s) => s !== service)
        : [...prev.selectedServices, service];
      return service === "其他請註明" && isSelected
        ? { ...prev, selectedServices: newServices, otherServiceRemark: "" }
        : { ...prev, selectedServices: newServices };
    });
  };

  const checkStepValidity = () => {
    if (consentStep === 1) return consentForm.name && consentForm.phone;
    if (consentStep === 2) return consentForm.selectedServices.length > 0;
    if (consentStep === 3) return consentForm.medicalConditions.length > 0;
    return true;
  };

  const validateId = (id, name) => {
    if (!id) return true;
    const existing = findClientById(id);
    if (existing && existing.name !== name) {
      showToast(`編號衝突：${id} 已屬於 ${existing.name}`, "error");
      return false;
    }
    return true;
  };

  const handleServiceSelectTrans = (service) => {
    let updates = { service: service.name, serviceColor: service.color };
    if (transForm.mode === "single")
      updates.amount =
        transForm.type === "全數" ? service.price : defaultDeposit;
    else {
      updates.depositAmount = defaultDeposit;
      updates.balanceAmount = (service.price || 2800) - defaultDeposit;
    }
    setTransForm({ ...transForm, ...updates });
  };

  const getCoordinates = (e, canvas) => {
    const rect = canvas.getBoundingClientRect();
    const scaleX = canvas.width / rect.width;
    const scaleY = canvas.height / rect.height;
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;
    return {
      x: (clientX - rect.left) * scaleX,
      y: (clientY - rect.top) * scaleY,
    };
  };

  const startDrawing = (e) => {
    if (e.cancelable) e.preventDefault();
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    ctx.lineWidth = 2;
    ctx.lineCap = "round";
    ctx.strokeStyle = "black";
    const { x, y } = getCoordinates(e, canvas);
    ctx.beginPath();
    ctx.moveTo(x, y);
    setIsDrawing(true);
  };

  const draw = (e) => {
    if (e.cancelable) e.preventDefault();
    if (!isDrawing) return;
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    const { x, y } = getCoordinates(e, canvas);
    ctx.lineTo(x, y);
    ctx.stroke();
  };

  const endDrawing = () => setIsDrawing(false);

  const clearSignature = () => {
    const canvas = canvasRef.current;
    if (canvas)
      canvas.getContext("2d").clearRect(0, 0, canvas.width, canvas.height);
  };

  const saveSort = async (type, list) => {
    if (!db) return;
    const field = type === "color" ? "colorPresets" : "toolPresets";
    await setDoc(
      doc(db, "system", "settings"),
      { [field]: list },
      { merge: true }
    );
  };

  const handleDragStart = (e, position) => {
    dragItem.current = position;
  };
  const handleDragEnter = (e, position) => {
    dragOverItem.current = position;
  };
  const handleDragEnd = (type) => {
    const list = type === "color" ? [...colorPresets] : [...toolPresets];
    const dragItemContent = list[dragItem.current];
    list.splice(dragItem.current, 1);
    list.splice(dragOverItem.current, 0, dragItemContent);
    dragItem.current = null;
    dragOverItem.current = null;
    if (type === "color") setColorPresets(list);
    else setToolPresets(list);
    saveSort(type, list);
  };

  const handleServiceDragEnd = async () => {
    const list = [...services];
    const dragItemContent = list[serviceDragItem.current];
    list.splice(serviceDragItem.current, 1);
    list.splice(serviceDragOverItem.current, 0, dragItemContent);
    serviceDragItem.current = null;
    serviceDragOverItem.current = null;

    setServices(list);

    if (db) {
      const batch = writeBatch(db);
      list.forEach((svc, idx) => {
        batch.update(doc(db, "services", String(svc.id)), { order: idx });
      });
      await batch.commit();
    }
  };

  const handleTapMove = (type, index) => {
    if (selectedDragItem === null) {
      setSelectedDragItem({ type, index });
    } else {
      if (selectedDragItem.type !== type) {
        setSelectedDragItem({ type, index });
        return;
      }
      const list = type === "color" ? [...colorPresets] : [...toolPresets];
      const itemContent = list[selectedDragItem.index];
      list.splice(selectedDragItem.index, 1);
      list.splice(index, 0, itemContent);
      if (type === "color") setColorPresets(list);
      else setToolPresets(list);
      saveSort(type, list);
      setSelectedDragItem(null);
    }
  };

  const addPreset = async (type, value) => {
    if (!value || !db) return;
    if (type === "color") {
      const newPresets = [...colorPresets, value];
      setColorPresets(newPresets);
      await setDoc(
        doc(db, "system", "settings"),
        { colorPresets: newPresets },
        { merge: true }
      );
    } else {
      const newPresets = [...toolPresets, value];
      setToolPresets(newPresets);
      await setDoc(
        doc(db, "system", "settings"),
        { toolPresets: newPresets },
        { merge: true }
      );
    }
  };

  const promptAddPreset = async (type) => {
    const val = await showDialog({
      title: `新增${type === "color" ? "配色" : "工具"}常用字`,
      type: "prompt",
      placeholder: "輸入新字彙...",
      confirmLabel: "新增",
    });
    if (val && typeof val === "string" && val.trim())
      addPreset(type, val.trim());
  };

  const deletePreset = async (type, value) => {
    const newPresets = (type === "color" ? colorPresets : toolPresets).filter(
      (p) => p !== value
    );
    if (type === "color") setColorPresets(newPresets);
    else setToolPresets(newPresets);
    await setDoc(
      doc(db, "system", "settings"),
      {
        [type === "color" ? "colorPresets" : "toolPresets"]: newPresets,
      },
      { merge: true }
    );
  };

  const updatePreset = async (type, oldValue, newValue) => {
    if (!newValue || !db) return;
    const newPresets = (type === "color" ? colorPresets : toolPresets).map(
      (p) => (p === oldValue ? newValue : p)
    );
    if (type === "color") setColorPresets(newPresets);
    else setToolPresets(newPresets);
    await setDoc(
      doc(db, "system", "settings"),
      {
        [type === "color" ? "colorPresets" : "toolPresets"]: newPresets,
      },
      { merge: true }
    );
  };

  const handlePresetClick = (type, value, index) => {
    const isEditing = type === "color" ? isEditingColor : isEditingTool;
    if (isEditing) {
      handleTapMove(type, index);
    } else {
      const field = type === "color" ? "colorUsed" : "toolsUsed";
      const current = recordForm[field] || "";
      setRecordForm((prev) => ({
        ...prev,
        [field]: current ? `${current} ${value}` : value,
      }));
    }
  };

  const handlePresetDoubleClick = async (type, value) => {
    const isEditing = type === "color" ? isEditingColor : isEditingTool;
    if (isEditing) {
      const newName = await showDialog({
        title: `修改「${value}」`,
        type: "prompt",
        defaultValue: value,
        placeholder: "新名稱（留空則刪除）",
        confirmLabel: "確認",
      });
      if (newName === false) return;
      if (typeof newName === "string") {
        if (newName.trim() === "") deletePreset(type, value);
        else if (newName.trim() !== value)
          updatePreset(type, value, newName.trim());
      }
    }
  };

  const handleDeleteConsent = async (consentToDelete) => {
    const ok = await showDialog({
      title: "刪除同意書",
      message: "確定要刪除這份同意書記錄嗎？",
      confirmLabel: "刪除",
      cancelLabel: "取消",
      type: "danger",
    });
    if (!ok) return;
    if (!db || !selectedClient) return;
    const profileKey =
      selectedClient.id || selectedClient.phone || selectedClient.name;
    try {
      await updateDoc(doc(db, "clientProfiles", profileKey), {
        consents: arrayRemove(consentToDelete),
      });
      const updatedConsents = selectedClient.consents.filter(
        (c) => c !== consentToDelete
      );
      setSelectedClient({ ...selectedClient, consents: updatedConsents });
    } catch (e) {
      showToast("刪除失敗: " + e.message, "error");
    }
  };

  const handleDownloadImage = async () => {
    if (!window.html2canvas || !consentFormRef.current || !viewConsentData)
      return;
    try {
      const canvas = await window.html2canvas(consentFormRef.current, {
        scale: 2,
        backgroundColor: "#ffffff",
        logging: false,
        useCORS: true,
      });
      const link = document.createElement("a");
      link.href = canvas.toDataURL("image/png");
      link.download = `EyebrowsArt_Consent_${viewConsentData.name}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      showToast("下載圖片時發生錯誤，請重試。", "error");
    }
  };

  const handleSaveTrans = async () => {
    if (!transForm.client) {
      showToast("請輸入客名", "error");
      return;
    }
    if (transForm.mode === "single" && !transForm.amount) {
      showToast("請輸入金額", "error");
      return;
    }
    if (
      transForm.mode === "split" &&
      !transForm.depositAmount &&
      !transForm.balanceAmount
    ) {
      showToast("請至少輸入訂金或尾數金額", "error");
      return;
    }
    if (!validateId(transForm.customerId, transForm.client)) return;
    if (!db) {
      showToast("資料庫未連接", "error");
      return;
    }

    setIsSubmitting(true);
    try {
      const cleanData = (obj) => {
        const newObj = { ...obj };
        Object.keys(newObj).forEach(
          (k) => newObj[k] === undefined && delete newObj[k]
        );
        newObj.customerId = newObj.customerId || "";
        newObj.phone = newObj.phone || "";
        return newObj;
      };

      const {
        id,
        mode,
        depositDate,
        depositMethod,
        depositAmount,
        balanceDate,
        balanceMethod,
        balanceAmount,
        isMixedSingle,
        method2,
        amount2,
        isMixedBalance,
        balanceMethod2,
        balanceAmount2,
        ...rawData
      } = transForm;

      if (transForm.mode === "split") {
        const batch = [];
        if (transForm.depositAmount) {
          batch.push(
            addDoc(
              collection(db, "transactions"),
              cleanData({
                ...rawData,
                type: "訂金",
                date: transForm.depositDate,
                method: transForm.depositMethod,
                amount: transForm.depositAmount,
              })
            )
          );
        }
        if (transForm.balanceAmount) {
          batch.push(
            addDoc(
              collection(db, "transactions"),
              cleanData({
                ...rawData,
                type: "尾數",
                date: transForm.balanceDate,
                method: transForm.balanceMethod,
                amount: transForm.balanceAmount,
              })
            )
          );
        }
        if (transForm.isMixedBalance && transForm.balanceAmount2) {
          batch.push(
            addDoc(
              collection(db, "transactions"),
              cleanData({
                ...rawData,
                type: "尾數",
                date: transForm.balanceDate,
                method: transForm.balanceMethod2,
                amount: transForm.balanceAmount2,
              })
            )
          );
        }
        await Promise.all(batch);
      } else {
        const data1 = cleanData({
          ...rawData,
          method: transForm.method,
          amount: transForm.amount,
        });
        if (transForm.id) {
          await updateDoc(doc(db, "transactions", String(transForm.id)), data1);
        } else {
          await addDoc(collection(db, "transactions"), data1);
          if (transForm.isMixedSingle && transForm.amount2) {
            await addDoc(
              collection(db, "transactions"),
              cleanData({
                ...rawData,
                method: transForm.method2,
                amount: transForm.amount2,
              })
            );
          }
        }
      }
      setShowModal(false);
    } catch (e) {
      showToast("儲存失敗: " + e.message, "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSaveRecord = async () => {
    if (!recordForm.client) {
      showToast("錯誤：找不到客戶名稱。", "error");
      return;
    }
    if (!recordForm.service) {
      showToast("請選擇「項目 Service」", "error");
      return;
    }
    if (!db) {
      showToast("錯誤：資料庫未連接。", "error");
      return;
    }

    setIsSubmitting(true);
    try {
      const { id, ...rawData } = recordForm;
      const dataToSave = {
        ...rawData,
        customerId: rawData.customerId || "",
        phone: rawData.phone || "",
        price: rawData.price || "",
        colorUsed: rawData.colorUsed || "",
        toolsUsed: rawData.toolsUsed || "",
        remarks: rawData.remarks || "",
        colorComparison: rawData.colorComparison || "",
        beforePhotos: rawData.beforePhotos || [],
        afterPhotos: rawData.afterPhotos || [],
      };

      if (recordForm.id) {
        await updateDoc(
          doc(db, "treatmentRecords", String(recordForm.id)),
          dataToSave
        );
      } else {
        await addDoc(collection(db, "treatmentRecords"), dataToSave);
      }

      const isTouchUp = dataToSave.service?.includes("補");

      setShowRecordModal(false);

      if (isTouchUp) {
        showToast("補色紀錄儲存成功！", "success");
      } else {
        showToast("紀錄儲存成功！", "success");
        await new Promise((r) => setTimeout(r, 150));

        if (
          await showDialog({
            title: "前往財務",
            message: "是否需要即時轉去「財務」頁面進行收費？",
            confirmLabel: "前往",
            cancelLabel: "稍後",
          })
        ) {
          setTransForm({
            ...initialTransForm,
            client: dataToSave.client,
            phone: dataToSave.phone,
            customerId: dataToSave.customerId,
            customerType: "old",
            service: dataToSave.service,
            serviceColor: dataToSave.serviceColor,
            amount: dataToSave.price || "",
            date: getTodayDate(),
          });
          setActiveTab("home");
          setShowModal(true);
        }
      }
    } catch (e) {
      showToast("儲存失敗: " + e.message, "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  const copyReminderMessage = async (message, clientName) => {
    try {
      await navigator.clipboard.writeText(message);
      showToast(`✅ Copy 成功！去WhatsApp ${clientName} 度貼上`, "success", 5000);
    } catch (e) {
      const textArea = document.createElement("textarea");
      textArea.value = message;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
        showToast(`✅ Copy 成功！去WhatsApp ${clientName} 度貼上`, "success", 5000);
      } catch (err) {
        showToast("Copy 失敗，請手動複製。", "error");
      }
      document.body.removeChild(textArea);
    }
  };

  const handleSendWhatsAppCare = async () => {
    if (!recordForm.client || !recordForm.phone) {
      showToast("請先確保已填寫客戶名稱及電話號碼", "error");
      return;
    }
    if (!recordForm.service) {
      showToast("請先選擇服務項目，系統才能配對相應嘅護理事項", "error");
      return;
    }

    const isTouchUp = recordForm.service.includes("補");
    const message = generateCareMessage({
      client: recordForm.client,
      service: recordForm.service,
      date: recordForm.date,
      isTouchUp,
    });

    try {
      await navigator.clipboard.writeText(message);
      showToast(
        `✅ Copy 成功！去公司 iPhone WhatsApp ${recordForm.client} 度貼上`,
        "success",
        5000
      );
    } catch (e) {
      const textArea = document.createElement("textarea");
      textArea.value = message;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
        showToast("✅ Copy 成功！去公司 iPhone 貼上啦！", "success", 5000);
      } catch (err) {
        showToast("Copy 失敗，請手動複製。", "error");
      }
      document.body.removeChild(textArea);
    }
  };

  const buildClientProfileData = (form, existingConsents = []) => ({
    name: form.name,
    phone: form.phone,
    id: form.id || "",
    skinType: form.skinType || [],
    preference: form.preference || "",
    dailyCare: form.dailyCare || [],
    socialHandle: form.useSocial ? form.socialHandle : "",
    whatsappPhone: form.whatsappPhone || "",
    consents: existingConsents,
    dobMonth: form.dobMonth || "",
    dobDay: form.dobDay || "",
    email: form.email || "",
    notes: form.notes || "",
    tagV: form.tagV || false,
    tagS: form.tagS || false,
    hasWhatsapp: form.hasWhatsapp || false,
    hasTattooBefore: form.hasTattooBefore,
    tattooTime: form.tattooTime,
    tattooBaseColor: form.tattooBaseColor,
    hasLaserBefore: form.hasLaserBefore,
    source: form.source,
    isNonHK: form.isNonHK || false,
    voucherPurchaseDate: form.voucherPurchaseDate || "",
    voucherUsed: form.voucherUsed || false,
    voucherUsedDate: form.voucherUsedDate || "",
    lastUpdated: new Date().toISOString(),
  });

  const handleSaveClientProfile = async () => {
    if (!clientEditForm.name) {
      showToast("請輸入客戶名稱", "error");
      return;
    }
    if (!db) return;

    const isEdit = !!selectedClient;

    if (
      !isEdit &&
      clientEditForm.id &&
      !validateId(clientEditForm.id, clientEditForm.name)
    )
      return;

    setIsSubmitting(true);
    try {
      const profileKey =
        clientEditForm.id || clientEditForm.phone || clientEditForm.name;
      const batch = writeBatch(db);
      const profileRef = doc(db, "clientProfiles", profileKey);

      const finalClientData = buildClientProfileData(
        clientEditForm,
        selectedClient?.consents || []
      );
      batch.set(profileRef, finalClientData, { merge: true });

      if (isEdit) {
        const updateData = {
          client: clientEditForm.name,
          phone: clientEditForm.phone,
          customerId: clientEditForm.id || "",
          socialHandle: clientEditForm.socialHandle || "",
          whatsappPhone: clientEditForm.whatsappPhone || "",
        };

        transactions
          .filter((t) =>
            selectedClient.id
              ? t.customerId === selectedClient.id
              : selectedClient.phone
              ? t.phone === selectedClient.phone
              : t.client === selectedClient.name
          )
          .forEach((t) =>
            batch.update(doc(db, "transactions", String(t.id)), updateData)
          );

        treatmentRecords
          .filter((r) =>
            selectedClient.id
              ? r.customerId === selectedClient.id
              : selectedClient.phone
              ? r.phone === selectedClient.phone
              : r.client === selectedClient.name
          )
          .forEach((r) =>
            batch.update(doc(db, "treatmentRecords", String(r.id)), {
              client: clientEditForm.name,
              phone: clientEditForm.phone,
              customerId: clientEditForm.id || "",
            })
          );
      }

      await batch.commit();

      const updatedClientData = {
        ...selectedClient,
        ...clientEditForm,
        socialHandle: clientEditForm.useSocial
          ? clientEditForm.socialHandle
          : "",
      };

      if (isEdit) {
        setSelectedClient(updatedClientData);
      } else {
        setSelectedClient(finalClientData);
        setShowClientDetails(false);
        setShowClientModal(true);
      }

      if (isGuestMode) {
        setShowGuestLockScreen(true);
        setIsGuestMode(false);
      } else if (isEdit) {
        showToast("客戶資料已更新。", "success");
      }

      setShowClientEditModal(false);
    } catch (e) {
      showToast("儲存失敗: " + e.message, "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  const saveConsent = async () => {
    const canvas = canvasRef.current;
    if (!canvas || !selectedClient) return;
    if (!consentForm.agreed) {
      showToast("必須同意條款", "error");
      return;
    }
    const signatureImage = canvas.toDataURL("image/png");
    if (signatureImage.length < 3000) {
      showToast("請先簽名", "error");
      return;
    }
    if (!db) return;

    setIsSubmitting(true);
    try {
      const profileKey =
        selectedClient.id || selectedClient.phone || selectedClient.name;
      const todayDate = getTodayDate();
      const timeString = new Date().toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
      });

      const newConsent = {
        ...consentForm,
        signature: signatureImage,
        date: todayDate,
        time: timeString,
        timestamp: new Date().toISOString(),
        version: "v53",
      };

      await setDoc(
        doc(db, "clientProfiles", profileKey),
        {
          name: consentForm.name,
          phone: consentForm.phone,
          dobMonth: consentForm.dobMonth,
          dobDay: consentForm.dobDay,
          email: consentForm.email,
          medicalConditions: consentForm.medicalConditions,
          consents: arrayUnion(newConsent),
        },
        { merge: true }
      );

      setSelectedClient({
        ...selectedClient,
        name: consentForm.name,
        phone: consentForm.phone,
        medicalConditions: consentForm.medicalConditions,
        consents: [...(selectedClient.consents || []), newConsent],
      });

      setViewConsentData(newConsent);
    } catch (e) {
      showToast("儲存失敗: " + e.message, "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleUpdateDefaultDeposit = async (val) => {
    const amount = parseInt(val) || 0;
    setDefaultDeposit(amount);
    if (db)
      await setDoc(
        doc(db, "system", "settings"),
        { defaultDeposit: amount },
        { merge: true }
      );
  };

  const handleUpdateRecallPricing = async (field, val) => {
    const amount = parseInt(val) || 0;
    const updated = { ...recallPricing, [field]: amount };
    setRecallPricing(updated);
    if (db)
      await setDoc(
        doc(db, "system", "settings"),
        { recallPricing: updated },
        { merge: true }
      );
  };

  const handleUpdateReminderTemplate = async (type, text) => {
    const updated = { ...reminderTemplates, [type]: text };
    setReminderTemplates(updated);
    if (db)
      await setDoc(
        doc(db, "system", "settings"),
        { reminderTemplates: updated },
        { merge: true }
      );
  };

  const handleUpdateLogo = async (base64Image) => {
    setLogoImage(base64Image);
    if (db)
      await setDoc(
        doc(db, "system", "settings"),
        { logoImage: base64Image || "" },
        { merge: true }
      );
  };

  const getClientRecords = (client) => {
    if (!client) return [];
    return treatmentRecords
      .filter((r) => {
        if (client.id && r.customerId) return r.customerId === client.id;
        if (client.phone && r.phone) return r.phone === client.phone;
        return r.client === client.name && !r.customerId && !r.phone;
      })
      .sort((a, b) => new Date(b.date) - new Date(a.date));
  };

  const handleDeleteTransaction = async () => {
    if (
      db &&
      transForm.id &&
      (await showDialog({
        title: "刪除收款記錄",
        message: "確定刪除？此動作無法復原。",
        confirmLabel: "刪除",
        type: "danger",
      }))
    ) {
      await deleteDoc(doc(db, "transactions", String(transForm.id)));
      setShowModal(false);
    }
  };

  const handleDeleteRecord = async () => {
    if (
      db &&
      recordForm.id &&
      (await showDialog({
        title: "刪除施術紀錄",
        message: "確定刪除？此動作無法復原。",
        confirmLabel: "刪除",
        type: "danger",
      }))
    ) {
      await deleteDoc(doc(db, "treatmentRecords", String(recordForm.id)));
      setShowRecordModal(false);
    }
  };

  const handleDeleteClient = async () => {
    if (!db || !selectedClient) return;
    const okDel = await showDialog({
      title: `永久刪除「${selectedClient.name}」`,
      message: "此動作將刪除該客戶所有收款記錄、施術紀錄及同意書，無法復原！",
      confirmLabel: "永久刪除",
      cancelLabel: "取消",
      type: "danger",
    });
    if (!okDel) return;

    setIsSubmitting(true);
    try {
      const batch = writeBatch(db);
      const matchFn = (item) =>
        selectedClient.id
          ? item.customerId === selectedClient.id
          : selectedClient.phone
          ? item.phone === selectedClient.phone
          : item.client === selectedClient.name;

      transactions
        .filter(matchFn)
        .forEach((t) => batch.delete(doc(db, "transactions", String(t.id))));
      treatmentRecords
        .filter(matchFn)
        .forEach((r) =>
          batch.delete(doc(db, "treatmentRecords", String(r.id)))
        );

      const profileKey =
        selectedClient.id || selectedClient.phone || selectedClient.name;
      batch.delete(doc(db, "clientProfiles", profileKey));

      await batch.commit();
      showToast("已徹底刪除客戶及其所有紀錄。", "success");
      setShowClientModal(false);
      setSelectedClient(null);
    } catch (e) {
      showToast("刪除失敗: " + e.message, "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleAddService = async () => {
    if (newService.name) {
      await addDoc(collection(db, "services"), {
        ...newService,
        price: parseInt(newService.price) || 0,
        color: newService.color,
      });
      setNewService({ name: "", price: "", color: COLOR_PALETTE[0] });
    }
  };

  const handleDeleteService = async (id) => {
    if (
      await showDialog({
        title: "刪除服務項目",
        message: "確定刪除此服務？",
        confirmLabel: "刪除",
        type: "danger",
      })
    )
      await deleteDoc(doc(db, "services", String(id)));
  };

  const startEditingService = (s) => setTempEditingService(s);
  const cancelEditingService = () => setTempEditingService(null);
  const saveEditingService = async () => {
    if (tempEditingService?.name) {
      await setDoc(
        doc(db, "services", String(tempEditingService.id)),
        {
          name: tempEditingService.name,
          price: parseInt(tempEditingService.price) || 0,
          color: tempEditingService.color,
        },
        { merge: true }
      );
      setTempEditingService(null);
    }
  };

  const changeDashboardMonth = (offset) =>
    setDashboardDate(
      new Date(
        dashboardDate.getFullYear(),
        dashboardDate.getMonth() + offset,
        1
      )
    );

  const currentMonthTransactions = transactions.filter((t) => {
    const d = new Date(t.date);
    return (
      d.getMonth() === dashboardDate.getMonth() &&
      d.getFullYear() === dashboardDate.getFullYear()
    );
  });

  const calculateMonthlyTotal = (m) =>
    currentMonthTransactions
      .filter((t) => t.method === m)
      .reduce((a, c) => a + parseInt(c.amount || 0), 0);

  const totalMonthlyRevenue = currentMonthTransactions.reduce(
    (a, c) => a + parseInt(c.amount || 0),
    0
  );

  const changeCalendarMonth = (offset) => {
    setCalendarDate(
      new Date(calendarDate.getFullYear(), calendarDate.getMonth() + offset, 1)
    );
    setSelectedCalendarDate(null);
  };

  const handleDateClick = (d) =>
    setSelectedCalendarDate(selectedCalendarDate === d ? null : d);

  if (!db) {
    return (
      <div className="w-full h-screen bg-neutral-900 flex items-center justify-center p-10 text-white">
        Loading...
      </div>
    );
  }

  const colors = {
    bg: "bg-neutral-900",
    card: "bg-neutral-800",
    gold: "text-[#C5A47E]",
    goldBg: "bg-[#C5A47E]",
    pink: "text-[#E07A8D]",
    white: "text-neutral-100",
    gray: "text-neutral-400",
    inputBg: "bg-neutral-900",
  };

  return (
    <div
      className={`w-full h-screen ${colors.bg} relative font-sans overflow-hidden text-sm sm:text-base`}
    >
      {photoViewerRecord && (
        <PhotoViewer
          record={photoViewerRecord}
          onClose={() => setPhotoViewerRecord(null)}
        />
      )}

      <div className="fixed top-0 left-0 w-full h-20 px-6 flex justify-between items-center bg-gradient-to-b from-black to-neutral-900 z-30 shadow-sm border-b border-neutral-800">
        <div className="flex items-center gap-3">
          <div>
            <h1 className={`text-xl tracking-widest font-light ${colors.gold}`}>
              EYEBROWS <span className={`font-normal ${colors.pink}`}>Art</span>
            </h1>
            <p className={`text-[10px] ${colors.gray} tracking-wide`}>
              Professional Semi Permanent Makeup
            </p>
          </div>
        </div>
        <button
          onClick={() => setActiveTab("settings")}
          className={`p-2 rounded-full ${
            activeTab === "settings"
              ? "bg-[#C5A47E] text-black"
              : "text-[#C5A47E] hover:bg-neutral-800"
          }`}
        >
          <Settings size={24} />
        </button>
      </div>

      <div className="absolute top-20 bottom-20 left-0 w-full overflow-y-auto px-4 pt-4 pb-4 custom-scrollbar">
        {activeTab === "home" && (
          <div className="animate-fade-in h-full flex flex-col">
            {!isFinanceUnlocked ? (
              <PinLock
                icon={<Settings size={32} />}
                title="財務鎖定"
                onUnlock={() => setIsFinanceUnlocked(true)}
              />
            ) : (
              <div className="animate-fade-in space-y-6">
                <div className="flex items-center justify-center gap-6 mb-2">
                  <button
                    onClick={() => changeDashboardMonth(-1)}
                    className="p-2 bg-neutral-800 rounded-full text-neutral-400 hover:text-white"
                  >
                    <ChevronLeft size={20} />
                  </button>
                  <div className="text-center">
                    <span
                      className={`${colors.gold} text-lg font-medium block`}
                    >
                      {dashboardDate.getFullYear()}年
                    </span>
                    <span className={`${colors.white} text-2xl font-light`}>
                      {dashboardDate.getMonth() + 1}月
                    </span>
                  </div>
                  <button
                    onClick={() => changeDashboardMonth(1)}
                    className="p-2 bg-neutral-800 rounded-full text-neutral-400 hover:text-white"
                  >
                    <ChevronRight size={20} />
                  </button>
                </div>
                <div className="text-center mb-6">
                  <p className={`text-xs ${colors.gray} uppercase`}>
                    本月總收入
                  </p>
                  <p className={`${colors.white} text-4xl font-light mt-1`}>
                    HK$ {totalMonthlyRevenue.toLocaleString()}
                  </p>
                </div>
                <div className="grid grid-cols-1 gap-3">
                  {[
                    {
                      label: "現金 Cash",
                      amount: calculateMonthlyTotal("Cash"),
                      icon: <Banknote size={20} />,
                      color: "text-green-400",
                      bg: "bg-green-900/30",
                    },
                    {
                      label: "PayMe",
                      amount: calculateMonthlyTotal("PayMe"),
                      icon: <span className="font-bold">P</span>,
                      color: "text-red-400",
                      bg: "bg-red-900/30",
                    },
                    {
                      label: "轉數快 FPS",
                      amount: calculateMonthlyTotal("FPS"),
                      icon: <CreditCard size={20} />,
                      color: "text-blue-400",
                      bg: "bg-blue-900/30",
                    },
                  ].map((item, idx) => (
                    <div
                      key={idx}
                      className={`p-4 rounded-xl border border-neutral-700 ${colors.card} flex justify-between items-center`}
                    >
                      <div className="flex items-center gap-3">
                        <div
                          className={`p-2 rounded-lg ${item.bg} ${item.color} w-9 h-9 flex items-center justify-center`}
                        >
                          {item.icon}
                        </div>
                        <span className={`${colors.white} font-medium`}>
                          {item.label}
                        </span>
                      </div>
                      <span className={`${colors.white} text-lg`}>
                        ${item.amount.toLocaleString()}
                      </span>
                    </div>
                  ))}
                </div>
                <div className="mt-4">
                  <h3
                    className={`${colors.gold} text-xs uppercase tracking-wider font-semibold mb-3`}
                  >
                    近期收款
                  </h3>
                  <div className="space-y-3">
                    {currentMonthTransactions.length > 0 ? (
                      [...currentMonthTransactions]
                        .sort((a, b) => new Date(b.date) - new Date(a.date))
                        .map((t) => (
                          <TransactionCard
                            key={t.id}
                            t={t}
                            colors={colors}
                            onClick={() => openEditModal(t)}
                            onClientClick={handleJumpToClient}
                          />
                        ))
                    ) : (
                      <p className="text-neutral-600 text-center py-4">
                        本月暫無記錄
                      </p>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {activeTab === "stats" && (
          <div className="animate-fade-in h-full flex flex-col">
            {!isFinanceUnlocked ? (
              <PinLock
                icon={<BarChart2 size={32} />}
                title="報表鎖定"
                onUnlock={() => setIsFinanceUnlocked(true)}
              />
            ) : (
              <div className="animate-fade-in h-full flex flex-col w-full">
                <div className="sticky top-0 bg-neutral-900 pb-4 z-10">
                  <h2 className={`${colors.white} text-xl font-medium mb-4`}>
                    業務報表 Report
                  </h2>
                  <div className="flex justify-between items-center bg-neutral-800 rounded-xl p-2 mb-3 border border-neutral-700">
                    <button
                      onClick={() => setReportYear((y) => y - 1)}
                      className="p-2 text-neutral-400 hover:text-white"
                    >
                      <ChevronLeft size={20} />
                    </button>
                    <span
                      className={`${colors.gold} text-lg font-bold tracking-widest`}
                    >
                      {reportYear} 年
                    </span>
                    <button
                      onClick={() => setReportYear((y) => y + 1)}
                      className="p-2 text-neutral-400 hover:text-white"
                    >
                      <ChevronRight size={20} />
                    </button>
                  </div>
                  <div className="flex gap-2 overflow-x-auto custom-scrollbar pb-2">
                    <button
                      onClick={() => setReportMonth("all")}
                      className={`flex-none px-5 py-2 rounded-full text-sm font-medium transition-all ${
                        reportMonth === "all"
                          ? "bg-[#C5A47E] text-black shadow-md"
                          : "bg-neutral-800 text-neutral-400 border border-neutral-700 hover:text-white"
                      }`}
                    >
                      全年總結
                    </button>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((m) => (
                      <button
                        key={m}
                        onClick={() => setReportMonth(m)}
                        className={`flex-none px-4 py-2 rounded-full text-sm font-medium transition-all ${
                          reportMonth === m
                            ? "bg-[#C5A47E] text-black shadow-md"
                            : "bg-neutral-800 text-neutral-400 border border-neutral-700 hover:text-white"
                        }`}
                      >
                        {m}月
                      </button>
                    ))}
                  </div>
                </div>

                <div className="flex-1 overflow-y-auto space-y-5 pb-10 custom-scrollbar mt-2">
                  <div className="grid grid-cols-2 gap-3">
                    <div className="col-span-2 bg-neutral-800 p-6 rounded-2xl border border-neutral-700 flex flex-col items-center justify-center relative overflow-hidden">
                      <div className="absolute top-0 right-0 w-32 h-32 bg-[#C5A47E]/10 rounded-full blur-3xl -mr-10 -mt-10" />
                      <span className="text-neutral-400 text-xs uppercase tracking-wider mb-2">
                        總營業額 Total Revenue
                      </span>
                      <span
                        className={`${colors.white} text-4xl font-light tracking-wider`}
                      >
                        HK$ {reportData.totalRevenue.toLocaleString()}
                      </span>
                    </div>
                    <div className="bg-neutral-800 p-5 rounded-2xl border border-neutral-700 flex flex-col items-center">
                      <span className="text-neutral-400 text-xs mb-2">
                        全新客數
                      </span>
                      <div className="flex items-baseline gap-1">
                        <span className="text-[#E07A8D] text-3xl font-bold">
                          {reportData.newClients}
                        </span>
                        <span className="text-[10px] text-neutral-500">人</span>
                      </div>
                    </div>
                    <div className="bg-neutral-800 p-5 rounded-2xl border border-neutral-700 flex flex-col items-center">
                      <span className="text-neutral-400 text-xs mb-2">
                        總服務人次
                      </span>
                      <div className="flex items-baseline gap-1">
                        <span className="text-[#C5A47E] text-3xl font-bold">
                          {reportData.totalServices}
                        </span>
                        <span className="text-[10px] text-neutral-500">次</span>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h3
                      className={`${colors.gold} text-sm uppercase tracking-wider font-semibold mb-3 mt-4`}
                    >
                      項目分佈 Service Breakdown
                    </h3>
                    <div className="space-y-5 bg-neutral-900 p-5 rounded-2xl border border-neutral-800">
                      {reportData.breakdown.length > 0 ? (
                        reportData.breakdown.map((item, idx) => (
                          <div key={idx} className="space-y-2">
                            <div className="flex justify-between items-end">
                              <div className="flex items-center gap-2">
                                <div
                                  className={`w-2.5 h-2.5 rounded-full ${
                                    item.color.split(" ")[0] || "bg-neutral-500"
                                  }`}
                                />
                                <span className="text-sm text-white font-medium">
                                  {item.name}
                                </span>
                                <span className="text-[10px] text-neutral-400 bg-neutral-800 px-1.5 py-0.5 rounded border border-neutral-700">
                                  {item.clientCount} 人做過
                                </span>
                              </div>
                              <span className="text-sm font-mono text-white tracking-wide">
                                ${item.revenue.toLocaleString()}
                              </span>
                            </div>
                            <div className="w-full h-1.5 bg-neutral-800 rounded-full overflow-hidden">
                              <div
                                className={`h-full ${
                                  item.color.split(" ")[0] || "bg-neutral-500"
                                }`}
                                style={{
                                  width: `${item.percentage}%`,
                                  transition: "width 1s ease-out",
                                }}
                              />
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="text-center py-6 text-neutral-600">
                          <BarChart2
                            size={32}
                            className="mx-auto mb-2 opacity-20"
                          />
                          <p className="text-xs">此期間暫無收入紀錄</p>
                        </div>
                      )}
                    </div>
                  </div>

                  <div>
                    <h3
                      className={`${colors.gold} text-sm uppercase tracking-wider font-semibold mb-3 mt-6`}
                    >
                      新客來源 Source Breakdown
                    </h3>
                    <div className="space-y-4 bg-neutral-900 p-5 rounded-2xl border border-neutral-800">
                      {reportData.sourceBreakdown?.length > 0 ? (
                        reportData.sourceBreakdown.map((item, idx) => (
                          <div
                            key={idx}
                            className="flex items-center justify-between"
                          >
                            <div className="flex items-center gap-2">
                              <span className="text-sm text-white font-medium">
                                {item.name}
                              </span>
                              <span className="text-[10px] text-neutral-400 bg-neutral-800 px-1.5 py-0.5 rounded border border-neutral-700">
                                {item.count} 人
                              </span>
                            </div>
                            <div className="w-24 h-1.5 bg-neutral-800 rounded-full overflow-hidden">
                              <div
                                className="h-full bg-[#E07A8D]"
                                style={{
                                  width:
                                    reportData.newClients > 0
                                      ? `${
                                          (item.count / reportData.newClients) *
                                          100
                                        }%`
                                      : "0%",
                                  transition: "width 1s ease-out",
                                }}
                              />
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="text-center py-4 text-neutral-600">
                          <p className="text-xs">此期間暫無來源紀錄</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {activeTab === "calendar" && (
          <div className="animate-fade-in h-full flex flex-col">
            {!isFinanceUnlocked ? (
              <PinLock
                icon={<CalendarIcon size={32} />}
                title="月曆鎖定"
                onUnlock={() => setIsFinanceUnlocked(true)}
              />
            ) : (
              <div className="animate-fade-in h-full flex flex-col w-full">
                <div className="flex justify-between items-center mb-6 px-2">
                  <button
                    onClick={() => changeCalendarMonth(-1)}
                    className="p-2 bg-neutral-800 rounded-full text-neutral-400 hover:text-white"
                  >
                    <ChevronLeft />
                  </button>
                  <h2 className={`${colors.white} text-lg font-medium`}>
                    {calendarDate.getFullYear()}年 {calendarDate.getMonth() + 1}
                    月
                  </h2>
                  <button
                    onClick={() => changeCalendarMonth(1)}
                    className="p-2 bg-neutral-800 rounded-full text-neutral-400 hover:text-white"
                  >
                    <ChevronRight />
                  </button>
                </div>

                <div className="flex gap-2 mb-6 px-2">
                  <button
                    onClick={() => setCalendarMode("records")}
                    className={`flex-1 py-2.5 rounded-xl text-sm font-bold transition-all ${
                      calendarMode === "records"
                        ? "bg-[#C5A47E] text-black"
                        : "bg-neutral-800 text-neutral-400"
                    }`}
                  >
                    交易 / 施術紀錄
                  </button>
                  <button
                    onClick={() => setCalendarMode("reminders")}
                    className={`flex-1 py-2.5 rounded-xl text-sm font-bold transition-all relative ${
                      calendarMode === "reminders"
                        ? "bg-[#C5A47E] text-black"
                        : "bg-neutral-800 text-neutral-400"
                    }`}
                  >
                    補色提醒
                    {(monthlyReminders.touchUpDue.length > 0 ||
                      monthlyReminders.voucherExpiring.length > 0 ||
                      monthlyReminders.recallClients.length > 0) && (
                      <span className="absolute -top-1.5 -right-1.5 w-5 h-5 rounded-full bg-red-500 text-white text-[10px] flex items-center justify-center font-bold">
                        {monthlyReminders.touchUpDue.length +
                          monthlyReminders.voucherExpiring.length +
                          monthlyReminders.recallClients.length}
                      </span>
                    )}
                  </button>
                </div>

                {calendarMode === "reminders" ? (
                  <div className="flex-1 overflow-y-auto space-y-6 pb-4">
                    <div>
                      <h3 className="text-amber-400 text-xs uppercase tracking-wider font-semibold mb-3 flex items-center gap-2">
                        <AlertCircle size={14} />
                        本月未約補色 ({monthlyReminders.touchUpDue.length})
                      </h3>
                      <div className="space-y-3">
                        {monthlyReminders.touchUpDue.length === 0 && (
                          <div className="text-center py-6 text-neutral-600 bg-neutral-800/30 rounded-xl border border-dashed border-neutral-700 text-sm">
                            本月暫無未約補色客人
                          </div>
                        )}
                        {monthlyReminders.touchUpDue.map((item) => {
                          const contact = getContactInfo(item);
                          return (
                            <div
                              key={item.id}
                              className="p-4 rounded-xl bg-neutral-800 border border-neutral-700 hover:border-amber-400/50 flex items-start justify-between gap-3"
                            >
                              <div
                                onClick={() => {
                                  if (item.customerId)
                                    handleJumpToClient(item.customerId);
                                }}
                                className="cursor-pointer flex-1 min-w-0"
                              >
                                <div className="flex items-center gap-2 flex-wrap">
                                  <span className="text-white font-medium">
                                    {item.client}
                                  </span>
                                  {item.customerId && (
                                    <span className="text-[10px] bg-neutral-900 text-neutral-400 px-1.5 py-0.5 rounded border border-neutral-600">
                                      {item.customerId}
                                    </span>
                                  )}
                                  <span className="text-[10px] bg-neutral-700 text-neutral-300 px-1.5 py-0.5 rounded">
                                    {item.service}
                                  </span>
                                </div>
                                <div className="text-[11px] text-neutral-500 mt-1">
                                  施術日：{item.serviceDate} ・ 免費補色限期：
                                  <span className="text-amber-400">
                                    {item.deadline}
                                  </span>
                                </div>
                                {contact && (
                                  <div className="text-[11px] text-neutral-400 mt-1">
                                    {contact.label}：{contact.value}
                                  </div>
                                )}
                              </div>
                              <div className="flex flex-col items-end gap-2 flex-none">
                                <button
                                  type="button"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    const message = generateTouchUpReminderMessage({
                                      client: item.client,
                                      deadline: item.deadline,
                                      template: reminderTemplates.touchUp,
                                    });
                                    copyReminderMessage(message, item.client);
                                  }}
                                  className="w-9 h-9 rounded-lg bg-amber-500/10 text-amber-400 border border-amber-500/30 flex items-center justify-center hover:bg-amber-500/20"
                                  title="複製提醒短訊"
                                >
                                  <Copy size={14} />
                                </button>
                                <ReminderStatusToggle
                                  type="touchUp"
                                  itemId={item.id}
                                  status={reminderStatus[`touchUp-${item.id}`]}
                                  onToggle={toggleReminderStatus}
                                />
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>

                    <div>
                      <h3 className="text-[#C5A47E] text-xs uppercase tracking-wider font-semibold mb-3 flex items-center gap-2">
                        <Tag size={14} />
                        補色券即將到期 ({monthlyReminders.voucherExpiring.length})
                      </h3>
                      <div className="space-y-3">
                        {monthlyReminders.voucherExpiring.length === 0 && (
                          <div className="text-center py-6 text-neutral-600 bg-neutral-800/30 rounded-xl border border-dashed border-neutral-700 text-sm">
                            本月暫無補色券到期
                          </div>
                        )}
                        {monthlyReminders.voucherExpiring.map((item) => {
                          const contact = getContactInfo(item);
                          return (
                            <div
                              key={item.key}
                              className="p-4 rounded-xl bg-neutral-800 border border-neutral-700 hover:border-[#C5A47E]/50 flex items-start justify-between gap-3"
                            >
                              <div
                                onClick={() => {
                                  if (item.customerId)
                                    handleJumpToClient(item.customerId);
                                }}
                                className="cursor-pointer flex-1 min-w-0"
                              >
                                <div className="flex items-center gap-2 flex-wrap">
                                  <span className="text-white font-medium">
                                    {item.client}
                                  </span>
                                  {item.customerId && (
                                    <span className="text-[10px] bg-neutral-900 text-neutral-400 px-1.5 py-0.5 rounded border border-neutral-600">
                                      {item.customerId}
                                    </span>
                                  )}
                                </div>
                                <div className="text-[11px] text-neutral-500 mt-1">
                                  購買日：{item.purchaseDate} ・ 到期日：
                                  <span className="text-[#C5A47E]">
                                    {item.expiryDate}
                                  </span>
                                </div>
                                {contact && (
                                  <div className="text-[11px] text-neutral-400 mt-1">
                                    {contact.label}：{contact.value}
                                  </div>
                                )}
                              </div>
                              <div className="flex flex-col items-end gap-2 flex-none">
                                <button
                                  type="button"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    const message = generateVoucherExpiryMessage({
                                      client: item.client,
                                      expiryDate: item.expiryDate,
                                      template: reminderTemplates.voucher,
                                    });
                                    copyReminderMessage(message, item.client);
                                  }}
                                  className="w-9 h-9 rounded-lg bg-[#C5A47E]/10 text-[#C5A47E] border border-[#C5A47E]/30 flex items-center justify-center hover:bg-[#C5A47E]/20"
                                  title="複製提醒短訊"
                                >
                                  <Copy size={14} />
                                </button>
                                <ReminderStatusToggle
                                  type="voucher"
                                  itemId={item.key}
                                  status={reminderStatus[`voucher-${item.key}`]}
                                  onToggle={toggleReminderStatus}
                                />
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>

                    <div>
                      <h3 className="text-sky-400 text-xs uppercase tracking-wider font-semibold mb-3 flex items-center gap-2">
                        <Users size={14} />
                        回頭客提醒 ({monthlyReminders.recallClients.length})
                      </h3>
                      <p className="text-[10px] text-neutral-500 mb-3 -mt-1">
                        一年前呢個月做過補色，之後未見返嚟嘅客人
                      </p>
                      <div className="space-y-3">
                        {monthlyReminders.recallClients.length === 0 && (
                          <div className="text-center py-6 text-neutral-600 bg-neutral-800/30 rounded-xl border border-dashed border-neutral-700 text-sm">
                            暫無需要 recall 嘅客人
                          </div>
                        )}
                        {monthlyReminders.recallClients.map((item) => {
                          const contact = getContactInfo(item);
                          return (
                            <div
                              key={item.id}
                              className="p-4 rounded-xl bg-neutral-800 border border-neutral-700 hover:border-sky-400/50 flex items-start justify-between gap-3"
                            >
                              <div
                                onClick={() => {
                                  if (item.customerId)
                                    handleJumpToClient(item.customerId);
                                }}
                                className="cursor-pointer flex-1 min-w-0"
                              >
                                <div className="flex items-center gap-2 flex-wrap">
                                  <span className="text-white font-medium">
                                    {item.client}
                                  </span>
                                  {item.customerId && (
                                    <span className="text-[10px] bg-neutral-900 text-neutral-400 px-1.5 py-0.5 rounded border border-neutral-600">
                                      {item.customerId}
                                    </span>
                                  )}
                                  <span className="text-[10px] bg-neutral-700 text-neutral-300 px-1.5 py-0.5 rounded">
                                    {item.service}
                                  </span>
                                </div>
                                <div className="text-[11px] text-neutral-500 mt-1">
                                  最後一次補色：
                                  <span className="text-sky-400">
                                    {item.lastServiceDate}
                                  </span>
                                  ・相隔 {formatElapsedTime(item.monthsElapsed)}
                                </div>
                                <div className="text-[11px] text-neutral-400 mt-1">
                                  建議優惠價：
                                  <span className="text-amber-400 font-medium">
                                    ${item.recallPrice}
                                  </span>
                                  <span className="text-neutral-600">
                                    {" "}
                                    ({item.recallTier})
                                  </span>
                                </div>
                                {contact && (
                                  <div className="text-[11px] text-neutral-400 mt-1">
                                    {contact.label}：{contact.value}
                                  </div>
                                )}
                              </div>
                              <div className="flex flex-col items-end gap-2 flex-none">
                                <button
                                  type="button"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    const message = generateRecallMessage({
                                      client: item.client,
                                      lastServiceDate: item.lastServiceDate,
                                      monthsElapsed: item.monthsElapsed,
                                      price: item.recallPrice,
                                      pricing: recallPricing,
                                      template: reminderTemplates.recall,
                                    });
                                    copyReminderMessage(message, item.client);
                                  }}
                                  className="w-9 h-9 rounded-lg bg-sky-500/10 text-sky-400 border border-sky-500/30 flex items-center justify-center hover:bg-sky-500/20"
                                  title="複製提醒短訊"
                                >
                                  <Copy size={14} />
                                </button>
                                <ReminderStatusToggle
                                  type="recall"
                                  itemId={item.id}
                                  status={reminderStatus[`recall-${item.id}`]}
                                  onToggle={toggleReminderStatus}
                                />
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                <div className="grid grid-cols-7 gap-2 text-center mb-6">
                  {["S", "M", "T", "W", "T", "F", "S"].map((d, i) => (
                    <div
                      key={i}
                      className="text-xs text-neutral-600 py-2 font-bold"
                    >
                      {d}
                    </div>
                  ))}
                  {Array(
                    new Date(
                      calendarDate.getFullYear(),
                      calendarDate.getMonth(),
                      1
                    ).getDay()
                  )
                    .fill(null)
                    .map((_, i) => (
                      <div key={`empty-${i}`} />
                    ))}
                  {Array(
                    new Date(
                      calendarDate.getFullYear(),
                      calendarDate.getMonth() + 1,
                      0
                    ).getDate()
                  )
                    .fill(null)
                    .map((_, i) => {
                      const day = i + 1;
                      const dayStr = `${calendarDate.getFullYear()}-${String(
                        calendarDate.getMonth() + 1
                      ).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
                      const hasTrans =
                        transactions.some((t) => t.date === dayStr) ||
                        treatmentRecords.some((r) => r.date === dayStr);
                      const isSelected = selectedCalendarDate === dayStr;
                      return (
                        <div
                          key={day}
                          onClick={() => handleDateClick(dayStr)}
                          className={`aspect-square flex flex-col items-center justify-center rounded-xl relative transition-all duration-300 cursor-pointer ${
                            isSelected
                              ? "bg-white text-black scale-110 shadow-lg z-10"
                              : hasTrans
                              ? "bg-[#C5A47E] text-black font-bold shadow-[0_0_12px_rgba(197,164,126,0.6)] border-2 border-[#fff]/20"
                              : "bg-neutral-800/40 text-neutral-500 border border-neutral-800"
                          }`}
                        >
                          <span className="text-sm">{day}</span>
                          {hasTrans && (
                            <div
                              className={`w-1.5 h-1.5 rounded-full mt-1 ${
                                isSelected ? "bg-[#C5A47E]" : "bg-black"
                              }`}
                            />
                          )}
                        </div>
                      );
                    })}
                </div>
                <div className="mt-4 border-t border-neutral-800 pt-4">
                  <h3
                    className={`${colors.gold} text-xs uppercase tracking-wider font-semibold mb-3 flex items-center gap-2`}
                  >
                    <List size={14} />{" "}
                    {selectedCalendarDate
                      ? `${selectedCalendarDate} 記錄`
                      : "本月記錄"}
                  </h3>
                  <div className="space-y-3">
                    {transactions
                      .filter((t) =>
                        selectedCalendarDate
                          ? t.date === selectedCalendarDate
                          : new Date(t.date).getMonth() ===
                              calendarDate.getMonth() &&
                            new Date(t.date).getFullYear() ===
                              calendarDate.getFullYear()
                      )
                      .sort((a, b) => new Date(b.date) - new Date(a.date))
                      .map((t) => (
                        <TransactionCard
                          key={t.id}
                          t={t}
                          colors={colors}
                          onClick={() => openEditModal(t)}
                          onClientClick={handleJumpToClient}
                        />
                      ))}
                    {treatmentRecords
                      .filter((r) =>
                        selectedCalendarDate
                          ? r.date === selectedCalendarDate
                          : new Date(r.date).getMonth() ===
                              calendarDate.getMonth() &&
                            new Date(r.date).getFullYear() ===
                              calendarDate.getFullYear()
                      )
                      .sort((a, b) => new Date(b.date) - new Date(a.date))
                      .map((r) => (
                        <div
                          key={r.id}
                          onClick={() => {
                            setRecordForm({
                              ...r,
                              beforePhotos: r.beforePhotos || [],
                              afterPhotos: r.afterPhotos || [],
                            });
                            setRecordServiceCat(
                              r.service ? getServiceCategory(r.service) : ""
                            );
                            setShowRecordModal(true);
                          }}
                          className={`p-4 rounded-xl bg-neutral-800 border border-neutral-700 flex justify-between items-center relative overflow-hidden cursor-pointer hover:border-[#C5A47E]/50`}
                        >
                          <div
                            className={`absolute left-0 top-0 bottom-0 w-1 ${
                              r.serviceColor?.split(" ")[0] || "bg-gray-500"
                            }`}
                          />
                          <div className="pl-3">
                            <div className="flex items-center gap-2">
                              <span className="text-white font-medium">
                                {r.client}
                              </span>
                              {r.customerId && (
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleJumpToClient(r.customerId);
                                  }}
                                  className="text-[10px] bg-neutral-900 text-neutral-400 px-1.5 py-0.5 rounded border border-neutral-600 hover:text-white hover:border-[#C5A47E] transition-all"
                                >
                                  {r.customerId}
                                </button>
                              )}
                              <span className="text-[10px] bg-neutral-700 text-neutral-300 px-1.5 py-0.5 rounded">
                                {r.service}
                              </span>
                            </div>
                            <div className="text-[10px] text-neutral-500 mt-1">
                              {r.date} • {r.colorUsed || "未填色料"}
                            </div>
                          </div>
                          <div className="text-right">
                            <span className="text-xs text-[#C5A47E] border border-[#C5A47E]/30 px-2 py-1 rounded-full">
                              施術紀錄
                            </span>
                          </div>
                        </div>
                      ))}
                    {transactions.filter((t) =>
                      selectedCalendarDate
                        ? t.date === selectedCalendarDate
                        : new Date(t.date).getMonth() ===
                          calendarDate.getMonth()
                    ).length === 0 &&
                      treatmentRecords.filter((r) =>
                        selectedCalendarDate
                          ? r.date === selectedCalendarDate
                          : new Date(r.date).getMonth() ===
                            calendarDate.getMonth()
                      ).length === 0 && (
                        <div className="text-center py-8 text-neutral-600 bg-neutral-800/30 rounded-xl border border-dashed border-neutral-700">
                          {selectedCalendarDate ? "該日無記錄" : "本月暫無記錄"}
                        </div>
                      )}
                  </div>
                </div>
                  </>
                )}
              </div>
            )}
          </div>
        )}

        {activeTab === "clients" && (
          <div className="animate-fade-in h-full flex flex-col">
            <div className="sticky top-0 bg-neutral-900 pb-4 z-10 space-y-3">
              <div className="flex items-center gap-2">
                <div
                  className={`flex-1 flex items-center ${colors.card} rounded-xl px-4 py-3 border border-neutral-700`}
                >
                  <Search size={18} className={colors.gold} />
                  <input
                    type="text"
                    placeholder="搜尋客戶 (名 / 電話 / ID)"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="bg-transparent ml-3 outline-none text-white w-full placeholder-neutral-500"
                  />
                  {searchQuery && (
                    <button
                      onClick={() => setSearchQuery("")}
                      className="p-2 text-neutral-500 hover:text-white"
                    >
                      <X size={16} />
                    </button>
                  )}
                </div>
                <button
                  onClick={openNewClientModal}
                  className={`p-3 rounded-xl ${colors.goldBg} text-black shadow-lg active:scale-95 transition-transform flex-none`}
                >
                  <Plus size={20} />
                </button>
              </div>
              <div className="flex bg-neutral-800 p-1 rounded-lg border border-neutral-700">
                <button
                  onClick={() => setSortOption("latest")}
                  className={`flex-1 py-1.5 text-xs rounded-md transition-all font-medium ${
                    sortOption === "latest"
                      ? "bg-[#C5A47E] text-black shadow-sm"
                      : "text-neutral-400 hover:text-white"
                  }`}
                >
                  最新編輯
                </button>
                <button
                  onClick={() =>
                    setSortOption(
                      sortOption === "id_asc" ? "id_desc" : "id_asc"
                    )
                  }
                  className={`flex-1 py-1.5 text-xs rounded-md transition-all font-medium flex items-center justify-center gap-1 ${
                    sortOption.includes("id")
                      ? "bg-[#C5A47E] text-black shadow-sm"
                      : "text-neutral-400 hover:text-white"
                  }`}
                >
                  號碼順序
                  {sortOption === "id_asc" && <ArrowUp size={12} />}
                  {sortOption === "id_desc" && <ArrowDown size={12} />}
                </button>
              </div>
            </div>
            <div className="space-y-3 flex-1 pt-2 overflow-y-auto">
              {clients.length > 0 ? (
                clients
                  .filter((c) => {
                    const q = searchQuery.toLowerCase().trim();
                    if (q === "v") return c.tagV === true;
                    return (
                      c.name?.toLowerCase().includes(q) ||
                      c.phone?.includes(q) ||
                      c.id?.toLowerCase().includes(q)
                    );
                  })
                  .sort((a, b) => {
                    if (sortOption === "id_asc" || sortOption === "id_desc") {
                      const multiplier = sortOption === "id_asc" ? 1 : -1;
                      if (!a.id) return 1;
                      if (!b.id) return -1;
                      const numA = parseInt(a.id);
                      const numB = parseInt(b.id);
                      if (!isNaN(numA) && !isNaN(numB))
                        return (numA - numB) * multiplier;
                      return a.id.localeCompare(b.id) * multiplier;
                    } else {
                      const dateA = a.lastActivity || "0000-00-00";
                      const dateB = b.lastActivity || "0000-00-00";
                      if (dateB !== dateA) return dateB.localeCompare(dateA);
                      return parseInt(b.id || 0) - parseInt(a.id || 0);
                    }
                  })
                  .map((client, idx) => (
                    <div
                      key={idx}
                      onClick={() => openClientFile(client)}
                      className={`p-4 rounded-xl ${colors.card} border border-neutral-800 flex justify-between items-center active:scale-95 transition-transform cursor-pointer`}
                    >
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-full bg-[#C5A47E]/20 text-[#C5A47E] flex items-center justify-center font-bold">
                          {client.name.charAt(0)}
                        </div>
                        <div>
                          <div className="flex items-center gap-2">
                            <span className={`${colors.white} font-medium`}>
                              {client.name}
                            </span>
                            {client.id && (
                              <span className="text-[10px] bg-neutral-900 text-neutral-400 px-1 rounded border border-neutral-700">
                                {client.id}
                              </span>
                            )}
                          </div>
                          <p className={`text-xs ${colors.gray}`}>
                            {client.phone}
                          </p>
                        </div>
                      </div>
                      <ChevronRight size={18} className="text-neutral-600" />
                    </div>
                  ))
              ) : (
                <div className="text-center text-neutral-500 mt-10">
                  <Users size={48} className="mx-auto mb-2 opacity-20" />
                  <p>未找到客戶</p>
                </div>
              )}
            </div>
          </div>
        )}

        {activeTab === "settings" && (
          <div className="animate-fade-in space-y-6">
            <div
              className={`p-5 rounded-2xl ${colors.card} border border-neutral-700`}
            >
              <h3
                className={`${colors.gold} text-lg font-medium mb-4 flex items-center gap-2`}
              >
                <Tag size={20} /> 常用字彙管理
              </h3>
              <div className="space-y-4">
                <div>
                  <h4 className="text-xs text-neutral-400 mb-2">
                    配色 (Color)
                  </h4>
                  <div className="flex flex-wrap gap-2">
                    {colorPresets.map((p) => (
                      <button
                        key={p}
                        onClick={async () =>
                          (await showDialog({
                            title: `刪除「${p}」`,
                            message: "確定刪除此配色預設？",
                            confirmLabel: "刪除",
                            type: "danger",
                          })) && deletePreset("color", p)
                        }
                        className="text-xs bg-neutral-900 border border-neutral-700 text-white px-3 py-1 rounded-full hover:bg-red-900/20 hover:border-red-800"
                      >
                        {p}{" "}
                        <X size={10} className="inline ml-1 text-neutral-500" />
                      </button>
                    ))}
                  </div>
                </div>
                <div>
                  <h4 className="text-xs text-neutral-400 mb-2">
                    工具 (Tools)
                  </h4>
                  <div className="flex flex-wrap gap-2">
                    {toolPresets.map((p) => (
                      <button
                        key={p}
                        onClick={async () =>
                          (await showDialog({
                            title: `刪除「${p}」`,
                            message: "確定刪除此工具預設？",
                            confirmLabel: "刪除",
                            type: "danger",
                          })) && deletePreset("tool", p)
                        }
                        className="text-xs bg-neutral-900 border border-neutral-700 text-white px-3 py-1 rounded-full hover:bg-red-900/20 hover:border-red-800"
                      >
                        {p}{" "}
                        <X size={10} className="inline ml-1 text-neutral-500" />
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div
              className={`p-5 rounded-2xl ${colors.card} border border-neutral-700`}
            >
              <h3
                className={`${colors.gold} text-lg font-medium mb-4 flex items-center gap-2`}
              >
                <Sliders size={20} /> 系統參數
              </h3>
              <div className="flex items-center justify-between bg-neutral-900 p-3 rounded-lg border border-neutral-800">
                <span className="text-neutral-300 text-sm">
                  預設訂金金額 Default Deposit
                </span>
                <div className="flex items-center border border-neutral-600 rounded bg-neutral-800 w-24 px-2">
                  <span className="text-neutral-500 text-xs">$</span>
                  <input
                    type="number"
                    value={defaultDeposit}
                    onChange={(e) => handleUpdateDefaultDeposit(e.target.value)}
                    className="bg-transparent text-white text-right w-full py-1 outline-none"
                  />
                </div>
              </div>
            </div>

            <div
              className={`p-5 rounded-2xl ${colors.card} border border-neutral-700`}
            >
              <h3
                className={`${colors.gold} text-lg font-medium mb-1 flex items-center gap-2`}
              >
                <Tag size={20} /> 回頭客優惠價錢
              </h3>
              <p className="text-[10px] text-neutral-500 mb-4">
                「回頭客提醒」短訊入面顯示同自動配對嘅價錢，可以隨時自己改
              </p>
              <div className="space-y-2">
                {[
                  { field: "price6m", label: "6個月內" },
                  { field: "price12m", label: "12個月內" },
                  { field: "price18m", label: "18個月內" },
                ].map(({ field, label }) => (
                  <div
                    key={field}
                    className="flex items-center justify-between bg-neutral-900 p-3 rounded-lg border border-neutral-800"
                  >
                    <span className="text-neutral-300 text-sm">{label}</span>
                    <div className="flex items-center border border-neutral-600 rounded bg-neutral-800 w-24 px-2">
                      <span className="text-neutral-500 text-xs">$</span>
                      <input
                        type="number"
                        value={recallPricing[field]}
                        onChange={(e) =>
                          handleUpdateRecallPricing(field, e.target.value)
                        }
                        className="bg-transparent text-white text-right w-full py-1 outline-none"
                      />
                    </div>
                  </div>
                ))}
                <div className="flex items-center justify-between bg-neutral-900 p-3 rounded-lg border border-neutral-800">
                  <span className="text-neutral-300 text-sm">
                    超過18個月（原價減）
                  </span>
                  <div className="flex items-center border border-neutral-600 rounded bg-neutral-800 w-24 px-2">
                    <span className="text-neutral-500 text-xs">$</span>
                    <input
                      type="number"
                      value={recallPricing.discountOver18m}
                      onChange={(e) =>
                        handleUpdateRecallPricing(
                          "discountOver18m",
                          e.target.value
                        )
                      }
                      className="bg-transparent text-white text-right w-full py-1 outline-none"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div
              className={`p-5 rounded-2xl ${colors.card} border border-neutral-700`}
            >
              <h3
                className={`${colors.gold} text-lg font-medium mb-1 flex items-center gap-2`}
              >
                <MessageCircle size={20} /> 提醒短訊內容
              </h3>
              <p className="text-[10px] text-neutral-500 mb-4">
                自己改內容都得，用 {"{placeholder}"} 就會自動填返客人資料
              </p>
              <div className="space-y-5">
                <div>
                  <div className="flex items-center justify-between mb-1.5">
                    <span className="text-sm text-white font-medium">
                      補色提醒
                    </span>
                    <button
                      onClick={() =>
                        handleUpdateReminderTemplate("touchUp", "")
                      }
                      className="text-[10px] text-neutral-500 underline hover:text-white"
                    >
                      還原預設
                    </button>
                  </div>
                  <p className="text-[10px] text-neutral-500 mb-1.5">
                    可用：{"{client}"} {"{deadline}"}
                  </p>
                  <textarea
                    rows={5}
                    value={
                      reminderTemplates.touchUp || DEFAULT_TOUCHUP_TEMPLATE
                    }
                    onChange={(e) =>
                      handleUpdateReminderTemplate("touchUp", e.target.value)
                    }
                    className={`w-full ${colors.inputBg} rounded-lg p-3 border border-neutral-600 text-white outline-none text-xs resize-y font-mono`}
                  />
                </div>
                <div>
                  <div className="flex items-center justify-between mb-1.5">
                    <span className="text-sm text-white font-medium">
                      補色券提醒
                    </span>
                    <button
                      onClick={() =>
                        handleUpdateReminderTemplate("voucher", "")
                      }
                      className="text-[10px] text-neutral-500 underline hover:text-white"
                    >
                      還原預設
                    </button>
                  </div>
                  <p className="text-[10px] text-neutral-500 mb-1.5">
                    可用：{"{client}"} {"{expiryDate}"}
                  </p>
                  <textarea
                    rows={5}
                    value={
                      reminderTemplates.voucher || DEFAULT_VOUCHER_TEMPLATE
                    }
                    onChange={(e) =>
                      handleUpdateReminderTemplate("voucher", e.target.value)
                    }
                    className={`w-full ${colors.inputBg} rounded-lg p-3 border border-neutral-600 text-white outline-none text-xs resize-y font-mono`}
                  />
                </div>
                <div>
                  <div className="flex items-center justify-between mb-1.5">
                    <span className="text-sm text-white font-medium">
                      回頭客提醒
                    </span>
                    <button
                      onClick={() =>
                        handleUpdateReminderTemplate("recall", "")
                      }
                      className="text-[10px] text-neutral-500 underline hover:text-white"
                    >
                      還原預設
                    </button>
                  </div>
                  <p className="text-[10px] text-neutral-500 mb-1.5">
                    可用：{"{client}"} {"{lastServiceDate}"} {"{timeElapsed}"}{" "}
                    {"{price}"} {"{tier6}"} {"{tier12}"} {"{tier18}"}{" "}
                    {"{plus6Months}"} {"{plus12Months}"} {"{plus18Months}"}
                  </p>
                  <textarea
                    rows={7}
                    value={reminderTemplates.recall || DEFAULT_RECALL_TEMPLATE}
                    onChange={(e) =>
                      handleUpdateReminderTemplate("recall", e.target.value)
                    }
                    className={`w-full ${colors.inputBg} rounded-lg p-3 border border-neutral-600 text-white outline-none text-xs resize-y font-mono`}
                  />
                </div>
              </div>
            </div>

            <div
              className={`p-5 rounded-2xl ${colors.card} border border-neutral-700`}
            >
              <div className="flex justify-between items-center mb-4">
                <h3
                  className={`${colors.gold} text-lg font-medium flex items-center gap-2`}
                >
                  <Palette size={20} /> 服務項目管理
                </h3>
              </div>
              <div className="space-y-3">
                {services.map((s) => (
                  <div
                    key={s.id}
                    className="flex flex-col gap-2 bg-neutral-900 p-3 rounded-lg border border-neutral-800"
                  >
                    {tempEditingService && tempEditingService.id === s.id ? (
                      <div className="flex flex-col gap-3 w-full animate-fade-in">
                        <div className="flex gap-2">
                          <input
                            value={tempEditingService.name}
                            onChange={(e) =>
                              setTempEditingService({
                                ...tempEditingService,
                                name: e.target.value,
                              })
                            }
                            className="bg-neutral-800 text-white rounded p-2 flex-1 border border-[#C5A47E] outline-none"
                          />
                          <input
                            type="number"
                            value={tempEditingService.price}
                            onChange={(e) =>
                              setTempEditingService({
                                ...tempEditingService,
                                price: e.target.value,
                              })
                            }
                            className="bg-neutral-800 text-white w-20 p-2 text-center rounded border border-[#C5A47E] outline-none"
                          />
                          <button
                            onClick={saveEditingService}
                            className="text-black bg-[#C5A47E] p-2 rounded hover:bg-[#b08d66]"
                          >
                            <Check size={18} />
                          </button>
                          <button
                            onClick={cancelEditingService}
                            className="text-neutral-400 p-2 hover:text-white"
                          >
                            <X size={18} />
                          </button>
                        </div>
                        <div className="flex flex-wrap gap-2 mt-1">
                          {COLOR_PALETTE.map((c) => (
                            <button
                              key={c}
                              onClick={() =>
                                setTempEditingService({
                                  ...tempEditingService,
                                  color: c,
                                })
                              }
                              className={`w-6 h-6 rounded-full border-2 ${
                                c.split(" ")[0]
                              } ${
                                tempEditingService.color === c
                                  ? "border-white scale-110"
                                  : "border-transparent opacity-50 hover:opacity-100"
                              }`}
                            />
                          ))}
                        </div>
                      </div>
                    ) : (
                      <div className="flex justify-between items-center">
                        <div className="flex items-center gap-3">
                          <div
                            className={`w-3 h-3 rounded-full ${
                              s.color.split(" ")[0]
                            }`}
                          />
                          <span className="text-white">{s.name}</span>
                        </div>
                        <div className="flex items-center gap-3">
                          <span className={`${colors.gold} font-mono`}>
                            ${s.price}
                          </span>
                          <button
                            onClick={() => startEditingService(s)}
                            className="text-neutral-500 hover:text-white"
                          >
                            <Edit2 size={14} />
                          </button>
                          <button
                            onClick={() => handleDeleteService(s.id)}
                            className="text-neutral-500 hover:text-red-400 ml-1"
                          >
                            <Trash2 size={14} />
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
              <div className="mt-4 pt-4 border-t border-neutral-700">
                <h4 className="text-white text-sm mb-3">新增項目</h4>
                <div className="flex gap-2 mb-3">
                  <input
                    type="text"
                    placeholder="名稱"
                    value={newService.name}
                    onChange={(e) =>
                      setNewService({ ...newService, name: e.target.value })
                    }
                    className="bg-neutral-900 text-white px-3 py-2 rounded-lg border border-neutral-600 w-full outline-none text-sm"
                  />
                  <input
                    type="number"
                    placeholder="價錢"
                    value={newService.price}
                    onChange={(e) =>
                      setNewService({ ...newService, price: e.target.value })
                    }
                    className="bg-neutral-900 text-white px-3 py-2 rounded-lg border border-neutral-600 w-24 outline-none text-sm"
                  />
                </div>
                <div className="flex flex-wrap gap-2 mb-3">
                  {COLOR_PALETTE.map((c) => (
                    <button
                      key={c}
                      onClick={() => setNewService({ ...newService, color: c })}
                      className={`w-6 h-6 rounded-full border-2 ${
                        c.split(" ")[0]
                      } ${
                        newService.color === c
                          ? "border-white scale-110"
                          : "border-transparent opacity-50 hover:opacity-100"
                      }`}
                    />
                  ))}
                </div>
                <button
                  onClick={handleAddService}
                  className={`w-full py-2 rounded-lg ${colors.goldBg} text-black font-medium text-sm`}
                >
                  + 加入列表
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="fixed bottom-0 left-0 w-full h-20 bg-neutral-900 border-t border-neutral-800 flex items-center px-4 z-30">
        <div className="flex justify-between w-[85%] pr-2">
          <NavButton
            icon={<Users size={20} />}
            label="客戶"
            active={activeTab === "clients"}
            onClick={() => setActiveTab("clients")}
            colors={colors}
          />
          <NavButton
            icon={<CalendarIcon size={20} />}
            label="月曆"
            active={activeTab === "calendar"}
            onClick={() => setActiveTab("calendar")}
            colors={colors}
          />
          <NavButton
            icon={<PieChart size={20} />}
            label="財務"
            active={activeTab === "home"}
            onClick={() => setActiveTab("home")}
            colors={colors}
          />
          <NavButton
            icon={<BarChart2 size={20} />}
            label="報表"
            active={activeTab === "stats"}
            onClick={() => setActiveTab("stats")}
            colors={colors}
          />
        </div>
      </div>

      {activeTab === "home" && (
        <button
          onClick={openAddModal}
          className={`fixed bottom-24 right-6 w-14 h-14 ${colors.goldBg} rounded-full flex items-center justify-center shadow-[0_0_20px_rgba(197,164,126,0.4)] hover:scale-105 transition-transform z-50`}
        >
          <Plus color="#1a1a1a" size={28} />
        </button>
      )}

      {showModal && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-fade-in">
          <div
            className={`w-full max-w-md ${colors.card} max-h-[90vh] rounded-2xl flex flex-col border border-[#C5A47E]/30`}
          >
            <div className="flex-none flex justify-between items-center p-5 border-b border-neutral-700 bg-neutral-900/50 rounded-t-2xl">
              <h3 className={`${colors.white} text-xl font-medium`}>
                {transForm.id ? "修改收款" : "新增收款"}
              </h3>
              <button
                onClick={() => setShowModal(false)}
                type="button"
                className="p-2 bg-neutral-700 rounded-full text-neutral-400 hover:text-white"
              >
                <X size={20} />
              </button>
            </div>
            <div className="flex-1 overflow-y-auto p-5 space-y-4 custom-scrollbar">
              {!transForm.id && (
                <div className="bg-neutral-900 p-1 rounded-lg flex mb-2 border border-neutral-700">
                  {["single", "split"].map((mode) => (
                    <button
                      key={mode}
                      type="button"
                      onClick={() => setTransForm({ ...transForm, mode })}
                      className={`flex-1 py-2 text-xs rounded transition-all ${
                        transForm.mode === mode
                          ? "bg-[#C5A47E] text-black font-bold"
                          : "text-neutral-500"
                      }`}
                    >
                      {mode === "single" ? "單次收款" : "補錄訂金 + 尾數"}
                    </button>
                  ))}
                </div>
              )}
              <div className="flex gap-2">
                <div className="flex-1 space-y-1">
                  <label
                    className={`text-[10px] ${colors.gold} uppercase tracking-wide flex items-center gap-1`}
                  >
                    <Hash size={10} /> 客戶編號 ID
                  </label>
                  <input
                    type="text"
                    placeholder="輸入編號自動填寫"
                    value={transForm.customerId}
                    onChange={handleTransIdChange}
                    className={`w-full ${colors.inputBg} rounded-lg p-3 border border-neutral-600 text-white outline-none text-sm focus:border-[#C5A47E] transition-colors`}
                  />
                </div>
                <div className="flex-1 space-y-1">
                  <label
                    className={`text-[10px] ${colors.gold} uppercase tracking-wide`}
                  >
                    客人類別
                  </label>
                  <div className="flex bg-neutral-900 rounded-lg p-1 border border-neutral-600 h-[46px]">
                    {["new", "old"].map((type) => (
                      <button
                        type="button"
                        key={type}
                        onClick={() =>
                          setTransForm({ ...transForm, customerType: type })
                        }
                        className={`flex-1 rounded text-xs transition-all ${
                          transForm.customerType === type
                            ? "bg-[#C5A47E] text-black font-bold"
                            : "text-neutral-500"
                        }`}
                      >
                        {type === "new" ? "新客" : "舊客"}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div className="space-y-1">
                  <label
                    className={`text-[10px] ${colors.gold} uppercase tracking-wide`}
                  >
                    客名 Name
                  </label>
                  <input
                    type="text"
                    value={transForm.client}
                    onChange={(e) =>
                      setTransForm({ ...transForm, client: e.target.value })
                    }
                    className={`w-full ${colors.inputBg} rounded-lg p-3 border border-neutral-600 text-white outline-none text-sm`}
                  />
                </div>
                <div className="space-y-1">
                  <label
                    className={`text-[10px] ${colors.gold} uppercase tracking-wide`}
                  >
                    電話 Phone
                  </label>
                  <input
                    type="tel"
                    value={transForm.phone}
                    onChange={(e) =>
                      setTransForm({ ...transForm, phone: e.target.value })
                    }
                    className={`w-full ${colors.inputBg} rounded-lg p-3 border border-neutral-600 text-white outline-none text-sm`}
                  />
                </div>
              </div>
              <div className="space-y-2">
                <label
                  className={`text-[10px] ${colors.gold} uppercase tracking-wide`}
                >
                  服務項目 Service
                </label>
                <div className="flex flex-wrap gap-2">
                  {CATEGORY_LABELS.filter((cat) =>
                    services.some((s) => getServiceCategory(s.name) === cat)
                  ).map((cat) => (
                    <button
                      key={cat}
                      type="button"
                      onClick={() =>
                        setTransServiceCat(transServiceCat === cat ? "" : cat)
                      }
                      className={`px-4 py-2 rounded-full text-sm font-medium border transition-all ${
                        transServiceCat === cat
                          ? "bg-[#C5A47E] text-black border-[#C5A47E]"
                          : "border-neutral-700 text-neutral-400 bg-neutral-900 hover:border-[#C5A47E]"
                      }`}
                    >
                      {cat}
                    </button>
                  ))}
                </div>
                {transServiceCat && (
                  <div className="animate-fade-in">
                    <div className="flex justify-end mb-2">
                      <button
                        type="button"
                        onClick={() =>
                          setIsEditingServiceOrder(!isEditingServiceOrder)
                        }
                        className={`text-[10px] px-2 py-0.5 rounded-full flex items-center gap-1 transition-all ${
                          isEditingServiceOrder
                            ? "bg-[#C5A47E] text-black"
                            : "bg-neutral-800 text-neutral-400"
                        }`}
                      >
                        <Move size={10} />{" "}
                        {isEditingServiceOrder ? "完成排序" : "調整次序"}
                      </button>
                    </div>
                    <div className="grid grid-cols-1 gap-2">
                      {services
                        .filter(
                          (s) => getServiceCategory(s.name) === transServiceCat
                        )
                        .map((svc, idx, arr) => (
                          <div
                            key={svc.id}
                            draggable={isEditingServiceOrder}
                            onDragStart={() =>
                              (serviceDragItem.current = services.indexOf(svc))
                            }
                            onDragEnter={() =>
                              (serviceDragOverItem.current =
                                services.indexOf(svc))
                            }
                            onDragEnd={handleServiceDragEnd}
                            onDragOver={(e) => e.preventDefault()}
                            className={`flex items-center gap-2 ${
                              isEditingServiceOrder ? "cursor-move" : ""
                            }`}
                          >
                            {isEditingServiceOrder && (
                              <div className="flex flex-col gap-1">
                                <button
                                  type="button"
                                  onClick={async () => {
                                    if (idx === 0) return;
                                    const globalIdx = services.indexOf(svc);
                                    const prevInCat = arr[idx - 1];
                                    const prevGlobalIdx =
                                      services.indexOf(prevInCat);
                                    const list = [...services];
                                    [list[globalIdx], list[prevGlobalIdx]] = [
                                      list[prevGlobalIdx],
                                      list[globalIdx],
                                    ];
                                    setServices(list);
                                    if (db) {
                                      const batch = writeBatch(db);
                                      list.forEach((s, i) =>
                                        batch.update(
                                          doc(db, "services", String(s.id)),
                                          { order: i }
                                        )
                                      );
                                      await batch.commit();
                                    }
                                  }}
                                  className="text-neutral-400 hover:text-white p-0.5"
                                >
                                  <ArrowUp size={12} />
                                </button>
                                <button
                                  type="button"
                                  onClick={async () => {
                                    if (idx === arr.length - 1) return;
                                    const globalIdx = services.indexOf(svc);
                                    const nextInCat = arr[idx + 1];
                                    const nextGlobalIdx =
                                      services.indexOf(nextInCat);
                                    const list = [...services];
                                    [list[globalIdx], list[nextGlobalIdx]] = [
                                      list[nextGlobalIdx],
                                      list[globalIdx],
                                    ];
                                    setServices(list);
                                    if (db) {
                                      const batch = writeBatch(db);
                                      list.forEach((s, i) =>
                                        batch.update(
                                          doc(db, "services", String(s.id)),
                                          { order: i }
                                        )
                                      );
                                      await batch.commit();
                                    }
                                  }}
                                  className="text-neutral-400 hover:text-white p-0.5"
                                >
                                  <ArrowDown size={12} />
                                </button>
                              </div>
                            )}
                            <button
                              type="button"
                              onClick={() =>
                                !isEditingServiceOrder &&
                                handleServiceSelectTrans(svc)
                              }
                              className={`flex-1 p-3 rounded-lg text-left border text-sm flex items-center justify-between transition-all ${
                                transForm.service === svc.name
                                  ? `${svc.color} border-white shadow-md`
                                  : "border-neutral-700 bg-neutral-900 text-neutral-400"
                              } ${
                                isEditingServiceOrder
                                  ? "opacity-70 cursor-move"
                                  : ""
                              }`}
                            >
                              <span className="font-medium">{svc.name}</span>
                              <div className="flex items-center gap-2">
                                <span className="text-xs opacity-75">
                                  ${svc.price}
                                </span>
                                {transForm.service === svc.name &&
                                  !isEditingServiceOrder && <Check size={14} />}
                                {isEditingServiceOrder && (
                                  <Move
                                    size={12}
                                    className="text-neutral-500"
                                  />
                                )}
                              </div>
                            </button>
                          </div>
                        ))}
                    </div>
                  </div>
                )}
                {transForm.service && (
                  <p className="text-xs text-[#C5A47E] text-center pt-1">
                    ✓ 已選：{transForm.service}
                  </p>
                )}
              </div>

              {transForm.mode === "single" && (
                <>
                  <div className="space-y-1">
                    <label
                      className={`text-[10px] ${colors.gold} uppercase tracking-wide`}
                    >
                      日期 Date
                    </label>
                    <input
                      type="date"
                      value={transForm.date}
                      onChange={(e) =>
                        setTransForm({ ...transForm, date: e.target.value })
                      }
                      className={`w-full ${colors.inputBg} rounded-lg p-3 border border-neutral-600 text-white outline-none`}
                    />
                  </div>
                  <div className="bg-neutral-900 p-4 rounded-xl border border-neutral-700 space-y-4">
                    <div className="flex bg-neutral-800 rounded p-1">
                      {["訂金", "尾數", "全數"].map((type) => (
                        <button
                          type="button"
                          key={type}
                          onClick={() => setTransForm({ ...transForm, type })}
                          className={`flex-1 py-1.5 text-xs rounded transition-all ${
                            transForm.type === type
                              ? "bg-[#C5A47E] text-black font-bold"
                              : "text-neutral-500"
                          }`}
                        >
                          {type}
                        </button>
                      ))}
                    </div>
                    <div className="flex items-center border-b border-[#C5A47E]">
                      <span className={`${colors.gold} text-xl mr-2`}>$</span>
                      <input
                        type="number"
                        value={transForm.amount}
                        onChange={(e) =>
                          setTransForm({ ...transForm, amount: e.target.value })
                        }
                        className={`bg-transparent w-full text-2xl font-light ${colors.white} outline-none`}
                      />
                    </div>
                    <div className="flex gap-2">
                      {["Cash", "FPS", "PayMe"].map((m) => (
                        <button
                          type="button"
                          key={m}
                          onClick={() =>
                            setTransForm({ ...transForm, method: m })
                          }
                          className={`flex-1 py-2 rounded border text-[10px] font-bold ${
                            transForm.method === m
                              ? "border-neutral-400 text-white bg-neutral-700"
                              : "border-neutral-700 text-neutral-500"
                          }`}
                        >
                          {m}
                        </button>
                      ))}
                    </div>
                    {!transForm.id && (
                      <button
                        type="button"
                        onClick={() =>
                          setTransForm({
                            ...transForm,
                            isMixedSingle: !transForm.isMixedSingle,
                          })
                        }
                        className="text-[#C5A47E] text-xs underline mt-2 block hover:text-white transition-colors"
                      >
                        {transForm.isMixedSingle
                          ? "- 取消混合收款"
                          : "+ 新增混合收款 (如: 部份現金、部份PayMe)"}
                      </button>
                    )}
                    {transForm.isMixedSingle && !transForm.id && (
                      <div className="mt-4 pt-4 border-t border-neutral-700 animate-fade-in">
                        <label className="text-[10px] text-neutral-400 block mb-2">
                          第二筆付款
                        </label>
                        <div className="flex items-center border-b border-[#C5A47E]">
                          <span className={`${colors.gold} text-xl mr-2`}>
                            $
                          </span>
                          <input
                            type="number"
                            placeholder="輸入第二筆金額"
                            value={transForm.amount2}
                            onChange={(e) =>
                              setTransForm({
                                ...transForm,
                                amount2: e.target.value,
                              })
                            }
                            className={`bg-transparent w-full text-2xl font-light ${colors.white} outline-none`}
                          />
                        </div>
                        <div className="flex gap-2 mt-3">
                          {["Cash", "FPS", "PayMe"].map((m) => (
                            <button
                              type="button"
                              key={m}
                              onClick={() =>
                                setTransForm({ ...transForm, method2: m })
                              }
                              className={`flex-1 py-2 rounded border text-[10px] font-bold ${
                                transForm.method2 === m
                                  ? "border-[#C5A47E] text-[#C5A47E] bg-[#C5A47E]/10"
                                  : "border-neutral-700 text-neutral-500"
                              }`}
                            >
                              {m}
                            </button>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </>
              )}

              {transForm.mode === "split" && (
                <div className="space-y-4">
                  <div className="p-4 rounded-xl bg-neutral-900 border border-neutral-700 relative">
                    <div className="absolute top-0 left-0 bg-[#C5A47E] text-black text-[10px] font-bold px-2 py-1 rounded-br-lg rounded-tl-lg">
                      A. 補錄訂金
                    </div>
                    <div className="mt-4 space-y-3">
                      <div className="flex gap-2">
                        <input
                          type="date"
                          value={transForm.depositDate}
                          onChange={(e) =>
                            setTransForm({
                              ...transForm,
                              depositDate: e.target.value,
                            })
                          }
                          className={`w-[60%] ${colors.inputBg} rounded-lg p-2 border border-neutral-600 text-white outline-none text-xs`}
                        />
                        <div className="w-[40%] flex items-center bg-neutral-900 border border-neutral-600 rounded-lg px-2">
                          <span className="text-neutral-500 text-xs">$</span>
                          <input
                            type="number"
                            value={transForm.depositAmount}
                            onChange={(e) =>
                              setTransForm({
                                ...transForm,
                                depositAmount: e.target.value,
                              })
                            }
                            className="bg-transparent w-full outline-none text-white text-right text-xs"
                          />
                        </div>
                      </div>
                      <div className="flex gap-1">
                        {["PayMe", "FPS", "Cash"].map((m) => (
                          <button
                            type="button"
                            key={m}
                            onClick={() =>
                              setTransForm({ ...transForm, depositMethod: m })
                            }
                            className={`flex-1 py-1.5 rounded border text-[10px] ${
                              transForm.depositMethod === m
                                ? "border-[#C5A47E] text-[#C5A47E] bg-[#C5A47E]/10"
                                : "border-neutral-700 text-neutral-500"
                            }`}
                          >
                            {m}
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="p-4 rounded-xl bg-neutral-900 border border-neutral-700 relative">
                    <div className="absolute top-0 left-0 bg-neutral-700 text-white text-[10px] font-bold px-2 py-1 rounded-br-lg rounded-tl-lg">
                      B. 今日尾數
                    </div>
                    <div className="mt-4 space-y-3">
                      <div className="flex gap-2">
                        <input
                          type="date"
                          value={transForm.balanceDate}
                          onChange={(e) =>
                            setTransForm({
                              ...transForm,
                              balanceDate: e.target.value,
                            })
                          }
                          className={`w-[60%] ${colors.inputBg} rounded-lg p-2 border border-neutral-600 text-white outline-none text-xs`}
                        />
                        <div className="w-[40%] flex items-center bg-neutral-900 border border-neutral-600 rounded-lg px-2">
                          <span className="text-neutral-500 text-xs">$</span>
                          <input
                            type="number"
                            value={transForm.balanceAmount}
                            onChange={(e) =>
                              setTransForm({
                                ...transForm,
                                balanceAmount: e.target.value,
                              })
                            }
                            className="bg-transparent w-full outline-none text-white text-right text-xs"
                          />
                        </div>
                      </div>
                      <div className="flex gap-1">
                        {["Cash", "FPS", "PayMe"].map((m) => (
                          <button
                            type="button"
                            key={m}
                            onClick={() =>
                              setTransForm({ ...transForm, balanceMethod: m })
                            }
                            className={`flex-1 py-1.5 rounded border text-[10px] ${
                              transForm.balanceMethod === m
                                ? "border-green-500 text-green-400 bg-green-900/20"
                                : "border-neutral-700 text-neutral-500"
                            }`}
                          >
                            {m}
                          </button>
                        ))}
                      </div>
                      <button
                        type="button"
                        onClick={() =>
                          setTransForm({
                            ...transForm,
                            isMixedBalance: !transForm.isMixedBalance,
                          })
                        }
                        className="text-[#C5A47E] text-[10px] underline mt-3 block hover:text-white transition-colors"
                      >
                        {transForm.isMixedBalance
                          ? "- 取消混合收款"
                          : "+ 新增混合收款 (如: 尾數部分現金、部分PayMe)"}
                      </button>
                      {transForm.isMixedBalance && (
                        <div className="mt-3 pt-3 border-t border-neutral-700 space-y-2 animate-fade-in">
                          <div className="flex gap-2 justify-end">
                            <div className="w-[60%] text-[10px] text-neutral-500 flex items-center justify-end pr-2">
                              第二筆尾數付款:
                            </div>
                            <div className="w-[40%] flex items-center bg-neutral-900 border border-[#C5A47E] rounded-lg px-2 py-1">
                              <span className="text-[#C5A47E] text-xs">$</span>
                              <input
                                type="number"
                                placeholder="金額"
                                value={transForm.balanceAmount2}
                                onChange={(e) =>
                                  setTransForm({
                                    ...transForm,
                                    balanceAmount2: e.target.value,
                                  })
                                }
                                className="bg-transparent w-full outline-none text-white text-right text-xs"
                              />
                            </div>
                          </div>
                          <div className="flex gap-1">
                            {["PayMe", "FPS", "Cash"].map((m) => (
                              <button
                                type="button"
                                key={m}
                                onClick={() =>
                                  setTransForm({
                                    ...transForm,
                                    balanceMethod2: m,
                                  })
                                }
                                className={`flex-1 py-1.5 rounded border text-[10px] ${
                                  transForm.balanceMethod2 === m
                                    ? "border-[#C5A47E] text-[#C5A47E] bg-[#C5A47E]/10"
                                    : "border-neutral-700 text-neutral-500"
                                }`}
                              >
                                {m}
                              </button>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              <div className="space-y-1 mt-2 pt-4 border-t border-neutral-700">
                <label
                  className={`text-[10px] ${colors.gold} uppercase tracking-wide`}
                >
                  內部備註 Remarks
                </label>
                <textarea
                  rows={2}
                  placeholder="輸入特別收款備註 (只限內部查看)..."
                  value={transForm.remarks || ""}
                  onChange={(e) =>
                    setTransForm({ ...transForm, remarks: e.target.value })
                  }
                  className={`w-full ${colors.inputBg} rounded-lg p-3 border border-neutral-600 text-white outline-none text-sm resize-none focus:border-[#C5A47E] transition-colors`}
                />
              </div>
            </div>
            <div className="flex-none p-5 pt-4 bg-neutral-900 border-t border-neutral-800 flex gap-3 rounded-b-2xl">
              {transForm.id && (
                <button
                  type="button"
                  onClick={handleDeleteTransaction}
                  disabled={isSubmitting}
                  className="flex-1 bg-red-900/50 text-red-400 font-medium py-3 rounded-xl border border-red-900/50"
                >
                  刪除
                </button>
              )}
              <button
                type="button"
                onClick={handleSaveTrans}
                disabled={isSubmitting}
                className={`flex-[2] bg-[#C5A47E] text-black font-bold py-3 rounded-xl flex justify-center items-center gap-2 ${
                  isSubmitting ? "opacity-70" : ""
                }`}
              >
                {isSubmitting ? (
                  <>
                    <Loader2 className="animate-spin" size={20} /> 儲存中...
                  </>
                ) : transForm.id ? (
                  "儲存修改"
                ) : (
                  "確認入數"
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {showRecordModal && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-fade-in">
          <div
            className={`w-full max-w-md ${colors.card} max-h-[90vh] rounded-2xl flex flex-col border border-[#C5A47E]/30`}
          >
            <div className="flex-none flex justify-between items-center p-5 border-b border-neutral-700 bg-neutral-800 rounded-t-2xl">
              <h3 className={`${colors.white} text-xl font-medium`}>
                {recordForm.id ? "修改施術紀錄" : "新增施術紀錄"}
              </h3>
              <button
                onClick={() => setShowRecordModal(false)}
                type="button"
                className="p-2 bg-neutral-700 rounded-full text-neutral-400 hover:text-white"
              >
                <X size={20} />
              </button>
            </div>
            <div className="flex-1 overflow-y-auto p-5 space-y-4 custom-scrollbar">
              <div className="bg-neutral-900 p-3 rounded-lg border border-neutral-700 flex justify-between items-center">
                <span className="text-neutral-400 text-xs">
                  客戶:{" "}
                  <span className={`${colors.gold} text-sm ml-1`}>
                    {recordForm.client}
                  </span>
                </span>
                <span className="text-neutral-500 text-xs">
                  {recordForm.date}
                </span>
              </div>
              <div className="flex gap-4 items-end">
                <div className="flex-[2] space-y-1">
                  <label
                    className={`text-[10px] ${colors.gold} uppercase tracking-wide`}
                  >
                    日期 Date
                  </label>
                  <input
                    type="date"
                    value={recordForm.date}
                    onChange={(e) =>
                      setRecordForm({ ...recordForm, date: e.target.value })
                    }
                    className={`w-full ${colors.inputBg} h-[46px] rounded-lg px-3 border border-neutral-600 text-white outline-none text-sm`}
                  />
                </div>
                <div className="flex-1 space-y-1">
                  <label
                    className={`text-[10px] ${colors.gold} uppercase tracking-wide`}
                  >
                    收費 Price
                  </label>
                  <div
                    className={`flex items-center rounded-lg px-3 border border-neutral-600 bg-neutral-900 h-[46px]`}
                  >
                    <span className="text-neutral-500 text-xs mr-1">$</span>
                    <input
                      type="number"
                      value={recordForm.price}
                      onChange={(e) =>
                        setRecordForm({ ...recordForm, price: e.target.value })
                      }
                      className="w-full bg-transparent text-white outline-none text-sm font-mono"
                    />
                  </div>
                </div>
              </div>
              <div className="space-y-2">
                <label
                  className={`text-[10px] ${colors.gold} uppercase tracking-wide`}
                >
                  項目 Service
                </label>
                {CATEGORY_LABELS.filter((cat) =>
                  services.some((s) => getServiceCategory(s.name) === cat)
                ).map((cat) => (
                  <button
                    key={cat}
                    type="button"
                    onClick={() =>
                      setRecordServiceCat(recordServiceCat === cat ? "" : cat)
                    }
                    className={`px-4 py-2 rounded-full text-sm font-medium border transition-all ${
                      recordServiceCat === cat
                        ? "bg-[#C5A47E] text-black border-[#C5A47E]"
                        : "border-neutral-700 text-neutral-400 bg-neutral-900 hover:border-[#C5A47E]"
                    }`}
                  >
                    {cat}
                  </button>
                ))}
              </div>
              {recordServiceCat && (
                <div className="animate-fade-in">
                  <div className="flex justify-end mb-2">
                    <button
                      type="button"
                      onClick={() =>
                        setIsEditingServiceOrder(!isEditingServiceOrder)
                      }
                      className={`text-[10px] px-2 py-0.5 rounded-full flex items-center gap-1 transition-all ${
                        isEditingServiceOrder
                          ? "bg-[#C5A47E] text-black"
                          : "bg-neutral-800 text-neutral-400"
                      }`}
                    >
                      <Move size={10} />{" "}
                      {isEditingServiceOrder ? "完成排序" : "調整次序"}
                    </button>
                  </div>
                  <div className="grid grid-cols-1 gap-2">
                    {services
                      .filter(
                        (s) => getServiceCategory(s.name) === recordServiceCat
                      )
                      .map((svc, idx, arr) => (
                        <div
                          key={svc.id}
                          draggable={isEditingServiceOrder}
                          onDragStart={() =>
                            (serviceDragItem.current = services.indexOf(svc))
                          }
                          onDragEnter={() =>
                            (serviceDragOverItem.current =
                              services.indexOf(svc))
                          }
                          onDragEnd={handleServiceDragEnd}
                          onDragOver={(e) => e.preventDefault()}
                          className={`flex items-center gap-2 ${
                            isEditingServiceOrder ? "cursor-move" : ""
                          }`}
                        >
                          {isEditingServiceOrder && (
                            <div className="flex flex-col gap-1">
                              <button
                                type="button"
                                onClick={async () => {
                                  if (idx === 0) return;
                                  const globalIdx = services.indexOf(svc);
                                  const prevInCat = arr[idx - 1];
                                  const prevGlobalIdx =
                                    services.indexOf(prevInCat);
                                  const list = [...services];
                                  [list[globalIdx], list[prevGlobalIdx]] = [
                                    list[prevGlobalIdx],
                                    list[globalIdx],
                                  ];
                                  setServices(list);
                                  if (db) {
                                    const batch = writeBatch(db);
                                    list.forEach((s, i) =>
                                      batch.update(
                                        doc(db, "services", String(s.id)),
                                        { order: i }
                                      )
                                    );
                                    await batch.commit();
                                  }
                                }}
                                className="text-neutral-400 hover:text-white p-0.5"
                              >
                                <ArrowUp size={12} />
                              </button>
                              <button
                                type="button"
                                onClick={async () => {
                                  if (idx === arr.length - 1) return;
                                  const globalIdx = services.indexOf(svc);
                                  const nextInCat = arr[idx + 1];
                                  const nextGlobalIdx =
                                    services.indexOf(nextInCat);
                                  const list = [...services];
                                  [list[globalIdx], list[nextGlobalIdx]] = [
                                    list[nextGlobalIdx],
                                    list[globalIdx],
                                  ];
                                  setServices(list);
                                  if (db) {
                                    const batch = writeBatch(db);
                                    list.forEach((s, i) =>
                                      batch.update(
                                        doc(db, "services", String(s.id)),
                                        { order: i }
                                      )
                                    );
                                    await batch.commit();
                                  }
                                }}
                                className="text-neutral-400 hover:text-white p-0.5"
                              >
                                <ArrowDown size={12} />
                              </button>
                            </div>
                          )}
                          <button
                            type="button"
                            onClick={() =>
                              !isEditingServiceOrder &&
                              setRecordForm({
                                ...recordForm,
                                service: svc.name,
                                serviceColor: svc.color,
                                price: svc.price,
                              })
                            }
                            className={`flex-1 p-3 rounded-lg text-left border text-sm flex items-center justify-between transition-all ${
                              recordForm.service === svc.name
                                ? `${svc.color} border-white shadow-md`
                                : "border-neutral-700 bg-neutral-900 text-neutral-400"
                            } ${
                              isEditingServiceOrder
                                ? "opacity-70 cursor-move"
                                : ""
                            }`}
                          >
                            <span className="font-medium">{svc.name}</span>
                            <div className="flex items-center gap-2">
                              {recordForm.service === svc.name &&
                                !isEditingServiceOrder && <Check size={14} />}
                              {isEditingServiceOrder && (
                                <Move size={12} className="text-neutral-500" />
                              )}
                            </div>
                          </button>
                        </div>
                      ))}
                  </div>
                </div>
              )}
              <div className="space-y-1">
                <label
                  className={`text-[10px] ${colors.gold} uppercase tracking-wide`}
                >
                  顏色對比 Color Comparison
                </label>
                <div className="flex bg-neutral-900 rounded-lg p-1 border border-neutral-600">
                  {["Lighter", "Darker", "Same"].map((opt) => (
                    <button
                      key={opt}
                      type="button"
                      onClick={() =>
                        setRecordForm({ ...recordForm, colorComparison: opt })
                      }
                      className={`flex-1 py-2 text-xs rounded transition-all ${
                        recordForm.colorComparison === opt
                          ? "bg-[#C5A47E] text-black font-bold"
                          : "text-neutral-500"
                      }`}
                    >
                      {opt}
                    </button>
                  ))}
                </div>
              </div>
              <div className="space-y-1">
                <div className="flex items-center justify-between">
                  <label
                    className={`text-[10px] ${colors.gold} uppercase tracking-wide`}
                  >
                    配色 Color
                  </label>
                  <button
                    onClick={() => setIsEditingColor(!isEditingColor)}
                    className={`text-[10px] px-2 py-0.5 rounded-full flex items-center gap-1 transition-all ${
                      isEditingColor
                        ? "bg-red-900 text-red-200"
                        : "bg-neutral-800 text-neutral-400"
                    }`}
                  >
                    {isEditingColor ? (
                      <Check size={10} />
                    ) : (
                      <PenLine size={10} />
                    )}{" "}
                    {isEditingColor ? "完成" : "編輯"}
                  </button>
                </div>
                <div className="flex gap-2 mb-1 flex-wrap">
                  {colorPresets.map((p, idx) => (
                    <button
                      key={p}
                      type="button"
                      draggable={isEditingColor}
                      onDragStart={(e) => handleDragStart(e, idx)}
                      onDragEnter={(e) => handleDragEnter(e, idx)}
                      onDragEnd={() => handleDragEnd("color")}
                      onDragOver={(e) => e.preventDefault()}
                      onClick={() => handlePresetClick("color", p, idx)}
                      onDoubleClick={() => handlePresetDoubleClick("color", p)}
                      className={`px-3 py-1.5 rounded-full text-xs border transition-all ${
                        isEditingColor ? "cursor-move" : ""
                      } ${
                        selectedDragItem?.type === "color" &&
                        selectedDragItem?.index === idx
                          ? "border-green-500 bg-green-900/30 text-green-300 scale-110"
                          : isEditingColor && selectedDragItem?.type !== "color"
                          ? "border-dashed border-red-500/50 text-red-300 bg-red-900/10"
                          : "border-neutral-600 text-neutral-400 hover:border-[#C5A47E] hover:text-[#C5A47E]"
                      }`}
                    >
                      {p}{" "}
                      {isEditingColor && (
                        <span className="ml-1 text-[8px] opacity-50">::</span>
                      )}
                    </button>
                  ))}
                  <button
                    onClick={() => promptAddPreset("color")}
                    className="px-2 py-1.5 rounded-full text-xs border border-[#C5A47E] text-[#C5A47E]"
                  >
                    <Plus size={12} />
                  </button>
                </div>
                <input
                  type="text"
                  placeholder="e.g. 淺啡+灰"
                  value={recordForm.colorUsed}
                  onChange={(e) =>
                    setRecordForm({ ...recordForm, colorUsed: e.target.value })
                  }
                  className={`w-full ${colors.inputBg} rounded-lg p-3 border border-neutral-600 text-white outline-none text-sm`}
                />
              </div>
              <div className="space-y-2">
                <div className="flex items-center justify-between">
                  <label
                    className={`text-[10px] ${colors.gold} uppercase tracking-wide`}
                  >
                    工具 Tools
                  </label>
                  <button
                    onClick={() => setIsEditingTool(!isEditingTool)}
                    className={`text-[10px] px-2 py-0.5 rounded-full flex items-center gap-1 transition-all ${
                      isEditingTool
                        ? "bg-red-900 text-red-200"
                        : "bg-neutral-800 text-neutral-400"
                    }`}
                  >
                    {isEditingTool ? (
                      <Check size={10} />
                    ) : (
                      <PenLine size={10} />
                    )}{" "}
                    {isEditingTool ? "完成" : "編輯"}
                  </button>
                </div>
                <div className="flex gap-2 mb-1 flex-wrap">
                  {toolPresets.map((p, idx) => (
                    <button
                      key={p}
                      type="button"
                      draggable={isEditingTool}
                      onDragStart={(e) => handleDragStart(e, idx)}
                      onDragEnter={(e) => handleDragEnter(e, idx)}
                      onDragEnd={() => handleDragEnd("tool")}
                      onDragOver={(e) => e.preventDefault()}
                      onClick={() => handlePresetClick("tool", p, idx)}
                      onDoubleClick={() => handlePresetDoubleClick("tool", p)}
                      className={`px-3 py-1.5 rounded-full text-xs border transition-all ${
                        isEditingTool ? "cursor-move" : ""
                      } ${
                        selectedDragItem?.type === "tool" &&
                        selectedDragItem?.index === idx
                          ? "border-green-500 bg-green-900/30 text-green-300 scale-110"
                          : isEditingTool && selectedDragItem?.type !== "tool"
                          ? "border-dashed border-red-500/50 text-red-300 bg-red-900/10"
                          : "border-neutral-600 text-neutral-400 hover:border-[#C5A47E] hover:text-[#C5A47E]"
                      }`}
                    >
                      {p}{" "}
                      {isEditingTool && (
                        <span className="ml-1 text-[8px] opacity-50">::</span>
                      )}
                    </button>
                  ))}
                  <button
                    onClick={() => promptAddPreset("tool")}
                    className="px-2 py-1.5 rounded-full text-xs border border-[#C5A47E] text-[#C5A47E]"
                  >
                    <Plus size={12} />
                  </button>
                </div>
                <input
                  type="text"
                  placeholder="e.g. 圓三針"
                  value={recordForm.toolsUsed}
                  onChange={(e) =>
                    setRecordForm({ ...recordForm, toolsUsed: e.target.value })
                  }
                  className={`w-full ${colors.inputBg} rounded-lg p-3 border border-neutral-600 text-white outline-none text-sm`}
                />
              </div>
              <div className="space-y-3 pt-2 border-t border-neutral-700">
                <label
                  className={`text-[10px] ${colors.gold} uppercase tracking-wide block`}
                >
                  Before / After 相片
                </label>
                <PhotoUploader
                  label="Before"
                  photos={recordForm.beforePhotos || []}
                  onChange={(photos) =>
                    setRecordForm((prev) => ({ ...prev, beforePhotos: photos }))
                  }
                  colors={colors}
                />
                <PhotoUploader
                  label="After"
                  photos={recordForm.afterPhotos || []}
                  onChange={(photos) =>
                    setRecordForm((prev) => ({ ...prev, afterPhotos: photos }))
                  }
                  colors={colors}
                />
              </div>
              <div className="space-y-1">
                <label
                  className={`text-[10px] ${colors.gold} uppercase tracking-wide`}
                >
                  備註 Remarks
                </label>
                <textarea
                  rows={2}
                  value={recordForm.remarks}
                  onChange={(e) =>
                    setRecordForm({ ...recordForm, remarks: e.target.value })
                  }
                  className={`w-full ${colors.inputBg} rounded-lg p-3 border border-neutral-600 text-white outline-none text-sm resize-none`}
                />
              </div>
            </div>
            <div className="flex-none p-5 pt-4 bg-neutral-900 border-t border-neutral-800 flex gap-3 rounded-b-2xl">
              {recordForm.id && (
                <button
                  type="button"
                  onClick={handleDeleteRecord}
                  disabled={isSubmitting}
                  className="flex-none px-4 bg-red-900/50 text-red-400 font-medium py-3 rounded-xl border border-red-900/50 flex justify-center items-center hover:bg-red-900/70 transition-colors"
                  title="刪除"
                >
                  <Trash2 size={20} />
                </button>
              )}
              <button
                type="button"
                onClick={handleSendWhatsAppCare}
                className="flex-1 bg-[#25D366]/20 text-[#25D366] border border-[#25D366]/50 font-medium py-3 rounded-xl flex justify-center items-center gap-2 hover:bg-[#25D366]/30 transition-colors"
              >
                <MessageCircle size={18} /> 發送護理
              </button>
              <button
                type="button"
                onClick={handleSaveRecord}
                disabled={isSubmitting}
                className={`flex-[1.5] bg-[#C5A47E] text-black font-bold py-3 rounded-xl flex justify-center items-center gap-2 ${
                  isSubmitting
                    ? "opacity-70"
                    : "hover:bg-[#b08d66] transition-colors"
                }`}
              >
                {isSubmitting ? (
                  <>
                    <Loader2 className="animate-spin" size={20} /> 儲存中...
                  </>
                ) : (
                  "儲存紀錄"
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {showClientModal && selectedClient && (
        <div className="fixed inset-0 z-40 bg-black flex flex-col animate-fade-in">
          <div className="flex-none pt-12 pb-4 px-6 flex justify-between items-center border-b border-neutral-800 bg-neutral-900">
            <button
              onClick={() => setShowClientModal(false)}
              className="p-2 -ml-2 text-neutral-400"
            >
              <ChevronLeft />
            </button>
            <h2 className={`${colors.white} text-lg font-medium`}>客戶檔案</h2>
            <div className="flex items-center gap-1">
              <button
                onClick={openClientEditModal}
                className="p-2 text-neutral-400 hover:text-white rounded-full"
              >
                <Edit2 size={20} />
              </button>
              <button
                onClick={handleDeleteClient}
                disabled={isSubmitting}
                className="p-3 text-red-400 hover:bg-red-900/20 rounded-full"
              >
                <Trash2 size={20} />
              </button>
            </div>
          </div>

          <div className="flex-none p-6 pb-2">
            <div
              className={`p-5 rounded-2xl ${colors.card} border border-neutral-700 flex flex-col items-center relative`}
            >
              <div className="absolute top-5 right-5 flex gap-2">
                {selectedClient.tagV && (
                  <span className="w-6 h-6 rounded bg-[#C5A47E] text-black text-xs font-bold flex items-center justify-center">
                    V
                  </span>
                )}
                {selectedClient.tagS && (
                  <span className="w-6 h-6 rounded bg-purple-500 text-white text-xs font-bold flex items-center justify-center">
                    S
                  </span>
                )}
              </div>
              <h3
                className={`${colors.white} text-3xl font-light mb-2 mt-4 flex items-center justify-center gap-2`}
              >
                {selectedClient.name}
                {selectedClient.notes?.trim() && (
                  <div title="此客有內部備註">
                    <FileText size={18} className="text-[#C5A47E]/40" />
                  </div>
                )}
              </h3>
              <div className="flex gap-2 mb-4">
                {selectedClient.id && (
                  <span className="text-xs bg-neutral-900 text-neutral-400 px-2 py-0.5 rounded border border-neutral-700">
                    {selectedClient.id}
                  </span>
                )}
                <span className="text-xs bg-neutral-900 text-neutral-400 px-2 py-0.5 rounded border border-neutral-700">
                  {selectedClient.phone}
                </span>
              </div>
              <div className="flex gap-2 flex-wrap justify-center">
                {selectedClient.hasWhatsapp && (
                  <span className="text-[10px] bg-neutral-900 text-[#C5A47E] px-2 py-0.5 rounded border border-[#C5A47E]/30 flex items-center gap-1">
                    WhatsApp
                  </span>
                )}
                {selectedClient.isNonHK && (
                  <span className="text-[10px] bg-neutral-900 text-sky-300 px-2 py-0.5 rounded border border-sky-500/30 flex items-center gap-1">
                    Non HK
                  </span>
                )}
                {selectedClient.useSocial && (
                  <span className="text-[10px] bg-neutral-900 text-white px-2 py-0.5 rounded border border-neutral-600 flex items-center gap-1">
                    <span className="text-[#C5A47E]">FB/IG:</span>{" "}
                    {selectedClient.socialHandle || ""}
                  </span>
                )}
                {selectedClient.skinType?.map((s) => (
                  <span
                    key={s}
                    className="text-[10px] bg-neutral-900 text-neutral-400 px-2 py-0.5 rounded border border-neutral-700"
                  >
                    {s}
                  </span>
                ))}
                {selectedClient.preference && (
                  <span className="text-[10px] bg-neutral-900 text-[#C5A47E] px-2 py-0.5 rounded border border-[#C5A47E]/30">
                    {selectedClient.preference === "natural" ? "自然" : "妝感"}
                  </span>
                )}
                {selectedClient.dailyCare?.map((c) => (
                  <span
                    key={c}
                    className="text-[10px] bg-neutral-900 text-[#C5A47E] px-2 py-0.5 rounded border border-[#C5A47E]/30"
                  >
                    {c}
                  </span>
                ))}
                {selectedClient.voucherPurchaseDate &&
                  (() => {
                    const exp = getVoucherExpiryDate(
                      selectedClient.voucherPurchaseDate
                    );
                    const expStr = exp
                      ? `${exp.getFullYear()}/${exp.getMonth() + 1}/${exp.getDate()}`
                      : "";
                    return selectedClient.voucherUsed ? (
                      <span className="text-[10px] bg-green-900/40 text-green-400 px-2 py-0.5 rounded border border-green-500/30">
                        補色券已用 ({selectedClient.voucherUsedDate})
                      </span>
                    ) : (
                      <span className="text-[10px] bg-neutral-900 text-amber-400 px-2 py-0.5 rounded border border-amber-500/30">
                        補色券未用・到期 {expStr}
                      </span>
                    );
                  })()}
              </div>
              <button
                onClick={openConsentModal}
                className="mt-6 flex items-center gap-1 text-xs bg-white/10 hover:bg-white/20 px-4 py-2 rounded-full transition-colors text-white border border-white/20"
              >
                <FileSignature size={14} className="text-[#C5A47E]" />{" "}
                簽署同意書
              </button>
            </div>

            <div className="mt-4 w-full">
              <button
                onClick={() => setShowClientDetails(!showClientDetails)}
                className={`w-full flex items-center justify-between p-3 rounded-xl border transition-all ${
                  showClientDetails
                    ? "bg-[#C5A47E]/10 border-[#C5A47E] text-[#C5A47E]"
                    : "bg-neutral-900 border-neutral-800 text-neutral-400 hover:text-white"
                }`}
              >
                <span className="flex items-center gap-2 font-medium text-xs sm:text-sm">
                  <User size={16} /> 檢視詳細檔案資料
                </span>
                {showClientDetails ? (
                  <ChevronUp size={16} />
                ) : (
                  <ChevronDown size={16} />
                )}
              </button>

              {showClientDetails && (
                <div className="mt-2 p-4 bg-neutral-900 border border-neutral-800 rounded-xl space-y-4 animate-fade-in text-sm text-neutral-300 shadow-inner">
                  <div className="grid grid-cols-2 gap-4 border-b border-neutral-800 pb-3">
                    <div>
                      <span className="block text-[#C5A47E] text-xs mb-1">
                        生日
                      </span>
                      {selectedClient.dobMonth && selectedClient.dobDay
                        ? `${selectedClient.dobMonth}月 ${selectedClient.dobDay}日`
                        : "未記錄"}
                    </div>
                    <div>
                      <span className="block text-[#C5A47E] text-xs mb-1">
                        Email
                      </span>
                      <span className="break-all text-xs">
                        {selectedClient.email || "未記錄"}
                      </span>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-4 border-b border-neutral-800 pb-3">
                    <div>
                      <span className="block text-[#C5A47E] text-xs mb-1">
                        認識途徑
                      </span>
                      {selectedClient.source || "未記錄"}
                    </div>
                    <div>
                      <span className="block text-[#C5A47E] text-xs mb-1">
                        過往紋繡
                      </span>
                      {selectedClient.hasTattooBefore
                        ? `有 (${selectedClient.tattooTime})`
                        : "沒有"}
                      {selectedClient.hasLaserBefore && (
                        <span className="block text-xs text-red-300 mt-1">
                          (曾做激光)
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <span className="block text-[#C5A47E] text-xs mb-1">
                        健康申報紀錄
                      </span>
                      {selectedClient.medicalConditions?.length > 0 ? (
                        <div className="flex flex-wrap gap-2 mt-1">
                          {selectedClient.medicalConditions.map((c) => (
                            <span
                              key={c}
                              className="bg-red-900/30 text-red-200 border border-red-900/50 px-2 py-0.5 rounded text-xs"
                            >
                              {c}
                            </span>
                          ))}
                        </div>
                      ) : (
                        "無特別申報"
                      )}
                    </div>
                    <div className="border-l border-neutral-800 pl-4">
                      <span className="block text-[#C5A47E] text-xs mb-1">
                        備注 Notes
                      </span>
                      <span className="text-white text-sm whitespace-pre-wrap break-words">
                        {selectedClient.notes || "無"}
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="flex-1 overflow-y-auto px-4 pb-24 custom-scrollbar">
            <div className="flex justify-between items-center mb-4 mt-2">
              <h3
                className={`${colors.gold} text-sm uppercase tracking-wider font-semibold`}
              >
                施術紀錄
              </h3>
              <button
                onClick={openAddRecordModal}
                className="flex items-center gap-1 text-xs bg-[#C5A47E] text-black px-3 py-1.5 rounded-full font-medium"
              >
                <Plus size={14} /> 新增
              </button>
            </div>
            <div className="space-y-4">
              {getClientRecords(selectedClient).length > 0 ? (
                getClientRecords(selectedClient).map((r) => {
                  const hasRemarks = r.remarks?.trim() !== "";
                  const hasPhotos =
                    r.beforePhotos?.length > 0 || r.afterPhotos?.length > 0;
                  return (
                    <div
                      key={r.id}
                      onClick={() => {
                        setRecordForm({
                          ...r,
                          beforePhotos: r.beforePhotos || [],
                          afterPhotos: r.afterPhotos || [],
                        });
                        setRecordServiceCat(
                          r.service ? getServiceCategory(r.service) : ""
                        );
                        setShowRecordModal(true);
                      }}
                      className={`p-5 rounded-xl ${colors.card} border border-neutral-800 relative group cursor-pointer hover:border-[#C5A47E]/50 transition-colors`}
                    >
                      <div
                        className={`absolute left-0 top-0 bottom-0 w-1.5 ${
                          r.serviceColor?.split(" ")[0] || "bg-neutral-600"
                        }`}
                      />
                      <div className="pl-4">
                        <div className="flex justify-between items-center mb-3">
                          <span
                            className={`${colors.white} text-lg font-medium`}
                          >
                            {r.service}
                          </span>
                          <div className="flex items-center gap-2">
                            {hasPhotos && (
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setPhotoViewerRecord(r);
                                }}
                                className="flex items-center gap-1 text-[10px] bg-[#C5A47E]/10 text-[#C5A47E] border border-[#C5A47E]/30 px-2 py-1 rounded-full hover:bg-[#C5A47E]/20 transition-colors"
                              >
                                <ImageIcon size={10} />
                                {(r.beforePhotos?.length || 0) +
                                  (r.afterPhotos?.length || 0)}{" "}
                                張
                              </button>
                            )}
                            <span className={`text-sm ${colors.gray}`}>
                              {r.date}
                            </span>
                          </div>
                        </div>
                        <div className="flex items-start gap-4">
                          <div
                            className={`flex flex-col gap-1 ${
                              hasRemarks ? "w-1/2" : "w-full"
                            }`}
                          >
                            <div className="flex items-center gap-2">
                              <span className="text-xs uppercase text-neutral-500 w-8 flex-none">
                                配色
                              </span>
                              <span className="text-sm text-[#C5A47E]">
                                {r.colorUsed || "-"}
                              </span>
                            </div>
                            <div className="flex items-center gap-2">
                              <span className="text-xs uppercase text-neutral-500 w-8 flex-none">
                                工具
                              </span>
                              <span className="text-sm text-neutral-300">
                                {r.toolsUsed || "-"}
                              </span>
                            </div>
                          </div>
                          {hasRemarks && (
                            <div className="w-1/2 border-l border-neutral-700 pl-4">
                              <span className="block text-[10px] uppercase text-neutral-500 mb-0.5">
                                備注 Remarks
                              </span>
                              <span className="text-sm text-white leading-relaxed line-clamp-2">
                                {r.remarks}
                              </span>
                            </div>
                          )}
                        </div>
                        {hasPhotos && (
                          <div className="mt-3 pt-3 border-t border-neutral-700/50 flex gap-4">
                            {["before", "after"].map((type) => {
                              const photos =
                                type === "before"
                                  ? r.beforePhotos || []
                                  : r.afterPhotos || [];
                              if (!photos.length) return null;
                              return (
                                <div key={type} className="flex-1">
                                  <p
                                    className={`text-[9px] uppercase mb-1.5 font-medium ${
                                      type === "before"
                                        ? "text-neutral-500"
                                        : "text-[#C5A47E]"
                                    }`}
                                  >
                                    {type}
                                  </p>
                                  <div className="flex gap-1.5">
                                    {photos.slice(0, 3).map((src, idx) => (
                                      <div
                                        key={idx}
                                        className="w-10 h-10 rounded-lg overflow-hidden border border-neutral-700 flex-none"
                                      >
                                        <img
                                          src={src}
                                          alt={`${type}-${idx}`}
                                          className="w-full h-full object-cover"
                                        />
                                      </div>
                                    ))}
                                    {photos.length > 3 && (
                                      <div className="w-10 h-10 rounded-lg bg-neutral-700 flex items-center justify-center text-[10px] text-neutral-400 border border-neutral-600 flex-none">
                                        +{photos.length - 3}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                      <Edit2
                        size={14}
                        className="absolute bottom-5 right-5 text-neutral-600 opacity-50 group-hover:opacity-100 transition-opacity"
                      />
                    </div>
                  );
                })
              ) : (
                <div className="text-center py-10 text-neutral-600 border border-dashed border-neutral-800 rounded-xl">
                  <FileText size={32} className="mx-auto mb-2 opacity-20" />
                  <p className="text-xs">暫無施術紀錄</p>
                </div>
              )}
            </div>

            {selectedClient.consents?.length > 0 && (
              <div className="mt-6 mb-4">
                <h3
                  className={`${colors.gold} text-sm uppercase tracking-wider font-semibold mb-2`}
                >
                  已簽署同意書
                </h3>
                <div className="space-y-2">
                  {selectedClient.consents.map((c, idx) => {
                    const hasMedicalIssues =
                      c.medicalConditions?.length > 0 &&
                      !c.medicalConditions.includes("以上症狀皆沒有");
                    return (
                      <div
                        key={idx}
                        onClick={() => openViewConsent(c)}
                        className="bg-neutral-900 p-3 rounded-lg border border-neutral-700 flex flex-col cursor-pointer hover:bg-neutral-800 group relative"
                      >
                        <div className="flex justify-between items-center">
                          <div className="flex items-center gap-2">
                            <span className="text-xs text-neutral-400">
                              {c.date}
                            </span>
                            <span className="text-[10px] bg-neutral-800 text-neutral-500 px-1 rounded">
                              {c.version || "v1"}
                            </span>
                            {hasMedicalIssues && (
                              <div
                                className="w-2 h-2 rounded-full bg-red-500 shadow-[0_0_5px_rgba(239,68,68,0.8)]"
                                title="有健康申報"
                              />
                            )}
                          </div>
                          <div className="flex items-center gap-2">
                            <Eye size={14} className="text-[#C5A47E]" />
                            <span className="text-xs text-green-500 border border-green-900 bg-green-900/20 px-2 py-0.5 rounded">
                              已簽署
                            </span>
                          </div>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDeleteConsent(c);
                            }}
                            className="absolute -right-2 -top-2 bg-red-900 text-white p-1 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
                          >
                            <X size={12} />
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {showClientEditModal && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-fade-in">
          <div
            className={`w-full max-w-md ${colors.card} max-h-[90vh] rounded-2xl flex flex-col border border-neutral-700`}
          >
            <div className="flex-none p-5 border-b border-neutral-700 bg-neutral-900/50 rounded-t-2xl flex justify-between items-center">
              <h3 className="text-white text-xl font-medium">
                {selectedClient ? "編輯客戶資料" : "新增客戶"}
              </h3>
              {!isGuestMode && (
                <button
                  onClick={async () => {
                    if (
                      await showDialog({
                        title: "啟動客人填寫模式",
                        message:
                          "啟動後將隱藏關閉按鈕及內部備註，客人提交後需要密碼解鎖。",
                        confirmLabel: "啟動",
                        cancelLabel: "取消",
                      })
                    ) {
                      setIsGuestMode(true);
                    }
                  }}
                  className="flex items-center gap-1 text-sm bg-[#C5A47E]/20 text-[#C5A47E] px-3 py-1.5 rounded-full border border-[#C5A47E]/50 hover:bg-[#C5A47E]/40 transition-colors"
                >
                  <Lock size={14} /> 轉交客人填寫
                </button>
              )}
            </div>
            <div className="flex-1 overflow-y-auto p-5 space-y-5 custom-scrollbar">
              <div>
                <label className="text-lg text-[#C5A47E] block mb-2">
                  客戶名稱 Name
                </label>
                <input
                  type="text"
                  value={clientEditForm.name}
                  onChange={(e) =>
                    setClientEditForm({
                      ...clientEditForm,
                      name: e.target.value,
                    })
                  }
                  autoComplete="nope"
                  autoCorrect="off"
                  spellCheck="false"
                  className={`w-full ${colors.inputBg} rounded-xl p-4 border border-neutral-600 text-white text-xl outline-none focus:border-[#C5A47E]`}
                />
              </div>
              <div>
                <label className="text-lg text-[#C5A47E] block mb-2">
                  電話 Phone
                </label>
                <input
                  type="tel"
                  value={clientEditForm.phone}
                  onChange={(e) =>
                    setClientEditForm({
                      ...clientEditForm,
                      phone: e.target.value,
                    })
                  }
                  autoComplete="nope"
                  autoCorrect="off"
                  spellCheck="false"
                  className={`w-full ${colors.inputBg} rounded-xl p-4 border border-neutral-600 text-white text-xl outline-none focus:border-[#C5A47E]`}
                />
              </div>
              {!isGuestMode && (
                <div>
                  <label className="text-lg text-[#C5A47E] block mb-2">
                    編號 ID
                  </label>
                  <input
                    type="text"
                    value={clientEditForm.id}
                    onChange={(e) =>
                      setClientEditForm({
                        ...clientEditForm,
                        id: e.target.value,
                      })
                    }
                    autoComplete="nope"
                    autoCorrect="off"
                    spellCheck="false"
                    className={`w-full ${colors.inputBg} rounded-xl p-4 border border-neutral-600 text-white text-xl outline-none focus:border-[#C5A47E]`}
                  />
                </div>
              )}
              <div className="flex gap-4">
                <div className="flex-1">
                  <label className="text-lg text-[#C5A47E] block mb-2">
                    生日月 Month
                  </label>
                  <input
                    type="number"
                    placeholder="MM"
                    value={clientEditForm.dobMonth}
                    onChange={(e) =>
                      setClientEditForm({
                        ...clientEditForm,
                        dobMonth: e.target.value,
                      })
                    }
                    autoComplete="nope"
                    className={`w-full ${colors.inputBg} rounded-xl p-4 border border-neutral-600 text-white text-xl outline-none focus:border-[#C5A47E] text-center`}
                  />
                </div>
                <div className="flex-1">
                  <label className="text-lg text-[#C5A47E] block mb-2">
                    日 Day
                  </label>
                  <input
                    type="number"
                    placeholder="DD"
                    value={clientEditForm.dobDay}
                    onChange={(e) =>
                      setClientEditForm({
                        ...clientEditForm,
                        dobDay: e.target.value,
                      })
                    }
                    autoComplete="nope"
                    className={`w-full ${colors.inputBg} rounded-xl p-4 border border-neutral-600 text-white text-xl outline-none focus:border-[#C5A47E] text-center`}
                  />
                </div>
              </div>
              <div>
                <label className="text-lg text-[#C5A47E] block mb-2">
                  電郵 Email
                </label>
                <input
                  type="text"
                  value={clientEditForm.email}
                  onChange={(e) =>
                    setClientEditForm({
                      ...clientEditForm,
                      email: e.target.value,
                    })
                  }
                  autoComplete="nope"
                  autoCorrect="off"
                  spellCheck="false"
                  className={`w-full ${colors.inputBg} rounded-xl p-4 border border-neutral-600 text-white text-xl outline-none focus:border-[#C5A47E]`}
                />
                <div className="flex gap-2 mt-3 flex-wrap">
                  {["@gmail.com", "@yahoo.com.hk", "@hotmail.com"].map(
                    (domain) => (
                      <button
                        key={domain}
                        type="button"
                        onClick={() =>
                          setClientEditForm((prev) => ({
                            ...prev,
                            email: (prev.email || "") + domain,
                          }))
                        }
                        className="px-3 py-2 rounded-lg bg-neutral-800 border border-neutral-700 text-sm text-neutral-400 hover:text-white hover:border-[#C5A47E] transition-colors"
                      >
                        {domain}
                      </button>
                    )
                  )}
                </div>
              </div>
              <div className="mt-4 pt-4 border-t border-neutral-700">
                <label className="text-lg text-[#C5A47E] block mb-4">
                  客戶聯絡方式 Contact Method
                </label>
                <div className="space-y-4">
                  <div>
                    <div
                      onClick={() =>
                        setClientEditForm({
                          ...clientEditForm,
                          useSocial: !clientEditForm.useSocial,
                        })
                      }
                      className="flex items-center gap-3 cursor-pointer mb-3"
                    >
                      <div
                        className={`w-6 h-6 rounded border flex items-center justify-center ${
                          clientEditForm.useSocial
                            ? "bg-[#C5A47E] border-[#C5A47E]"
                            : "border-neutral-600"
                        }`}
                      >
                        {clientEditForm.useSocial && (
                          <Check size={18} className="text-black" />
                        )}
                      </div>
                      <span className="text-white text-lg">Facebook / IG</span>
                    </div>
                    {clientEditForm.useSocial && (
                      <input
                        type="text"
                        placeholder="輸入用戶名稱 (e.g. @eyebrows.art)"
                        value={clientEditForm.socialHandle}
                        onChange={(e) =>
                          setClientEditForm({
                            ...clientEditForm,
                            socialHandle: e.target.value,
                          })
                        }
                        autoComplete="nope"
                        autoCorrect="off"
                        spellCheck="false"
                        className={`w-full ${colors.inputBg} rounded-xl p-4 border border-neutral-600 text-white outline-none text-lg`}
                      />
                    )}
                  </div>
                  <div
                    onClick={() =>
                      setClientEditForm({
                        ...clientEditForm,
                        hasWhatsapp: !clientEditForm.hasWhatsapp,
                      })
                    }
                    className="flex items-center gap-3 cursor-pointer"
                  >
                    <div
                      className={`w-6 h-6 rounded border flex items-center justify-center ${
                        clientEditForm.hasWhatsapp
                          ? "bg-[#C5A47E] border-[#C5A47E] text-black"
                          : "border-neutral-600"
                      }`}
                    >
                      {clientEditForm.hasWhatsapp && <Check size={18} />}
                    </div>
                    <span className="text-white text-lg">WhatsApp</span>
                  </div>
                  <div
                    onClick={() =>
                      setClientEditForm({
                        ...clientEditForm,
                        isNonHK: !clientEditForm.isNonHK,
                      })
                    }
                    className="flex items-center gap-3 cursor-pointer"
                  >
                    <div
                      className={`w-6 h-6 rounded border flex items-center justify-center ${
                        clientEditForm.isNonHK
                          ? "bg-[#C5A47E] border-[#C5A47E] text-black"
                          : "border-neutral-600"
                      }`}
                    >
                      {clientEditForm.isNonHK && <Check size={18} />}
                    </div>
                    <span className="text-white text-lg">
                      Non HK（非香港居民）
                    </span>
                  </div>
                </div>
              </div>

              <div className="pt-6 mt-4 border-t border-neutral-700 space-y-6">
                <div>
                  <label className="text-lg text-[#C5A47E] block mb-3">
                    認識途徑 Source
                  </label>
                  <div className="flex flex-wrap gap-3">
                    {[
                      "Social Media (IG/FB)",
                      "Google Search",
                      "親友介紹",
                      "途經本店",
                      "其他",
                    ].map((s) => (
                      <button
                        key={s}
                        type="button"
                        onClick={() =>
                          setClientEditForm({ ...clientEditForm, source: s })
                        }
                        className={`px-4 py-2.5 rounded-xl text-base border transition-all ${
                          clientEditForm.source === s
                            ? "bg-[#C5A47E] text-black border-[#C5A47E] font-bold shadow-md"
                            : "border-neutral-700 text-neutral-400 bg-neutral-800"
                        }`}
                      >
                        {s}
                      </button>
                    ))}
                  </div>
                </div>
                <div>
                  <label className="text-lg text-[#C5A47E] block mb-3">
                    過往紋繡經驗
                  </label>
                  <div className="flex gap-3 mb-3">
                    <button
                      type="button"
                      onClick={() =>
                        setClientEditForm({
                          ...clientEditForm,
                          hasTattooBefore: true,
                        })
                      }
                      className={`flex-1 py-3 rounded-xl text-lg border ${
                        clientEditForm.hasTattooBefore === true
                          ? "bg-[#C5A47E] text-black border-[#C5A47E] font-bold shadow-md"
                          : "border-neutral-700 text-neutral-400 bg-neutral-800"
                      }`}
                    >
                      有
                    </button>
                    <button
                      type="button"
                      onClick={() =>
                        setClientEditForm({
                          ...clientEditForm,
                          hasTattooBefore: false,
                          tattooTime: "",
                          tattooBaseColor: "",
                        })
                      }
                      className={`flex-1 py-3 rounded-xl text-lg border ${
                        clientEditForm.hasTattooBefore === false
                          ? "bg-[#C5A47E] text-black border-[#C5A47E] font-bold shadow-md"
                          : "border-neutral-700 text-neutral-400 bg-neutral-800"
                      }`}
                    >
                      沒有
                    </button>
                  </div>
                  {clientEditForm.hasTattooBefore && (
                    <div className="space-y-4 pl-3 border-l-2 border-[#C5A47E] ml-2 animate-fade-in">
                      <div className="flex flex-wrap gap-2">
                        {["1-3年", "3-5年", "5-10年", "10年以上"].map((t) => (
                          <button
                            key={t}
                            type="button"
                            onClick={() =>
                              setClientEditForm({
                                ...clientEditForm,
                                tattooTime: t,
                              })
                            }
                            className={`px-3 py-2 rounded-lg text-sm border ${
                              clientEditForm.tattooTime === t
                                ? "bg-neutral-600 text-white border-neutral-500 font-medium"
                                : "border-neutral-700 text-neutral-400 bg-neutral-900"
                            }`}
                          >
                            {t}
                          </button>
                        ))}
                      </div>
                      <div className="flex flex-wrap gap-2">
                        {["橙紅底", "灰藍底", "兩樣都有", "不清楚"].map((c) => (
                          <button
                            key={c}
                            type="button"
                            onClick={() =>
                              setClientEditForm({
                                ...clientEditForm,
                                tattooBaseColor: c,
                              })
                            }
                            className={`px-3 py-2 rounded-lg text-sm border ${
                              clientEditForm.tattooBaseColor === c
                                ? "bg-neutral-600 text-white border-neutral-500 font-medium"
                                : "border-neutral-700 text-neutral-400 bg-neutral-900"
                            }`}
                          >
                            {c}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
                <div>
                  <label className="text-lg text-[#C5A47E] block mb-3">
                    曾否進行激光洗眉？
                  </label>
                  <div className="flex gap-3">
                    <button
                      type="button"
                      onClick={() =>
                        setClientEditForm({
                          ...clientEditForm,
                          hasLaserBefore: true,
                        })
                      }
                      className={`flex-1 py-3 rounded-xl text-lg border ${
                        clientEditForm.hasLaserBefore === true
                          ? "bg-[#C5A47E] text-black border-[#C5A47E] font-bold shadow-md"
                          : "border-neutral-700 text-neutral-400 bg-neutral-800"
                      }`}
                    >
                      有
                    </button>
                    <button
                      type="button"
                      onClick={() =>
                        setClientEditForm({
                          ...clientEditForm,
                          hasLaserBefore: false,
                        })
                      }
                      className={`flex-1 py-3 rounded-xl text-lg border ${
                        clientEditForm.hasLaserBefore === false
                          ? "bg-[#C5A47E] text-black border-[#C5A47E] font-bold shadow-md"
                          : "border-neutral-700 text-neutral-400 bg-neutral-800"
                      }`}
                    >
                      沒有
                    </button>
                  </div>
                </div>
              </div>

              <div className="pt-6 mt-4 border-t border-neutral-700 space-y-5">
                <div>
                  <label className="text-lg text-[#C5A47E] block mb-3">
                    皮膚分析
                  </label>
                  <div className="flex flex-wrap gap-3">
                    {["油性", "乾性", "混合", "敏感", "其他"].map((type) => (
                      <button
                        key={type}
                        onClick={() => toggleEditSkinType(type)}
                        className={`px-4 py-2.5 rounded-full text-base border transition-all ${
                          clientEditForm.skinType?.includes(type)
                            ? "bg-[#C5A47E] text-black border-[#C5A47E] font-medium"
                            : "border-neutral-700 text-neutral-400 bg-neutral-800"
                        }`}
                      >
                        {type}
                      </button>
                    ))}
                  </div>
                </div>
                <div>
                  <label className="text-lg text-[#C5A47E] block mb-3">
                    日常護理
                  </label>
                  <div className="flex flex-wrap gap-3">
                    {["化妝", "畫眉", "修眉"].map((type) => (
                      <button
                        key={type}
                        onClick={() => toggleEditDailyCare(type)}
                        className={`px-4 py-2.5 rounded-full text-base border transition-all ${
                          clientEditForm.dailyCare?.includes(type)
                            ? "bg-[#C5A47E] text-black border-[#C5A47E] font-medium"
                            : "border-neutral-700 text-neutral-400 bg-neutral-800"
                        }`}
                      >
                        {type}
                      </button>
                    ))}
                  </div>
                </div>
                <div>
                  <label className="text-lg text-[#C5A47E] block mb-3">
                    喜好
                  </label>
                  <div className="flex bg-neutral-900 rounded-xl p-1.5 border border-neutral-600 h-[56px]">
                    {["natural", "makeup"].map((type) => (
                      <button
                        key={type}
                        onClick={() =>
                          setClientEditForm({
                            ...clientEditForm,
                            preference: type,
                          })
                        }
                        className={`flex-1 rounded-lg text-lg transition-all ${
                          clientEditForm.preference === type
                            ? "bg-[#C5A47E] text-black font-bold"
                            : "text-neutral-500 hover:text-white"
                        }`}
                      >
                        {type === "natural" ? "自然" : "妝感"}
                      </button>
                    ))}
                  </div>
                </div>
              </div>

              {!isGuestMode && (
                <div className="pt-6 mt-4 border-t border-neutral-700">
                  <div className="flex flex-col gap-4">
                    <div className="w-full">
                      <label className="text-lg text-[#C5A47E] block mb-2">
                        備注 Notes (只限內部查看)
                      </label>
                      <textarea
                        rows="3"
                        value={clientEditForm.notes}
                        onChange={(e) =>
                          setClientEditForm({
                            ...clientEditForm,
                            notes: e.target.value,
                          })
                        }
                        className={`w-full ${colors.inputBg} rounded-xl p-4 border border-neutral-600 text-white outline-none focus:border-[#C5A47E] resize-none text-base`}
                      />
                    </div>
                    <div>
                      <label className="text-base text-[#C5A47E] block mb-2">
                        標籤 Tag
                      </label>
                      <div className="flex gap-3">
                        <button
                          type="button"
                          onClick={() =>
                            setClientEditForm({
                              ...clientEditForm,
                              tagV: !clientEditForm.tagV,
                            })
                          }
                          className={`flex-1 h-14 rounded-xl border font-bold text-xl transition-all ${
                            clientEditForm.tagV
                              ? "bg-[#C5A47E] text-black border-[#C5A47E]"
                              : "bg-neutral-800 text-neutral-500 border-neutral-600"
                          }`}
                        >
                          V
                        </button>
                        <button
                          type="button"
                          onClick={() =>
                            setClientEditForm({
                              ...clientEditForm,
                              tagS: !clientEditForm.tagS,
                            })
                          }
                          className={`flex-1 h-14 rounded-xl border font-bold text-xl transition-all ${
                            clientEditForm.tagS
                              ? "bg-purple-500 text-white border-purple-500"
                              : "bg-neutral-800 text-neutral-500 border-neutral-600"
                          }`}
                        >
                          S
                        </button>
                      </div>
                    </div>

                    <div className="pt-4 mt-2 border-t border-neutral-700">
                      <label className="text-base text-[#C5A47E] block mb-3 font-semibold">
                        補色券 Touch-up Voucher
                      </label>
                      <div className="space-y-3">
                        <div>
                          <label className="text-sm text-neutral-400 block mb-1">
                            購買日期
                          </label>
                          <input
                            type="date"
                            value={clientEditForm.voucherPurchaseDate}
                            onChange={(e) =>
                              setClientEditForm({
                                ...clientEditForm,
                                voucherPurchaseDate: e.target.value,
                              })
                            }
                            className={`w-full ${colors.inputBg} rounded-xl p-3 border border-neutral-600 text-white outline-none focus:border-[#C5A47E] text-base`}
                          />
                        </div>
                        {clientEditForm.voucherPurchaseDate && (
                          <>
                            <button
                              type="button"
                              onClick={async () => {
                                await handleSaveClientProfile();
                                setTransForm({
                                  ...initialTransForm,
                                  client: clientEditForm.name,
                                  phone: clientEditForm.phone,
                                  customerId: clientEditForm.id || "",
                                  customerType: "old",
                                  service: "補色券",
                                  type: "全數",
                                  amount: "1380",
                                  date: clientEditForm.voucherPurchaseDate,
                                });
                                setShowClientEditModal(false);
                                setActiveTab("home");
                                setShowModal(true);
                              }}
                              className="w-full h-14 rounded-xl border font-bold text-lg transition-all flex items-center justify-center gap-2 bg-neutral-800 text-[#C5A47E] border-[#C5A47E]/50 hover:bg-[#C5A47E]/10"
                            >
                              <Banknote size={20} />
                              去財務收款（補色券）
                            </button>
                            <div className="text-sm text-neutral-500">
                              到期日：
                              {(() => {
                                const exp = getVoucherExpiryDate(
                                  clientEditForm.voucherPurchaseDate
                                );
                                return exp
                                  ? `${exp.getFullYear()}年${
                                      exp.getMonth() + 1
                                    }月${exp.getDate()}日`
                                  : "-";
                              })()}
                            </div>
                            <button
                              type="button"
                              onClick={() =>
                                setClientEditForm({
                                  ...clientEditForm,
                                  voucherUsed: !clientEditForm.voucherUsed,
                                  voucherUsedDate: !clientEditForm.voucherUsed
                                    ? getTodayDate()
                                    : "",
                                })
                              }
                              className={`w-full h-14 rounded-xl border font-bold text-lg transition-all flex items-center justify-center gap-2 ${
                                clientEditForm.voucherUsed
                                  ? "bg-green-600 text-white border-green-600"
                                  : "bg-neutral-800 text-neutral-400 border-neutral-600"
                              }`}
                            >
                              {clientEditForm.voucherUsed && (
                                <Check size={20} />
                              )}
                              {clientEditForm.voucherUsed
                                ? "已使用補色券"
                                : "標記為已使用"}
                            </button>
                            {clientEditForm.voucherUsed && (
                              <div>
                                <label className="text-sm text-neutral-400 block mb-1">
                                  使用日期
                                </label>
                                <input
                                  type="date"
                                  value={clientEditForm.voucherUsedDate}
                                  onChange={(e) =>
                                    setClientEditForm({
                                      ...clientEditForm,
                                      voucherUsedDate: e.target.value,
                                    })
                                  }
                                  className={`w-full ${colors.inputBg} rounded-xl p-3 border border-neutral-600 text-white outline-none focus:border-[#C5A47E] text-base`}
                                />
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="flex-none p-5 pt-4 bg-neutral-900 border-t border-neutral-800 flex gap-3 rounded-b-2xl">
              {!isGuestMode && (
                <button
                  onClick={() => setShowClientEditModal(false)}
                  className="flex-1 py-4 rounded-xl bg-neutral-700 text-neutral-300 hover:bg-neutral-600 transition-colors text-lg"
                >
                  取消
                </button>
              )}
              <button
                onClick={handleSaveClientProfile}
                disabled={isSubmitting}
                className="flex-[2] py-4 rounded-xl bg-[#C5A47E] text-black font-bold hover:bg-[#b08d66] transition-colors text-lg"
              >
                {isSubmitting ? (
                  <Loader2 className="animate-spin mx-auto" />
                ) : isGuestMode ? (
                  "完成提交 (Submit)"
                ) : selectedClient ? (
                  "確認更新"
                ) : (
                  "建立客戶"
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {showGuestLockScreen && (
        <div className="fixed inset-0 z-[100] bg-black flex flex-col items-center justify-center p-6 animate-fade-in">
          <div className="w-24 h-24 bg-green-500/20 text-green-400 rounded-full flex items-center justify-center mb-8">
            <Check size={48} />
          </div>
          <h2 className="text-3xl text-[#C5A47E] font-medium tracking-widest mb-4">
            資料已成功提交
          </h2>
          <p className="text-neutral-400 text-lg mb-16 text-center">
            Thank you! <br />
            請將平板電腦交還給職員
          </p>

          {!showGuestPinPad ? (
            <button
              onClick={() => setShowGuestPinPad(true)}
              className="mt-8 px-6 py-3 rounded-full bg-neutral-800 text-neutral-400 border border-neutral-700 hover:text-white hover:bg-neutral-700 transition-colors flex items-center gap-2"
            >
              <Lock size={18} /> 職員專用解鎖
            </button>
          ) : (
            <div className="w-full max-w-xs animate-fade-in">
              <p className="text-xs text-neutral-600 text-center mb-4">
                請輸入密碼
              </p>
              <div className="flex gap-4 justify-center mb-10">
                {[0, 1, 2, 3].map((i) => (
                  <div
                    key={i}
                    className={`w-4 h-4 rounded-full border border-neutral-600 transition-all duration-300 ${
                      i < guestPin.length
                        ? "bg-white border-white"
                        : "bg-transparent"
                    }`}
                  />
                ))}
              </div>
              <div className="grid grid-cols-3 gap-4">
                {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((n) => (
                  <button
                    key={n}
                    onClick={() => handleGuestPinPress(String(n))}
                    className="h-16 rounded-full bg-neutral-900 text-white text-xl font-medium active:bg-white active:text-black transition-colors"
                  >
                    {n}
                  </button>
                ))}
                <div className="h-16" />
                <button
                  onClick={() => handleGuestPinPress("0")}
                  className="h-16 rounded-full bg-neutral-900 text-white text-xl font-medium active:bg-white active:text-black transition-colors"
                >
                  0
                </button>
                <button
                  onClick={() => handleGuestPinPress("del")}
                  className="h-16 rounded-full flex items-center justify-center text-neutral-500 active:text-white"
                >
                  <ChevronLeft size={24} />
                </button>
              </div>
              <button
                onClick={() => {
                  setShowGuestPinPad(false);
                  setGuestPin("");
                }}
                className="mt-8 text-neutral-500 text-sm w-full text-center hover:text-white"
              >
                返回
              </button>
            </div>
          )}
        </div>
      )}

      {showConsentModal && (
        <div className="fixed inset-0 z-[60] flex flex-col bg-neutral-900 animate-fade-in overflow-hidden">
          {viewConsentData ? (
            <>
              <div className="flex-none px-4 py-3 border-b border-neutral-800 flex justify-between items-center bg-neutral-900 z-50">
                <h2 className={`${colors.white} text-lg`}>同意書預覽</h2>
                <div className="flex gap-3">
                  <button
                    onClick={handleDownloadImage}
                    className="p-2 bg-[#C5A47E] rounded-full text-black hover:bg-[#b08d66] transition-colors"
                    title="下載圖片"
                  >
                    <Download size={20} />
                  </button>
                  <button
                    onClick={() => setShowConsentModal(false)}
                    className="p-2 bg-neutral-800 rounded-full text-neutral-400"
                  >
                    <X size={20} />
                  </button>
                </div>
              </div>
              <div className="flex-1 overflow-y-auto custom-scrollbar bg-neutral-800 relative">
                <div
                  ref={consentFormRef}
                  className="bg-white text-black w-full min-h-full p-6 md:p-10 shadow-none mt-2"
                  style={{ minHeight: "100%" }}
                >
                  <div className="mb-6 border-b-2 border-black pb-6">
                    <h1 className="text-2xl md:text-3xl font-bold text-center mb-6 tracking-widest">
                      Eyebrows Art 半永久定妝
                    </h1>
                    <div className="space-y-3 text-sm md:text-base">
                      {[
                        {
                          label: "顧客姓名 (Name):",
                          value: viewConsentData.name,
                        },
                        {
                          label: "聯絡電話 (Phone):",
                          value: viewConsentData.phone,
                        },
                        {
                          label: "服務項目 (Service):",
                          value: `${
                            viewConsentData.selectedServices?.join(" / ") ||
                            "未選擇"
                          }${
                            viewConsentData.otherServiceRemark
                              ? ` (${viewConsentData.otherServiceRemark})`
                              : ""
                          }`,
                        },
                        { label: "日期 (Date):", value: viewConsentData.date },
                      ].map(({ label, value }) => (
                        <div
                          key={label}
                          className="flex flex-col md:flex-row md:items-end gap-1 md:gap-2"
                        >
                          <span className="font-bold text-gray-700 min-w-[140px]">
                            {label}
                          </span>
                          <span className="text-lg font-medium flex-1">
                            {value}
                          </span>
                        </div>
                      ))}
                      <div className="flex flex-col md:flex-row md:items-start gap-1 md:gap-2 pt-2">
                        <span className="font-bold text-gray-700 min-w-[140px]">
                          健康申報 (Medical):
                        </span>
                        <span className="text-lg font-medium flex-1">
                          {viewConsentData.medicalConditions?.length > 0
                            ? viewConsentData.medicalConditions.join(" / ")
                            : "無 / 未記錄"}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="text-sm md:text-base space-y-2 whitespace-pre-wrap leading-relaxed font-medium text-justify">
                    {CONSENT_TERMS}
                  </div>
                  <div className="mt-8 pt-4 border-t border-dashed border-gray-400">
                    <p className="text-sm font-bold mb-2 text-gray-600">
                      顧客簽署 (Signature):
                    </p>
                    <div className="w-full h-40 md:h-48 flex items-center justify-center border border-gray-200 rounded-lg bg-gray-50 overflow-hidden">
                      <img
                        src={viewConsentData.signature}
                        alt="Signature"
                        className="max-h-full max-w-full object-contain"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="flex-none px-6 py-5 border-b border-neutral-800 flex justify-between items-center bg-neutral-900">
                <h2 className={`${colors.white} text-2xl font-medium`}>
                  簽署同意書 ({consentStep}/4)
                </h2>
                <button
                  onClick={() => setShowConsentModal(false)}
                  className="p-3 bg-neutral-800 rounded-full text-neutral-400"
                >
                  <X size={28} />
                </button>
              </div>

              <div className="flex-1 overflow-y-auto p-6 md:p-10 custom-scrollbar flex flex-col">
                {consentStep === 1 && (
                  <div className="space-y-8 animate-fade-in max-w-2xl mx-auto w-full">
                    <h3 className="text-3xl font-bold mb-8 text-center text-[#C5A47E]">
                      1. 基本資料確認
                    </h3>
                    {[
                      { label: "姓名 Name", field: "name", type: "text" },
                      { label: "電話 Phone", field: "phone", type: "text" },
                    ].map(({ label, field, type }) => (
                      <div key={field}>
                        <label className="text-xl text-neutral-300 block mb-3">
                          {label}
                        </label>
                        <input
                          type={type}
                          value={consentForm[field]}
                          onChange={(e) =>
                            setConsentForm({
                              ...consentForm,
                              [field]: e.target.value,
                            })
                          }
                          autoComplete="off"
                          autoCorrect="off"
                          spellCheck="false"
                          className={`w-full ${colors.inputBg} rounded-xl p-5 border-2 border-neutral-600 text-white text-2xl`}
                        />
                      </div>
                    ))}
                    <div className="flex gap-6">
                      {[
                        {
                          label: "生日月 Month",
                          field: "dobMonth",
                          placeholder: "MM",
                        },
                        { label: "日 Day", field: "dobDay", placeholder: "DD" },
                      ].map(({ label, field, placeholder }) => (
                        <div key={field} className="flex-1">
                          <label className="text-xl text-neutral-300 block mb-3">
                            {label}
                          </label>
                          <input
                            type="number"
                            placeholder={placeholder}
                            value={consentForm[field]}
                            onChange={(e) =>
                              setConsentForm({
                                ...consentForm,
                                [field]: e.target.value,
                              })
                            }
                            autoComplete="off"
                            className={`w-full ${colors.inputBg} rounded-xl p-5 border-2 border-neutral-600 text-white text-2xl text-center`}
                          />
                        </div>
                      ))}
                    </div>
                    <div>
                      <label className="text-xl text-neutral-300 block mb-3">
                        電郵 Email
                      </label>
                      <input
                        type="text"
                        value={consentForm.email}
                        onChange={(e) =>
                          setConsentForm({
                            ...consentForm,
                            email: e.target.value,
                          })
                        }
                        autoComplete="nope"
                        autoCorrect="off"
                        spellCheck="false"
                        className={`w-full ${colors.inputBg} rounded-xl p-5 border-2 border-neutral-600 text-white text-2xl`}
                      />
                      <div className="flex gap-4 mt-4 flex-wrap">
                        {["@gmail.com", "@yahoo.com.hk", "@hotmail.com"].map(
                          (domain) => (
                            <button
                              key={domain}
                              type="button"
                              onClick={() =>
                                setConsentForm((prev) => ({
                                  ...prev,
                                  email: (prev.email || "") + domain,
                                }))
                              }
                              className="px-5 py-4 rounded-xl bg-neutral-800 border border-neutral-600 text-lg text-neutral-300 hover:text-white hover:border-[#C5A47E] transition-colors"
                            >
                              {domain}
                            </button>
                          )
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {consentStep === 2 && (
                  <div className="space-y-6 animate-fade-in max-w-3xl mx-auto w-full">
                    <h3 className="text-3xl font-bold mb-4 text-center text-[#C5A47E]">
                      2. 選擇服務項目
                    </h3>
                    <p className="text-neutral-300 text-2xl mb-8 text-center">
                      請問今次進行什麼服務？ (可多選)
                    </p>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      {[
                        "眉毛半永久定妝",
                        "眼線半永久定妝",
                        "唇部半永久定妝",
                        "激光洗眉",
                        "熱能氣化",
                        "角蛋白美睫",
                        "其他請註明",
                      ].map((s) => (
                        <button
                          key={s}
                          onClick={() => toggleService(s)}
                          className={`p-6 rounded-xl border-2 text-xl font-medium transition-all text-left flex items-center ${
                            consentForm.selectedServices.includes(s)
                              ? "bg-[#C5A47E] text-black border-[#C5A47E] font-bold shadow-[0_0_20px_rgba(197,164,126,0.4)]"
                              : "bg-neutral-800/80 text-neutral-300 border-neutral-600 hover:bg-neutral-700"
                          }`}
                        >
                          <span
                            className={`w-6 h-6 rounded-full border-2 mr-4 flex items-center justify-center flex-none ${
                              consentForm.selectedServices.includes(s)
                                ? "border-black bg-black/20"
                                : "border-neutral-500"
                            }`}
                          >
                            {consentForm.selectedServices.includes(s) && (
                              <Check size={16} className="text-black" />
                            )}
                          </span>
                          {s}
                        </button>
                      ))}
                    </div>
                    {consentForm.selectedServices.includes("其他請註明") && (
                      <div className="animate-fade-in mt-6 p-6 bg-neutral-800 rounded-xl border border-neutral-600">
                        <label className="text-[#C5A47E] text-lg block mb-3">
                          請註明其他服務內容：
                        </label>
                        <input
                          type="text"
                          value={consentForm.otherServiceRemark}
                          onChange={(e) =>
                            setConsentForm({
                              ...consentForm,
                              otherServiceRemark: e.target.value,
                            })
                          }
                          placeholder="例如：補色、除色..."
                          className="w-full bg-neutral-900 border-2 border-neutral-700 rounded-xl p-4 text-xl text-white outline-none focus:border-[#C5A47E]"
                        />
                      </div>
                    )}
                  </div>
                )}

                {consentStep === 3 && (
                  <div className="space-y-6 animate-fade-in max-w-3xl mx-auto w-full">
                    <h3 className="text-3xl font-bold mb-4 text-center text-[#C5A47E]">
                      3. 健康狀況申報
                    </h3>
                    <p className="text-neutral-300 text-2xl mb-8 text-center">
                      請問閣下是否有以下症狀？ (可多選)
                    </p>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      {[
                        "心臟病 / 高血壓",
                        "糖尿病",
                        "懷孕 / 正在哺乳",
                        "蟹足腫 / 疤痕體質",
                        "傳染性疾病 (如乙肝/愛滋)",
                        "藥物 / 麻藥 / 金屬敏感",
                        "近期曾做醫美 (Botox/激光)",
                        "面部皮膚病 (濕疹/疱疹)",
                        "正服用薄血藥 / 酸類保養",
                        "其他懷疑不適合原因",
                      ].map((c) => (
                        <button
                          key={c}
                          onClick={() => toggleMedical(c)}
                          className={`p-5 rounded-xl border-2 text-xl font-medium transition-all text-left flex items-center ${
                            consentForm.medicalConditions.includes(c)
                              ? "bg-[#C5A47E] text-black border-[#C5A47E] font-bold shadow-[0_0_20px_rgba(197,164,126,0.4)]"
                              : "bg-neutral-800/80 text-neutral-300 border-neutral-600 hover:bg-neutral-700"
                          }`}
                        >
                          <span
                            className={`w-6 h-6 rounded-full border-2 mr-4 flex items-center justify-center flex-none ${
                              consentForm.medicalConditions.includes(c)
                                ? "border-black bg-black/20"
                                : "border-neutral-500"
                            }`}
                          >
                            {consentForm.medicalConditions.includes(c) && (
                              <Check size={16} className="text-black" />
                            )}
                          </span>
                          {c}
                        </button>
                      ))}
                    </div>
                    <button
                      onClick={() => toggleMedical("以上症狀皆沒有")}
                      className={`w-full p-6 rounded-xl border-2 text-2xl mt-8 transition-all flex justify-center items-center gap-3 ${
                        consentForm.medicalConditions.includes("以上症狀皆沒有")
                          ? "bg-[#C5A47E] text-black border-[#C5A47E] font-bold shadow-[0_0_20px_rgba(197,164,126,0.4)]"
                          : "bg-neutral-800 text-neutral-400 border-neutral-600 hover:text-white"
                      }`}
                    >
                      {consentForm.medicalConditions.includes(
                        "以上症狀皆沒有"
                      ) && <Check size={32} />}
                      以上症狀皆沒有 (確認)
                    </button>
                  </div>
                )}

                {consentStep === 4 && (
                  <div className="flex-1 flex flex-col h-full animate-fade-in overflow-hidden max-w-4xl mx-auto w-full">
                    <h3 className="text-3xl font-bold mb-6 flex-none text-center text-[#C5A47E]">
                      4. 條款及簽署
                    </h3>
                    {!consentForm.agreed && (
                      <div className="flex-1 bg-neutral-800 rounded-xl p-6 border-2 border-neutral-700 overflow-y-auto mb-6 custom-scrollbar">
                        <div className="text-xl text-white leading-loose whitespace-pre-wrap font-medium">
                          {CONSENT_TERMS}
                        </div>
                      </div>
                    )}
                    <div
                      onClick={() =>
                        setConsentForm({
                          ...consentForm,
                          agreed: !consentForm.agreed,
                        })
                      }
                      className={`flex-none flex items-center justify-center gap-4 p-6 rounded-xl border-2 cursor-pointer transition-all duration-300 mb-6 ${
                        consentForm.agreed
                          ? "bg-[#C5A47E] border-[#C5A47E] text-black"
                          : "bg-neutral-800 border-neutral-600 text-neutral-300"
                      }`}
                    >
                      <div
                        className={`w-8 h-8 rounded border-2 flex items-center justify-center flex-shrink-0 ${
                          consentForm.agreed
                            ? "border-black"
                            : "border-neutral-500"
                        }`}
                      >
                        {consentForm.agreed && (
                          <Check size={24} className="text-black" />
                        )}
                      </div>
                      <span className="text-2xl font-bold">
                        本人已閱讀並同意上述條款 (點擊剔選)
                      </span>
                    </div>
                    {consentForm.agreed && (
                      <div className="flex-1 flex flex-col animate-slide-up">
                        <div className="flex justify-between items-end mb-3 px-2">
                          <p className="text-[#C5A47E] text-xl font-bold">
                            請在下方空白處簽名：
                          </p>
                          <button
                            onClick={clearSignature}
                            className="text-lg text-neutral-400 underline hover:text-white"
                          >
                            清除重簽
                          </button>
                        </div>
                        <div className="flex-1 bg-white rounded-xl overflow-hidden touch-none relative border-4 border-dashed border-[#C5A47E] shadow-inner">
                          <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none">
                            <span className="text-8xl font-light text-gray-200 tracking-widest">
                              簽署
                            </span>
                          </div>
                          <canvas
                            ref={canvasRef}
                            onTouchStart={startDrawing}
                            onTouchMove={draw}
                            onTouchEnd={endDrawing}
                            onMouseDown={startDrawing}
                            onMouseMove={draw}
                            onMouseUp={endDrawing}
                            className="w-full h-full cursor-crosshair relative z-10"
                            width={
                              window.innerWidth > 800
                                ? 800
                                : window.innerWidth - 48
                            }
                            height={400}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>

              <div className="flex-none p-6 bg-neutral-900 border-t border-neutral-800 flex gap-4 max-w-4xl mx-auto w-full">
                {consentStep > 1 && (
                  <button
                    onClick={() => setConsentStep(consentStep - 1)}
                    className="flex-1 py-5 bg-neutral-800 text-neutral-300 rounded-xl font-bold border border-neutral-700 text-2xl hover:bg-neutral-700 transition-colors"
                  >
                    上一步
                  </button>
                )}
                {consentStep < 4 ? (
                  <button
                    onClick={() => setConsentStep(consentStep + 1)}
                    disabled={!checkStepValidity()}
                    className={`flex-[2] py-5 rounded-xl flex items-center justify-center gap-2 text-2xl font-bold transition-all ${
                      checkStepValidity()
                        ? "bg-[#C5A47E] text-black shadow-lg"
                        : "bg-neutral-800 text-neutral-500 cursor-not-allowed border border-neutral-700"
                    }`}
                  >
                    下一步 <ArrowRight size={28} />
                  </button>
                ) : (
                  <button
                    onClick={saveConsent}
                    disabled={isSubmitting || !consentForm.agreed}
                    className={`flex-[2] py-5 rounded-xl font-bold text-2xl shadow-lg transition-all ${
                      isSubmitting || !consentForm.agreed
                        ? "bg-neutral-800 text-neutral-500 cursor-not-allowed"
                        : "bg-[#C5A47E] text-black"
                    }`}
                  >
                    {isSubmitting ? "儲存中..." : "確認簽署"}
                  </button>
                )}
              </div>
            </>
          )}
        </div>
      )}
      <ToastContainer />
      <DialogContainer />
    </div>
  );
};

export default EyebrowsArtApp;
